define(["lodash","coreUtilsLib","imageClientLib"], function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_7__) { return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);

function CompsMigrationHelper(compsMigrationMap) {
    this.migrationMap = compsMigrationMap;
}

CompsMigrationHelper.prototype.getComponentData = function (pageJson, comp) {
    return comp.dataQuery && pageJson.data.document_data[comp.dataQuery.replace('#', '')];
};

CompsMigrationHelper.prototype.setComponentData = function (pageJson, comp, dataItem, cache) {
    var newId = comp.dataQuery || _.get(cache, [comp.id, 'dataQuery']) || coreUtils.guidUtils.getUniqueId('dataItem', '-');
    newId = newId.replace('#', '');
    comp.dataQuery = '#' + newId;
    dataItem.id = newId;
    pageJson.data.document_data[newId] = dataItem;
    _.set(cache, [comp.id, 'dataQuery'], newId);
};

CompsMigrationHelper.prototype.deleteComponentData = function (pageJson, comp) {
    var dataQuery = comp.dataQuery && comp.dataQuery.replace('#', '');
    if (dataQuery && pageJson.data.document_data[dataQuery]) {
        delete pageJson.data.document_data[dataQuery];
    }
};

CompsMigrationHelper.prototype.getComponentDesignData = function (pageJson, comp) {
    return comp.designQuery && pageJson.data.design_data[comp.designQuery.replace('#', '')];
};

CompsMigrationHelper.prototype.deleteComponentDesignData = function (pageJson, comp) {
    var designQuery = comp.designQuery && comp.designQuery.replace('#', '');
    if (designQuery && pageJson.data.design_data[designQuery]) {
        delete pageJson.data.design_data[designQuery];
    }
};

CompsMigrationHelper.prototype.getComponentProperties = function (pageJson, comp) {
    return comp.propertyQuery && pageJson.data.component_properties[comp.propertyQuery.replace('#', '')];
};
CompsMigrationHelper.prototype.deleteComponentProperties = function (pageJson, comp) {
    var propertyQuery = comp.propertyQuery && comp.propertyQuery.replace('#', '');
    if (propertyQuery && pageJson.data.component_properties[propertyQuery]) {
        delete pageJson.data.component_properties[propertyQuery];
    }
    if (comp.propertyQuery) {
        delete comp.propertyQuery;
    }
};

CompsMigrationHelper.prototype.setComponentDesignData = function (pageJson, comp, designDataItem, cache) {
    var newId = comp.designQuery || _.get(cache, [comp.id, 'designQuery']) || coreUtils.guidUtils.getUniqueId('dataItem', '-');
    newId = newId.replace('#', '');
    comp.designQuery = '#' + newId;
    designDataItem.id = newId;
    if (_.isObject(designDataItem.background)) {
        var bg = _.clone(designDataItem.background);
        bg.id = (bg.id || coreUtils.guidUtils.getUniqueId('dataItem', '-')).replace('#', '');
        designDataItem.background = '#' + bg.id;
        pageJson.data.design_data[bg.id] = bg;
    }
    pageJson.data.design_data[newId] = designDataItem;
    _.set(cache, [comp.id, 'designQuery'], comp.designQuery);
};

CompsMigrationHelper.prototype.setComponentProperties = function (pageJson, comp, properties, cache) {
    var newId = comp.propertyQuery || _.get(cache, [comp.id, 'propertyQuery']) || coreUtils.guidUtils.getUniqueId('propItem', '-');
    newId = newId.replace('#', '');
    comp.propertyQuery = newId;
    properties.id = newId;
    pageJson.data.component_properties[newId] = properties;
    _.set(cache, [comp.id, 'propertyQuery'], newId);
};

CompsMigrationHelper.prototype.migrateComps = function (pageJson, cache, mobileView, comps) {
    var _this = this;

    _.forEach(comps, function (comp) {
        if (_this.migrationMap[comp.componentType]) {
            _this.migrationMap[comp.componentType].call(_this, pageJson, cache, mobileView, comp);
        }
        _this.migrateComps(pageJson, cache, mobileView, comp.components);
    });
};

CompsMigrationHelper.prototype.migratePage = function (pageJson) {
    var structureData = pageJson.structure;
    if (structureData) {
        var cache = {};

        var desktopComps = structureData.components || structureData.children;
        var mobileComps = structureData.mobileComponents;

        if (desktopComps) {
            this.migrateComps(pageJson, cache, false, desktopComps);
        }
        if (mobileComps) {
            this.migrateComps(pageJson, cache, true, mobileComps);
        }
    }
};

module.exports = CompsMigrationHelper;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var imageClientApi = __webpack_require__(7);
var fittingTypes = imageClientApi.fittingTypes;
var alignTypes = imageClientApi.alignTypes;

var tilingMap = {
    'repeat-x': fittingTypes.TILE_HORIZONTAL,
    'repeat no_repeat': fittingTypes.TILE_HORIZONTAL,
    'repeat no-repeat': fittingTypes.TILE_HORIZONTAL,
    'repeat-y': fittingTypes.TILE_VERTICAL,
    'no_repeat repeat': fittingTypes.TILE_VERTICAL,
    'no-repeat repeat': fittingTypes.TILE_VERTICAL,
    repeat: fittingTypes.TILE,
    'repeat repeat': fittingTypes.TILE,
    // Default (keep empty)
    '': ''
};

Object.freeze(tilingMap);

var fittingTypeMap = {
    'auto': function auto(tile) {
        return tile ? tile : fittingTypes.LEGACY_ORIGINAL_SIZE;
    },
    'cover': function cover() {
        return fittingTypes.SCALE_TO_FILL;
    },
    'contain': function contain(tile) {
        return tile ? fittingTypes.FIT_AND_TILE : fittingTypes.SCALE_TO_FIT;
    },

    // Default
    '': function _() {
        return fittingTypes.SCALE_TO_FILL;
    }
};

Object.freeze(fittingTypeMap);

var alignTypeMap = {
    'center center': alignTypes.CENTER,
    center: alignTypes.CENTER,
    '50% 50%': alignTypes.CENTER,

    'top center': alignTypes.TOP,
    'center top': alignTypes.TOP,
    '50% 0%': alignTypes.TOP,

    'bottom center': alignTypes.BOTTOM,
    'center bottom': alignTypes.BOTTOM,
    '50% 100%': alignTypes.BOTTOM,

    'center right': alignTypes.RIGHT,
    'right center': alignTypes.RIGHT,
    '100% 50%': alignTypes.RIGHT,

    'center left': alignTypes.LEFT,
    'left center': alignTypes.LEFT,
    '0% 50%': alignTypes.LEFT,

    'left top': alignTypes.TOP_LEFT,
    'top left': alignTypes.TOP_LEFT,
    '0% 0%': alignTypes.TOP_LEFT,

    'right top': alignTypes.TOP_RIGHT,
    'top right': alignTypes.TOP_RIGHT,
    '100% 0%': alignTypes.TOP_RIGHT,

    'left bottom': alignTypes.BOTTOM_LEFT,
    'bottom left': alignTypes.BOTTOM_LEFT,
    '0% 100%': alignTypes.BOTTOM_LEFT,

    'right bottom': alignTypes.BOTTOM_RIGHT,
    'bottom right': alignTypes.BOTTOM_RIGHT,
    '100% 100%': alignTypes.BOTTOM_RIGHT,

    // Default
    '': alignTypes.CENTER
};

Object.freeze(alignTypeMap);

var fittingToRepeatMap = function () {
    var map = {};
    map[fittingTypes.LEGACY_STRIP_TILE_HORIZONTAL] = 'repeat-x';
    map[fittingTypes.TILE_HORIZONTAL] = 'repeat-x';
    map[fittingTypes.LEGACY_STRIP_TILE_VERTICAL] = 'repeat-y';
    map[fittingTypes.TILE_VERTICAL] = 'repeat-y';
    map[fittingTypes.LEGACY_STRIP_TILE] = 'repeat';
    map[fittingTypes.TILE] = 'repeat';
    map[fittingTypes.FIT_AND_TILE] = 'repeat';

    // Default
    map[''] = 'no-repeat';
    return map;
}();

Object.freeze(fittingToRepeatMap);

var fittingToBgMap = function () {
    var map = {};
    map[fittingTypes.LEGACY_ORIGINAL_SIZE] = 'auto';
    map[fittingTypes.LEGACY_STRIP_ORIGINAL_SIZE] = 'auto';
    map[fittingTypes.SCALE_TO_FILL] = 'cover';
    map[fittingTypes.LEGACY_STRIP_SCALE_TO_FILL] = 'cover';
    map[fittingTypes.SCALE_TO_FIT] = 'contain';
    map[fittingTypes.LEGACY_STRIP_SCALE_TO_FIT] = 'contain';
    map[fittingTypes.FIT_AND_TILE] = 'contain';
    map[fittingTypes.LEGACY_STRIP_FIT_AND_TILE] = 'contain';

    // Default
    map[''] = 'auto';
    return map;
}();

Object.freeze(fittingToBgMap);

var alignToPositionMap = function () {
    var map = {};
    map[alignTypes.TOP] = 'center top';
    map[alignTypes.CENTER] = 'center';
    map[alignTypes.BOTTOM] = 'center bottom';

    map[alignTypes.TOP_LEFT] = 'left top';
    map[alignTypes.LEFT] = 'left center';
    map[alignTypes.BOTTOM_LEFT] = 'left bottom';

    map[alignTypes.TOP_RIGHT] = 'right top';
    map[alignTypes.RIGHT] = 'right center';
    map[alignTypes.BOTTOM_RIGHT] = 'right bottom';

    // Default
    map[''] = 'center';
    return map;
}();

Object.freeze(alignToPositionMap);

/**
 * sometime css values are saved with spaces. here we are cleaning and making sure all values are lower case.
 * @param {string} value
 * @returns {string}
 */
function cleanupDataStrings(value) {
    return (value || '').toLowerCase().trim();
}

function cssToFittingType(cssValues) {
    var bgRepeat = cleanupDataStrings(cssValues.bgRepeat);
    var bgSize = cleanupDataStrings(cssValues.bgSize);

    var tile = tilingMap[bgRepeat];
    return fittingTypeMap[bgSize] && fittingTypeMap[bgSize](tile);
}

function cssToAlignType(cssValues) {
    cssValues = cleanupDataStrings(cssValues);
    return alignTypeMap[cssValues];
}

function fittingTypeToBgRepeat(fittingType) {
    return fittingToRepeatMap[fittingType] || fittingToRepeatMap[''];
}

function fittingTypeToBgSize(fittingType) {
    return fittingToBgMap[fittingType] || fittingToBgMap[''];
}

function alignTypeToBgPosition(alignType) {
    return alignToPositionMap[alignType] || alignToPositionMap[''];
}

function migrateToLegacyFittings(fittingType) {
    if (fittingType === fittingTypes.TILE) {
        return fittingTypes.LEGACY_STRIP_TILE;
    } else if (fittingType === fittingTypes.TILE_HORIZONTAL) {
        return fittingTypes.LEGACY_STRIP_TILE_HORIZONTAL;
    } else if (fittingType === fittingTypes.TILE_VERTICAL) {
        return fittingTypes.LEGACY_STRIP_TILE_VERTICAL;
    } else if (fittingType === fittingTypes.SCALE_TO_FILL) {
        return fittingTypes.LEGACY_STRIP_SCALE_TO_FILL;
    } else if (fittingType === fittingTypes.SCALE_TO_FIT) {
        return fittingTypes.LEGACY_STRIP_SCALE_TO_FIT;
    } else if (fittingType === fittingTypes.FIT_AND_TILE) {
        return fittingTypes.LEGACY_STRIP_FIT_AND_TILE;
    } else if (fittingType === fittingTypes.LEGACY_ORIGINAL_SIZE) {
        return fittingTypes.LEGACY_STRIP_ORIGINAL_SIZE;
    }

    return fittingType;
}

module.exports = {
    cssToFittingType: cssToFittingType,
    cssToAlignType: cssToAlignType,
    fittingTypeToBgRepeat: fittingTypeToBgRepeat,
    fittingTypeToBgSize: fittingTypeToBgSize,
    alignTypeToBgPosition: alignTypeToBgPosition,
    migrateToLegacyFittings: migrateToLegacyFittings
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
// const loggingUtils = require('loggingUtils')
var coreUtils = __webpack_require__(1);
var galleriesMobileTypeFixer = __webpack_require__(9);
var pageTopFixer = __webpack_require__(11);
var masterPageFixer = __webpack_require__(12);
var customSiteMenuFixer = __webpack_require__(14);
var multipleMenusFixer = __webpack_require__(16);
var skinFixer = __webpack_require__(17);
var stylesFixer = __webpack_require__(18);
var bgImageStripDataFixer = __webpack_require__(19);
var compFixer = __webpack_require__(20);
var galleryFixer = __webpack_require__(21);
var behaviorsFixer = __webpack_require__(22);
var connectionsDataFixer = __webpack_require__(24);
var fiveGridLineLayoutFixer = __webpack_require__(25);
var toPageAnchorsFixer = __webpack_require__(26);
var wrongAnchorsFixer = __webpack_require__(27);
var addMissingAnchorsOfMasterPage = __webpack_require__(28);
var sitePagesFixer = __webpack_require__(29);
var linkRefDataFixer = __webpack_require__(30);
var fromDocumentToThemeData = __webpack_require__(31);
var tpaGluedWidgetDataFixer = __webpack_require__(32);
var tpaAddChatAppDataFixer = __webpack_require__(33);
var tpaProGalleryBackgroundDataFixer = __webpack_require__(34);
var compsWithImagesDataFixer = __webpack_require__(35);
var appPartCustomizationsFixer = __webpack_require__(36);
var backgroundMediaConverter = __webpack_require__(37);
var backgroundMediaUndefinedFixer = __webpack_require__(38);
var backgroundMediaRefDuplicationFixer = __webpack_require__(39);
var stripContainerBgEffectFixer = __webpack_require__(40);
var documentMediaFixer = __webpack_require__(41);
var pinterestFollowFixer = __webpack_require__(42);
var blogPageMenuFixer = __webpack_require__(43);
var appPartMediaInnerCustomizationFormatFixer = __webpack_require__(44);
var appPartReadMoreValueCustomizationFormatFixer = __webpack_require__(45);
var appPartTagsValueCustomizationFormatFixer = __webpack_require__(46);
var appPartDuplicateCustomizationFixer = __webpack_require__(47);
var blogCustomFeedPostsPerPageCustomizationFixer = __webpack_require__(48);
var blogDateAndAuthorHiddenCustomizationFixer = __webpack_require__(49);
var blogDateAlignmentCustomizationFixer = __webpack_require__(50);
var appPartBrokenButtonStyleFixer = __webpack_require__(51);
var blogDateFormatCustomizationFormatFixer = __webpack_require__(52);
var contactFormMigrationDataFixer = __webpack_require__(53);
var pageDataFixer = __webpack_require__(54);
var groupFixer = __webpack_require__(55);
var textSecurityFixer = __webpack_require__(56);
var pageUriSeoFixer = __webpack_require__(57);
var migrateStripToColumnsContainer = __webpack_require__(58);
var tinyMenuSkinBackgroundFixer = __webpack_require__(59);
var tinyMenuLayoutFixer = __webpack_require__(60);
var designDataFixer = __webpack_require__(61);
var homePageLoginDataFixer = __webpack_require__(62);
var characterSetsFixer = __webpack_require__(63);
var popupPropsTempDataFixer = __webpack_require__(64);
var blogSelectionSharerCustomizationsFixer = __webpack_require__(65);
var quickActionBarDataFixer = __webpack_require__(66);
var appPartMobileFeedMediaDateHiddenFixer = __webpack_require__(67);
var originalImageDataRefFixer = __webpack_require__(68);
var tpaWixForumDataFixer = __webpack_require__(69);
var filterEffectPropertyFixer = __webpack_require__(70);
var tinyMenuSkinFixer = __webpack_require__(71);
var svgShapeToVectorImageFixer = __webpack_require__(72);
var artAndShapeToVectorImageFixer = __webpack_require__(73);
var migrateIframesToSemiNativeComponents = __webpack_require__(74);
var migrateGridDataSource = __webpack_require__(75);
var unforkDesignData = __webpack_require__(76);
var stripColumnsContainerNoDesignFixer = __webpack_require__(77);

var plugins = _.compact([galleriesMobileTypeFixer, masterPageFixer, backgroundMediaConverter, backgroundMediaUndefinedFixer, backgroundMediaRefDuplicationFixer, pageDataFixer, customSiteMenuFixer, multipleMenusFixer, skinFixer, stylesFixer, bgImageStripDataFixer, compFixer, galleryFixer, behaviorsFixer, connectionsDataFixer, quickActionBarDataFixer, fiveGridLineLayoutFixer, toPageAnchorsFixer, wrongAnchorsFixer, addMissingAnchorsOfMasterPage, sitePagesFixer, linkRefDataFixer, fromDocumentToThemeData, pageTopFixer, tpaGluedWidgetDataFixer, tpaAddChatAppDataFixer, tpaProGalleryBackgroundDataFixer, compsWithImagesDataFixer, appPartCustomizationsFixer, designDataFixer, stripContainerBgEffectFixer, documentMediaFixer, pinterestFollowFixer, blogPageMenuFixer, appPartMediaInnerCustomizationFormatFixer, appPartReadMoreValueCustomizationFormatFixer, appPartTagsValueCustomizationFormatFixer, blogCustomFeedPostsPerPageCustomizationFixer, blogDateAndAuthorHiddenCustomizationFixer, blogDateAlignmentCustomizationFixer, appPartDuplicateCustomizationFixer, appPartBrokenButtonStyleFixer, blogDateFormatCustomizationFormatFixer, contactFormMigrationDataFixer, pageDataFixer, groupFixer, textSecurityFixer, pageUriSeoFixer, migrateStripToColumnsContainer, tinyMenuSkinBackgroundFixer, tinyMenuLayoutFixer, homePageLoginDataFixer, popupPropsTempDataFixer, characterSetsFixer, blogSelectionSharerCustomizationsFixer, appPartMobileFeedMediaDateHiddenFixer, originalImageDataRefFixer, tpaWixForumDataFixer, filterEffectPropertyFixer, tinyMenuSkinFixer, svgShapeToVectorImageFixer, artAndShapeToVectorImageFixer, migrateIframesToSemiNativeComponents, migrateGridDataSource, unforkDesignData, stripColumnsContainerNoDesignFixer]);

Object.freeze(plugins);

var specs = ['merge_clipart_and_image', 'sv_contactFormTemplatesMigration', 'sv_contactFormFinalMigration', 'sv_fixedMobileHeader', 'sv_migrateTpaToSemiNative', 'se_vector_image', 'se_proGalleryBGDataFixer', 'sv_tpaAddPublicAPI', 'sv_tpaSectionsMobileFSDataFixer'];

module.exports = function fixPageData(_ref) {
    var pageJson = _ref.pageJson,
        urlFormatModel = _ref.urlFormatModel,
        isViewerMode = _ref.isViewerMode,
        clientSpecMap = _ref.clientSpecMap,
        quickActionsMenuEnabled = _ref.quickActionsMenuEnabled,
        experiments = _ref.experiments,
        pageIdsArray = _ref.pageIdsArray;

    var magicObject = {};
    magicObject.isSlash = _.matchesProperty('format', coreUtils.siteConstants.URL_FORMATS.SLASH)(urlFormatModel);
    magicObject.pageIdToResolvedUriSEO = _.get(urlFormatModel, 'pageIdToResolvedUriSEO', {});
    magicObject.clientSpecMap = clientSpecMap;
    magicObject.quickActionsMenuEnabled = quickActionsMenuEnabled;
    magicObject.isExperimentOpen = function (spec) {
        return _.includes(_.intersection(specs, experiments), spec);
    };
    magicObject.isViewerMode = isViewerMode;
    var data = pageJson.data || {};
    data.document_data = data.document_data || {};
    data.theme_data = data.theme_data || {};
    data.component_properties = data.component_properties || {};
    data.mobile_hints = data.mobile_hints || {};
    pageJson.data = data;
    _.forEach(plugins, function (plugin) {
        plugin.exec(pageJson, pageIdsArray, null, null, null, null, null, magicObject);
    });
    return pageJson;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var coreUtils = __webpack_require__(1);

function createBehaviorsDataItem(behaviors) {
    var dataItem = {
        id: coreUtils.guidUtils.getUniqueId('behavior', '-'),
        type: 'ObsoleteBehaviorsList',
        items: behaviors
    };
    return dataItem;
}

module.exports = {
    createBehaviorsDataItem: createBehaviorsDataItem
};

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var ANCHOR_TYPES = {
    BOTTOM_BOTTOM: 'BOTTOM_BOTTOM',
    BOTTOM_TOP: 'BOTTOM_TOP'
};

function getCompBottom(comp) {
    return comp && comp.layout && comp.layout.y + comp.layout.height;
}

function getCompAnchors(comp) {
    return comp.layout && comp.layout.anchors || [];
}

function isPushingDownComponentThatsAbove(anchor, fromComp, toComp) {
    var anchorBottom = void 0;
    switch (anchor.type) {
        case ANCHOR_TYPES.BOTTOM_BOTTOM:
            anchorBottom = getCompBottom(toComp);
            break;
        case ANCHOR_TYPES.BOTTOM_TOP:
            anchorBottom = _.get(toComp, 'layout.y');
            break;
        default:
            return false;
    }

    if (_.isUndefined(anchorBottom)) {
        return false;
    }

    return anchorBottom - getCompBottom(fromComp) < 0;
}

function isBottomBottomOrBottomTopAnchor(anchor) {
    return anchor.type === ANCHOR_TYPES.BOTTOM_BOTTOM || anchor.type === ANCHOR_TYPES.BOTTOM_TOP;
}

function doesBTBBCycleExist(cycleCandidateComp, currCompInAnchorPath, siblingsMap, visitedMap) {
    if (visitedMap[currCompInAnchorPath.id]) {
        return false;
    }
    visitedMap[currCompInAnchorPath.id] = true;

    var anchors = getCompAnchors(currCompInAnchorPath);
    anchors = _.filter(anchors, isBottomBottomOrBottomTopAnchor);

    return _.some(anchors, function (anchor) {
        return anchor.targetComponent === cycleCandidateComp.id || doesBTBBCycleExist(cycleCandidateComp, siblingsMap[anchor.targetComponent], siblingsMap, visitedMap);
    });
}

function fixBottomTopBottomBottomCycles(children) {
    if (_.isEmpty(children)) {
        return;
    }

    var siblingsMap = _.keyBy(children, 'id');
    _.forEach(children, function (component) {
        var anchors = getCompAnchors(component);
        _.remove(anchors, function (anchor) {
            return isBottomBottomOrBottomTopAnchor(anchor) && isPushingDownComponentThatsAbove(anchor, component, siblingsMap[anchor.targetComponent]) && doesBTBBCycleExist(component, siblingsMap[anchor.targetComponent], siblingsMap, {});
        });

        fixBottomTopBottomBottomCycles(component.components);
    });
}

module.exports = {
    fixBottomTopBottomBottomCycles: fixBottomTopBottomBottomCycles
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fixPageData = __webpack_require__(4);
var deprecatedSiteModelMigrater = __webpack_require__(78);
var fixBackgroundData = __webpack_require__(79);
var imageTransformDataFixers = __webpack_require__(3);
var anchorCyclesHelper = __webpack_require__(6);

module.exports = {
    fix: fixPageData,
    deprecatedSiteModelMigrater: deprecatedSiteModelMigrater,
    fixBackgroundData: fixBackgroundData,
    imageTransformDataFixers: imageTransformDataFixers,
    anchorCyclesHelper: anchorCyclesHelper
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var CompsMigrationHelper = __webpack_require__(2);
var galleryTypes = __webpack_require__(10);

//we assume that the desktop page run before the mobile comps in the helper
function compMigrationFunction(pageJson, cache, isMobile, comp) {
    if (!isMobile) {
        cache[comp.id] = comp;
        return;
    }
    var desktopComp = cache[comp.id];
    if (desktopComp.componentType === comp.componentType) {
        return;
    }
    var correctCompType = desktopComp.componentType;
    comp.componentType = correctCompType;
    var compProperties = this.getComponentProperties(pageJson, comp);
    var correctPropType = galleryTypes[correctCompType].propType;
    if (correctCompType && (!compProperties || compProperties.type !== correctPropType)) {
        comp.propertyQuery = desktopComp.propertyQuery;
    }
}

module.exports = {
    exec: function exec(pageJson) {
        var map = _.mapValues(galleryTypes, function () {
            return compMigrationFunction;
        });
        var helper = new CompsMigrationHelper(map);

        helper.migratePage(pageJson);
    }
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    'wysiwyg.viewer.components.MatrixGallery': { propType: 'MatrixGalleryProperties' },
    'wysiwyg.viewer.components.PaginatedGridGallery': { propType: 'PaginatedGridGalleryProperties' },
    'wysiwyg.viewer.components.SliderGallery': { propType: 'SliderGalleryProperties' },
    'wysiwyg.viewer.components.SlideShowGallery': { propType: 'SlideShowGalleryProperties' },
    'tpa.viewer.components.Masonry': { propType: 'MasonryProperties' },
    'tpa.viewer.components.Accordion': { propType: 'AccordionProperties' },
    'tpa.viewer.components.Impress': { propType: 'ImpressProperties' },
    'tpa.viewer.components.Freestyle': { propType: 'FreestyleProperties' },
    'tpa.viewer.components.Collage': { propType: 'CollageProperties' },
    'tpa.viewer.components.Honeycomb': { propType: 'HoneycombProperties' },
    'tpa.viewer.components.StripShowcase': { propType: 'StripShowcaseProperties' },
    'tpa.viewer.components.StripSlideshow': { propType: 'StripSlideshowProperties' },
    'tpa.viewer.components.Thumbnails': { propType: 'ThumbnailsProperties' },
    'wysiwyg.viewer.components.tpapps.TPA3DGallery': { propType: 'SlideShowGalleryProperties' },
    'wysiwyg.viewer.components.tpapps.TPA3DCarousel': { propType: 'SlideShowGalleryProperties' }
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    /**
     * Implicitly sets page top to 0
     * @param pageJson
     */
    exec: function exec(pageJson) {
        pageJson.structure = pageJson.structure || {};
        pageJson.structure.layout = pageJson.structure.layout || {};
        pageJson.structure.layout.y = 0;
    }
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var runOnAllCompsRecursively = __webpack_require__(13);

function fixMasterPage(masterPageDocumentData) {
    if (masterPageDocumentData.SITE_STRUCTURE) {
        masterPageDocumentData.masterPage = masterPageDocumentData.SITE_STRUCTURE;
    }
    if (!masterPageDocumentData.masterPage) {
        masterPageDocumentData.masterPage = {};
    }
    masterPageDocumentData.masterPage.id = 'masterPage';
    delete masterPageDocumentData.SITE_STRUCTURE;
}

function hasCorruptedWidth(comp) {
    return _.get(comp, 'layout.width') === 0;
}

function hasCorruptedHeight(comp) {
    return _.get(comp, 'layout.height') === 0;
}

function setDefaultSizesForCorruptedComponents(comp) {
    if (hasCorruptedWidth(comp)) {
        _.set(comp, 'layout.width', 100);
    }
    if (hasCorruptedHeight(comp)) {
        _.set(comp, 'layout.height', 100);
    }
}

function fixAnchorDistances(children) {
    _.forEach(children, function (child) {
        _.forEach(_.get(child, 'layout.anchors'), function (anchor) {
            switch (child.id) {
                case 'SITE_FOOTER':
                    if (anchor.type === 'BOTTOM_PARENT') {
                        anchor.distance = 0;
                    }
                    break;

                case 'PAGES_CONTAINER':
                    if (anchor.type === 'BOTTOM_TOP' && anchor.locked && anchor.distance >= 70) {
                        anchor.originalValue = 0;
                        anchor.locked = false;
                    }
                    break;
            }
        });
    });
}

function fixCorruptedMasterPageComponentLayouts(masterPageChildren, siteWidthForHeaderAndFooter) {
    var hasCorruption = false;

    _.forEach(['SITE_HEADER', 'SITE_FOOTER'], function (id) {
        var comp = _.find(masterPageChildren, { id: id });
        if (hasCorruptedWidth(comp)) {
            hasCorruption = true;
        }
        if (hasCorruptedHeight(comp)) {
            _.set(comp, 'layout.height', 100);
            hasCorruption = true;
        }

        _.set(comp, 'layout.width', siteWidthForHeaderAndFooter);
    });
    if (hasCorruption) {
        var rootCompsOnMasterPage = _.reject(masterPageChildren, { id: 'PAGES_CONTAINER' });
        runOnAllCompsRecursively(rootCompsOnMasterPage, [setDefaultSizesForCorruptedComponents]);
    }
}

function headerHasScrubBehavior(masterPageJson, mobileHeader) {
    if (!mobileHeader.behaviorQuery) {
        return false;
    }
    var behavior = _.get(masterPageJson, ['data', 'behaviors_data', mobileHeader.behaviorQuery]);
    try {
        var behaviorItems = JSON.parse(behavior.items);
        return _.some(behaviorItems, { type: 'scrub', name: 'ScrubAnimation' });
    } catch (e) {
        return false;
    }
}

function fixMobileFixedPositionSiteSegments(mobileMasterPageComps, masterPageJson, isFixedMobileHeaderOpen) {
    var mobileHeader = _.find(mobileMasterPageComps, { id: 'SITE_HEADER' });
    if (!isFixedMobileHeaderOpen) {
        _.set(mobileHeader, ['layout', 'fixedPosition'], false);
    } else if (headerHasScrubBehavior(masterPageJson, mobileHeader)) {
        _.set(mobileHeader, ['layout', 'fixedPosition'], true);
    }

    var mobileFooter = _.find(mobileMasterPageComps, { id: 'SITE_FOOTER' });
    _.set(mobileFooter, ['layout', 'fixedPosition'], false);
}

function fixMasterPageStructure(masterPageJson, isFixedMobileHeaderOpen) {
    var masterPageStructure = masterPageJson.structure;
    var desktopMasterPageComps = masterPageStructure.children;
    var mobileMasterPageComps = masterPageStructure.mobileComponents;
    var siteWidthForHeaderAndFooter = _.get(masterPageJson, 'data.document_data.masterPage.renderModifiers.siteWidth', 980);
    fixMissingMasterPagePartsIfNeeded(desktopMasterPageComps);
    fixCorruptedMasterPageComponentLayouts(desktopMasterPageComps, siteWidthForHeaderAndFooter);
    fixMissingMasterPagePartsIfNeeded(mobileMasterPageComps);
    fixCorruptedMasterPageComponentLayouts(mobileMasterPageComps, 320);
    fixMobileFixedPositionSiteSegments(mobileMasterPageComps, masterPageJson, isFixedMobileHeaderOpen);
    fixAnchorDistances(mobileMasterPageComps);
}

var mandatoryMasterPageParts = [{ componentType: 'wysiwyg.viewer.components.PagesContainer', id: 'PAGES_CONTAINER' }, { componentType: 'wysiwyg.viewer.components.FooterContainer', id: 'SITE_FOOTER' }, { componentType: 'wysiwyg.viewer.components.HeaderContainer', id: 'SITE_HEADER' }];

function fixMissingMasterPagePartsIfNeeded(comps) {
    _.forEach(mandatoryMasterPageParts, function (mandatoryPart) {
        var partByID = _.find(comps, { id: mandatoryPart.id });
        if (!partByID) {
            var partByType = _.find(comps, { componentType: mandatoryPart.componentType });
            if (partByType) {
                partByType.id = mandatoryPart.id;
            }
        }
    });
}

/**
 * @exports utils/dataFixer/plugins/masterPageFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson, pageIdsArray, requestModel, currentUrl, urlFormatModel, isViewerMode, rendererModel, magicObject) {
        if (pageJson.structure && pageJson.structure.type === 'Document') {
            pageJson.structure.id = 'masterPage';
            pageJson.structure.componentType = 'mobile.core.components.MasterPage';
            fixMasterPage(pageJson.data.document_data);
            var isFixedMobileHeaderOpen = magicObject.isExperimentOpen('sv_fixedMobileHeader');
            fixMasterPageStructure(pageJson, isFixedMobileHeaderOpen);
        }
        return pageJson;
    }
};

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
function runOnAllCompsRecursively(comps, funcs) {
    _.forEach(comps, function (comp) {
        _.forEach(funcs, function (func) {
            func(comp);
        });
        if (comp.components) {
            runOnAllCompsRecursively(comp.components, funcs);
        }
    });
}

module.exports = runOnAllCompsRecursively;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var menuFixer = __webpack_require__(15);

var bmiCnt = 0;
var pglkCnt = 0;

var BMI = 'bmi';
var PGLK = 'pglk';

function convertOldMenuToNewMenu(rawData, siteData) {
    return _.map(rawData, function (data) {
        return saveMenuItem(siteData, data);
    });
}

function saveMenuItem(siteData, data) {
    var id = BMI + bmiCnt++;
    var pageData = siteData[sanitizeId(data.refId)];
    siteData[id] = {
        id: id,
        label: pageData.title,
        isVisible: !pageData.hidePage,
        isVisibleMobile: pageData.mobileHidePage !== undefined ? !pageData.mobileHidePage : !pageData.hidePage,
        items: convertOldMenuToNewMenu(data.items, siteData),
        link: saveLinkItem(siteData, data.refId),
        type: 'BasicMenuItem',
        metaData: {}
    };

    return '#' + id;
}

function saveLinkItem(siteData, refId) {
    var id = PGLK + pglkCnt++;

    siteData[id] = {
        id: id,
        type: 'PageLink',
        pageId: refId,
        metaData: {}
    };

    return '#' + id;
}

function getDataItem(documentData, id) {
    return id && documentData[sanitizeId(id)];
}

function setAsMenuHeader(basicMenuItem) {
    delete basicMenuItem.link;
}

function getPageLink(documentData, basicMenuItem) {
    var linkItem = getDataItem(documentData, basicMenuItem.link);
    return _.get(linkItem, 'type') === 'PageLink' ? linkItem : undefined;
}

function isInvalidPageLink(documentData, basicMenuItem) {
    var pageLink = getPageLink(documentData, basicMenuItem);
    return pageLink && !getDataItem(documentData, pageLink.pageId);
}

function isInvalidLink(documentData, basicMenuItem) {
    return basicMenuItem.link && (basicMenuItem.link === '#CUSTOM_MENU_HEADER' || isInvalidPageLink(documentData, basicMenuItem));
}

function convertMenuItemsOfNonExistingPagesToHeaders(documentData, dataItem) {
    dataItem.items = _.filter(dataItem.items, function (basicMenuItemId) {
        return !_.isUndefined(getDataItem(documentData, basicMenuItemId));
    });

    _.forEach(dataItem.items, function (basicMenuItemId) {
        var basicMenuItem = getDataItem(documentData, basicMenuItemId);
        if (isInvalidLink(documentData, basicMenuItem)) {
            setAsMenuHeader(basicMenuItem);
        }
        convertMenuItemsOfNonExistingPagesToHeaders(documentData, basicMenuItem);
    });
}

function removeMenuDataItems(pageJson) {
    _(pageJson.data.document_data).filter({ type: 'Menu' }).map('id').forEach(function (pageId) {
        delete pageJson.data.document_data[pageId];
    });
}

function isJsonForPage(pageJson) {
    return _.get(pageJson, 'structure.type') === 'Page';
}

function sanitizeId(str) {
    return _.replace(str, '#', '');
}

function addMissingPageIdsToMenu(docData, pageIdsInSite) {
    var customMenuItems = docData.CUSTOM_MAIN_MENU.items;
    var pageIdsInMenu = _(docData).filter({ type: 'BasicMenuItem' }).map('link').compact().map(sanitizeId).map(function (linkItemId) {
        return docData[linkItemId];
    }).map('pageId').compact().map(sanitizeId).value();

    var pagesMissingFromMenu = _.difference(pageIdsInSite, pageIdsInMenu);
    _.forEach(pagesMissingFromMenu, function (missingPageId) {
        if (docData[missingPageId].isPopup) {
            return;
        }
        customMenuItems.push(createMenuItem(docData, missingPageId));
    });
}

function createMenuItem(siteData, pageId) {
    var id = BMI + bmiCnt++;
    var pageData = siteData[pageId];
    siteData[id] = {
        id: id,
        label: pageData.title,
        isVisible: !pageData.hidePage,
        isVisibleMobile: pageData.mobileHidePage !== undefined ? !pageData.mobileHidePage : !pageData.hidePage,
        items: [],
        link: saveLinkItem(siteData, '#' + pageId),
        type: 'BasicMenuItem',
        metaData: {}
    };

    return '#' + id;
}

function getInitDataIndexCounts(siteData, countId) {
    var indexedDataItems = _.filter(siteData, function (item) {
        return item.id && item.id.indexOf(countId) === 0;
    });
    var maxBmiId = -1;
    _.forEach(indexedDataItems, function (item) {
        var currentIndex = Number(item.id.replace(countId, ''));
        if (currentIndex > maxBmiId) {
            maxBmiId = currentIndex;
        }
    });
    return ++maxBmiId;
}

function menuWalker(pageJson, pageIdsArray) {
    function removeInvalidSubMenus(menuItem) {
        menuItem.items = _.filter(menuItem.items, isValidItem);
        _(menuItem.items).map(function (itemId) {
            return getDataItem(pageJson.data.document_data, itemId);
        }).forEach(removeInvalidSubMenus);
    }

    function isValidItem(menuItemId) {
        var masterPageData = pageJson.data.document_data;
        var menuItem = getDataItem(masterPageData, menuItemId);
        var hasNoLink = function hasNoLink() {
            return !menuItem.link;
        };
        var linksToNonPage = function linksToNonPage() {
            return !getPageLink(masterPageData, menuItem);
        };
        var pointsToAnExistingPage = function pointsToAnExistingPage() {
            var linkItem = getDataItem(masterPageData, menuItem.link);
            var linkedPageId = _.get(linkItem, 'pageId');
            return _.includes(pageIdsArray, sanitizeId(linkedPageId));
        };

        return hasNoLink() || linksToNonPage() || pointsToAnExistingPage();
    }

    return { removeInvalidSubMenues: removeInvalidSubMenus };
}

/**
 * @exports utils/dataFixer/plugins/customSiteMenuFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson, pageIdsArray) {
        if (isJsonForPage(pageJson)) {
            removeMenuDataItems(pageJson);
            return;
        }
        menuFixer.exec(pageJson, pageIdsArray);

        var docData = pageJson.data.document_data;
        bmiCnt = getInitDataIndexCounts(docData, BMI);
        pglkCnt = getInitDataIndexCounts(docData, PGLK);

        if (!pageJson.data.document_data.CUSTOM_MAIN_MENU) {
            pageJson.data.document_data.CUSTOM_MAIN_MENU = {
                id: 'CUSTOM_MAIN_MENU',
                items: convertOldMenuToNewMenu(pageJson.data.document_data.MAIN_MENU.items, pageJson.data.document_data),
                name: 'Custom Main Menu',
                type: 'CustomMenu',
                metaData: {}
            };
        }

        if (!pageJson.data.document_data.CUSTOM_MENUS) {
            pageJson.data.document_data.CUSTOM_MENUS = {
                id: 'CUSTOM_MENUS',
                menus: ['#CUSTOM_MAIN_MENU'],
                type: 'CustomMenusCollection',
                metaData: {}
            };
        } else if (!_.includes(pageJson.data.document_data.CUSTOM_MENUS.menus, '#CUSTOM_MAIN_MENU')) {
            pageJson.data.document_data.CUSTOM_MENUS.menus.push('#CUSTOM_MAIN_MENU');
        }
        addMissingPageIdsToMenu(docData, pageIdsArray);

        docData.CUSTOM_MAIN_MENU.items = _.uniq(docData.CUSTOM_MAIN_MENU.items); //fix for CLNT-8914 - ensure custom main menu items id uniqueness

        convertMenuItemsOfNonExistingPagesToHeaders(docData, docData.CUSTOM_MAIN_MENU);

        if (pageJson.data.document_data.MAIN_MENU.items.length > 0) {
            pageJson.data.document_data.MAIN_MENU.items = [];
        }

        var menuItem = pageJson.data.document_data.CUSTOM_MAIN_MENU;
        menuWalker(pageJson, pageIdsArray).removeInvalidSubMenues(menuItem);
    }
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function retrieveIds(menuOrMenuItem) {
    return _.reduce(menuOrMenuItem.items, function (ids, item) {
        ids.push(item.refId);
        if (item.items && item.items.length) {
            return ids.concat(retrieveIds(item));
        }
        return ids;
    }, []);
}

function retrieveAllMenuIds(docData) {
    return retrieveIds(docData.MAIN_MENU);
}

function removeTopLevelMenuItem(mainMenu, topLevelIndex) {
    var subMenu = mainMenu.items[topLevelIndex];
    if (subMenu.items && subMenu.items.length > 0) {
        _.forEach(subMenu.items, function (menuItem, subItemIndex) {
            //push the subitems to the top level array before removal
            mainMenu.items.push(menuItem);
            delete subMenu.items[subItemIndex]; //delete makes that array item = undefined, does not actually change the array length
        });
    }
    subMenu.items = []; //I prefer deletion of the items + set to empty array over splice an unknown amount of times
    mainMenu.items.splice(topLevelIndex, 1);
}

function findSubMenuItem(mainMenu, id) {
    var result = {};
    //for each item
    _.find(mainMenu.items, function (menuItem, topIndex) {
        //eslint-disable-line lodash/collection-method-value
        result.topIndex = topIndex;
        return _.find(menuItem.items, function (subItem, subIndex) {
            //check all of it's subitems
            if (subItem.refId === id) {
                result.subIndex = subIndex;
                return true;
            }
        });
    });

    return result;
}
function removeMenuItem(mainMenu, id) {
    var topLevelIndex = _.findIndex(mainMenu.items, { refId: id });
    if (topLevelIndex >= 0) {
        //case: id to remove is a top level menu item
        removeTopLevelMenuItem(mainMenu, topLevelIndex);
    } else {
        //case: id to remove is a subItem
        var location = findSubMenuItem(mainMenu, id);
        mainMenu.items[location.topIndex].items.splice(location.subIndex, 1);
    }
}

function removeAllBlankMenuItems(docData, menuIds) {
    var mainMenu = docData.MAIN_MENU;
    _.forEach(menuIds, function (id) {
        if (!id) {
            removeMenuItem(mainMenu, id);
        }
    });

    _.pull(menuIds, '', undefined);
}
function removeMenuItemsForNonexistingPages(docData, menuIds, pageIdsArray) {
    _.forEach(menuIds, function (id) {
        if (!_.includes(pageIdsArray, id.slice(1))) {
            //id is in #csdf format
            removeMenuItem(docData.MAIN_MENU, id);
        }
    });
}
function addMissingPageIdsToMenu(docData, menuIds, pageIdsArray) {
    var mainMenu = docData.MAIN_MENU;
    var emptyMainMenu = mainMenu.items.length === 0;
    var hasCsmData = !!docData.CUSTOM_MAIN_MENU;

    if (hasCsmData) {
        if (!emptyMainMenu) {
            delete docData.CUSTOM_MAIN_MENU;
            delete docData.CUSTOM_MENUS;
        } else {
            return;
        }
    }
    _.forEach(pageIdsArray, function (id) {
        if (!_.includes(menuIds, '#' + id)) {
            //id from pages list is not in the main menu, meaning it doesn't exist
            menuIds.push('#' + id); //add it to our array
            var newMenuItem = { items: [], refId: '#' + id };
            mainMenu.items.push(newMenuItem);
        }
    });
}

function stripHash(id) {
    return id.replace('#', '');
}

function validateSiteMainPage(siteStructure, pageIdsArray) {
    if (siteStructure && siteStructure.mainPage && !_.includes(pageIdsArray, stripHash(siteStructure.mainPage))) {
        siteStructure.mainPage = '#' + pageIdsArray[0];
    }
}

function hasReferenceToNonexistingData(docData, dataId) {
    return !docData[stripHash(dataId)];
}

function removeCustomSiteMenuIfNotLegal(docData) {
    var customMenuItems = _.get(docData, ['CUSTOM_MAIN_MENU', 'items']);
    if (customMenuItems && _.some(customMenuItems, _.partial(hasReferenceToNonexistingData, docData))) {
        delete docData.CUSTOM_MAIN_MENU;
        delete docData.CUSTOM_MENUS;
    }
}

function isJsonForMasterPage(pageJson) {
    return _.get(pageJson, 'structure.type') === 'Document';
}

function fixMenusOnMasterPage(docData, pageIdsArray) {
    var menuIds = retrieveAllMenuIds(docData);
    removeCustomSiteMenuIfNotLegal(docData);
    removeAllBlankMenuItems(docData, menuIds);
    removeMenuItemsForNonexistingPages(docData, menuIds, pageIdsArray);
    addMissingPageIdsToMenu(docData, menuIds, pageIdsArray);
    var siteStructure = docData.masterPage;
    validateSiteMainPage(siteStructure, pageIdsArray);
}
/**
 * @export utils/dataFixer/plugins/menuFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson, pageIdsArray) {
        var docData = pageJson.data.document_data;
        if (isJsonForMasterPage(pageJson)) {
            docData.MAIN_MENU = docData.MAIN_MENU || { items: [], type: 'Menu', id: 'MAIN_MENU', metaData: {} };
            if (pageIdsArray) {
                fixMenusOnMasterPage(docData, pageIdsArray);
            }
        }
    }
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CompsMigrationHelper = __webpack_require__(2);

var MIGRATION_MAP = {
    'wysiwyg.common.components.verticalmenu.viewer.VerticalMenu': migrateCompToSupportMultipleMenus,
    'wysiwyg.viewer.components.menus.DropDownMenu': migrateCompToSupportMultipleMenus
};
var migrationHelper = new CompsMigrationHelper(MIGRATION_MAP); // eslint-disable-line santa/no-module-state

function migrateCompToSupportMultipleMenus(pageJson, cache, mobileView, comp) {
    var compData = this.getComponentData(pageJson, comp);
    if (!compData || compData.type !== 'CustomMenuDataRef') {
        delete comp.dataQuery;
        this.setComponentData(pageJson, comp, {
            menuRef: '#CUSTOM_MAIN_MENU',
            type: 'CustomMenuDataRef'
        }, cache);
    }
}

module.exports = {
    exec: migrationHelper.migratePage.bind(migrationHelper)
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var replacementMap = {
    'mobile.core.skins.InlineSkin': 'skins.core.VerySimpleSkin',
    'mobile.core.skins.TwitterTweetSkin': 'skins.core.TwitterTweetSkin',
    'mobile.core.skins.ButtonSkin': 'skins.core.ButtonSkin',
    'mobile.core.skins.ContactItemSkin': 'skins.core.ContactItemSkin',
    'mobile.core.skins.ContactListSkin': 'skins.core.ContactListSkin',
    'mobile.core.skins.FacebookCommentSkin': 'skins.core.FacebookCommentSkin',
    'mobile.core.skins.GlobalMenuSkin': 'skins.core.GlobalMenuSkin',
    'mobile.core.skins.GooglePlusOneSkin': 'skins.core.GooglePlusOneSkin',
    'mobile.core.skins.HeaderSkin': 'skins.core.HeaderSkin',
    'mobile.core.skins.HomeButtonSkin': 'skins.core.HomeButtonSkin',
    'mobile.core.skins.ImageNewSkin': 'skins.core.ImageNewSkin',
    'mobile.core.skins.ImageSkin': 'skins.core.ImageSkin',
    'mobile.core.skins.MenuButtonSkin': 'skins.core.MenuButtonSkin',
    'mobile.core.skins.NetworkItemSkin': 'skins.core.NetworkItemSkin',
    'mobile.core.skins.NetworkListSkin': 'skins.core.NetworkListSkin',
    'mobile.core.skins.PageTitleSkin': 'skins.core.PageTitleSkin',
    'mobile.core.skins.PhotoFullScreenSkin': 'skins.core.PhotoFullScreenSkin',
    'mobile.core.skins.PhotoGalleryFullScreenDefaultSkin': 'skins.core.PhotoGalleryFullScreenDefaultSkin',
    'mobile.core.skins.PhotoGalleryGridDefaultSkin': 'skins.core.PhotoGalleryGridDefaultSkin',
    'mobile.core.skins.PhotoSkin': 'skins.core.PhotoSkin',
    'mobile.core.skins.RichTextImageSkin': 'skins.core.RichTextImageSkin',
    'mobile.core.skins.RichTextSkin': 'skins.core.RichTextSkin',
    'mobile.core.skins.ServiceItemSkin': 'skins.core.ServiceItemSkin',
    'mobile.core.skins.ServiceListSkin': 'skins.core.ServiceListSkin',
    'mobile.core.skins.SimpleButtonSkin': 'skins.core.SimpleButtonSkin',
    'mobile.core.skins.SiteNavigationMenuSkin': 'skins.core.SiteNavigationMenuSkin',
    'mobile.core.skins.TwitterFollowSkin': 'skins.core.TwitterFollowSkin',
    'mobile.core.skins.FacebookLikeSkin': 'skins.core.FacebookLikeSkin',

    'skins.viewer.gallerymatrix.PolaroidCustomHeightSkin': 'wysiwyg.viewer.skins.gallerymatrix.PolaroidCustomHeightSkin',
    'skins.viewer.gallerymatrix.PolaroidDisplayerCustomHeightSkin': 'wysiwyg.viewer.skins.gallerymatrix.PolaroidDisplayerCustomHeightSkin',
    'skins.viewer.gallerymatrix.TextBottomCustomHeightSkin': 'wysiwyg.viewer.skins.gallerymatrix.TextBottomCustomHeightSkin',
    'skins.viewer.gallerymatrix.TextBottomDisplayerCustomHeightSkin': 'wysiwyg.viewer.skins.gallerymatrix.TextBottomDisplayerCustomHeightSkin',

    'skins.viewer.galleryslider.SliderGalleryScotchTapeSkin': 'wysiwyg.viewer.skins.galleryslider.SliderGalleryScotchTapeSkin',
    'skins.viewer.galleryslider.SliderGalleryIronSkin': 'wysiwyg.viewer.skins.galleryslider.SliderGalleryIronSkin',
    'skins.viewer.galleryslider.SliderDisplayerIronSkin': 'wysiwyg.viewer.skins.galleryslider.SliderDisplayerIronSkin',
    'skins.viewer.galleryslider.SliderDisplayerScotchTapeSkin': 'wysiwyg.viewer.skins.galleryslider.SliderDisplayerScotchTapeSkin',
    'wysiwyg.viewer.skins.gallerymatrix.MatrixGallerySeparateTextBoxSkin': 'wysiwyg.common.components.matrixgallery.viewer.skins.MatrixGallerySeparateTextBoxSkin',
    'wysiwyg.viewer.skins.gallerymatrix.MatrixGalleryTextOnCenterSkin': 'wysiwyg.common.components.matrixgallery.viewer.skins.MatrixGalleryTextOnCenterSkin',

    'wysiwyg.viewer.skins.dropmenu.TextOnlyMenuNSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.TextOnlyMenuButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.TextSeparatorsMenuNSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.TextSeparatorsMenuButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.SolidColorMenuNSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.SolidColorMenuButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.ShinyMenuINSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.ShinyMenuIButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.ShinyMenuIINSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.ShinyMenuIIButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.OverlineMenuNSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.OverlineMenuButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.SeparateBasicMenuNSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateBasicMenuButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.SeparateShinyIMenuNSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateShinyIMenuButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.SeparateShinyIIMenuNSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateShinyIIMenuButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.LinesMenuNSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.LinesMenuButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.SeparateLinesMenuNSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateLinesMenuButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.PointerMenuNSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.PointerMenuButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.RibbonsMenuNSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.RibbonsMenuButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.VerticalRibbonsMenuNSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.VerticalRibbonsMenuButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.IndentedMenuNSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.IndentedMenuButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.SeparateIndentedMenuNSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateIndentedMenuButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.ArrowRightMenuNSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.ArrowRightMenuButtonSkin',
    'wysiwyg.viewer.skins.dropmenu.SloppyBorderMenuNSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.SloppyBorderMenuButtonSkin',

    /*Deprecated HorizontalMenu skins*/
    'wysiwyg.viewer.skins.menu.ShinyMenuISkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.ShinyMenuIIButtonSkin',
    'wysiwyg.viewer.skins.menu.ShinyMenuIISkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.ShinyMenuIIButtonSkin',
    'wysiwyg.viewer.skins.menu.TextOnlyMenuSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.TextOnlyMenuButtonBgFixSkin',
    'wysiwyg.viewer.skins.menu.TextSeparatorsMenuSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.TextSeparatorsMenuButtonSkin',
    'wysiwyg.viewer.skins.menu.SolidColorMenuSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.SolidColorMenuButtonSkin',
    'wysiwyg.viewer.skins.menu.OverlineMenuSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.OverlineMenuButtonHorizontalMenuAdaptationSkin',
    'wysiwyg.viewer.skins.menu.SeparateBasicMenuSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateBasicMenuButtonSkin',
    'wysiwyg.viewer.skins.menu.SeparateShinyIMenuSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateShinyIMenuButtonSkin',
    'wysiwyg.viewer.skins.menu.SeparateShinyIIMenuSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateShinyIIMenuButtonBorderRadiusFixSkin',
    'wysiwyg.viewer.skins.menu.LinesMenuSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.LinesMenuButtonBorderRadiusFixSkin',
    'wysiwyg.viewer.skins.menu.SeparateLinesMenuSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateLinesMenuButtonHorizontalMenuAdaptationSkin',
    'wysiwyg.viewer.skins.menu.PointerMenuSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.PointerMenuButtonHorizontalMenuAdaptationSkin',
    'wysiwyg.viewer.skins.menu.RibbonsMenuSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.RibbonsMenuButtonSkin',
    'wysiwyg.viewer.skins.menu.IndentedMenuSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.IndentedMenuButtonSkin',
    'wysiwyg.viewer.skins.menu.SeparateIndentedMenuSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.SeparateIndentedMenuButtonSkin',
    'wysiwyg.viewer.skins.menu.ArrowRightMenuSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.ArrowRightMenuButtonSkin',
    'wysiwyg.viewer.skins.menu.SloppyBorderMenuSkin': 'wysiwyg.common.components.dropdownmenu.viewer.skins.SloppyBorderMenuButtonSkin',

    'tpa.viewer.skins.TPAMasonrySkin': 'wysiwyg.viewer.skins.TPAMasonrySkin',
    'tpa.viewer.skins.TPA3DCarouselSkin': 'wysiwyg.viewer.skins.TPA3DCarouselSkin',
    'tpa.viewer.skins.TPA3DGallerySkin': 'wysiwyg.viewer.skins.TPA3DGallerySkin',
    'tpa.viewer.skins.TPAAccordionSkin': 'wysiwyg.viewer.skins.TPAAccordionSkin',
    'tpa.viewer.skins.TPACollageSkin': 'wysiwyg.viewer.skins.TPACollageSkin',
    'tpa.viewer.skins.TPAEcomGallerySkin': 'wysiwyg.viewer.skins.TPAEcomGallerySkin',
    'tpa.viewer.skins.TPAFreestyleSkin': 'wysiwyg.viewer.skins.TPAFreestyleSkin',
    'tpa.viewer.skins.TPAHoneycombSkin': 'wysiwyg.viewer.skins.TPAHoneycombSkin',
    'tpa.viewer.skins.TPAImpressSkin': 'wysiwyg.viewer.skins.TPAImpressSkin',
    'tpa.viewer.skins.TPAStripShowcaseSkin': 'wysiwyg.viewer.skins.TPAStripShowcaseSkin',
    'tpa.viewer.skins.TPAStripSlideshowSkin': 'wysiwyg.viewer.skins.TPAStripSlideshowSkin',
    'tpa.viewer.skins.TPAThumbnailsSkin': 'wysiwyg.viewer.skins.TPAThumbnailsSkin',

    'tpa.common.skins.TPAPreloaderSkin': 'wysiwyg.viewer.skins.TPAPreloaderSkin',
    'tpa.common.skins.TPAUnavailableMessageOverlaySkin': 'wysiwyg.viewer.skins.TPAUnavailableMessageOverlaySkin'
};

function replaceNameIfNeeded(component) {
    if (component.skin && replacementMap[component.skin]) {
        component.skin = replacementMap[component.skin];
    }
}

function fixSkinName(component, componentsName) {
    var i = void 0,
        curChild = void 0; //eslint-disable-line one-var
    var children = component[componentsName] || component.components;
    if (!children) {
        return;
    }

    for (i = 0; i < children.length; i++) {
        curChild = children[i];
        replaceNameIfNeeded(curChild);
        fixSkinName(curChild, componentsName);
    }
}

/**
 * @exports utils/dataFixer/plugins/skinFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        var structureData = pageJson.structure;

        if (structureData) {
            fixSkinName(structureData, 'children');
            fixSkinName(structureData, 'mobileComponents');
            replaceNameIfNeeded(structureData);
        }

        var themeData = pageJson.data && pageJson.data.theme_data;
        if (themeData) {
            _.forEach(themeData, function (data) {
                replaceNameIfNeeded(data);
            });
        }
    }
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function replaceLltWithLlf(res, value, key) {
    res[key.replace('llt_', 'llf_')] = value;
    return res;
}

function SUBSCRIBE_FORM_LINE_LAYOUT_STYLE_FIXER(styleData) {
    styleData.style.properties = _.reduce(styleData.style.properties, replaceLltWithLlf, {});
    styleData.style.propertiesSource = _.reduce(styleData.style.propertiesSource, replaceLltWithLlf, {});
}

var CORRUPT_STYLES_FIXER = {
    '*': function _(styleData) {
        if (styleData.id === 'THEME_DATA') {
            return;
        }
        if (!styleData.style) {
            styleData.style = {
                properties: {},
                propertiesSource: {},
                groups: {}
            };
        }
    },

    'wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormLineLayoutFlat': SUBSCRIBE_FORM_LINE_LAYOUT_STYLE_FIXER,
    'wysiwyg.common.components.subscribeform.viewer.skins.SubscribeFormLineLayoutTransparentWithIcon': SUBSCRIBE_FORM_LINE_LAYOUT_STYLE_FIXER
};

function fixStyleParamsIfNeeded(style) {
    if (style.style) {
        _.forEach(style.style.properties, function (paramValue, paramName, properties) {
            if (typeof paramValue === 'string') {
                properties[paramName] = paramValue.replace(/(\d)x/g, '$1px');
            }
        });
    }
}

function createDefaultWixAppsVideoStyle() {
    var newStyle = {
        type: 'TopLevelStyle',
        id: 'v2',
        metaData: {
            isPreset: false,
            schemaVersion: '1.0',
            isHidden: false
        },
        style: {
            properties: {
                brd: 'color_15',
                brw: '0px',
                rd: '0px',
                shd: '0 1px 4px rgba(0, 0, 0, 0.6);'
            },
            propertiesSource: {
                brd: 'theme',
                brw: 'value',
                rd: 'value',
                shd: 'value'
            },
            groups: {}
        },
        componentClassName: '',
        pageId: '',
        compId: '',
        styleType: 'system',
        skin: 'wysiwyg.viewer.skins.video.VideoDefault'
    };
    return newStyle;
}

function addMissingStyleIfNeeded(themeData) {
    if (!themeData.v2) {
        var newStyle = createDefaultWixAppsVideoStyle();
        themeData.v2 = _.cloneDeep(themeData.vl) || newStyle;
    }
}

function fixCorruptStyle(themeData) {
    _.forOwn(themeData, function (value) {
        CORRUPT_STYLES_FIXER['*'](value);
        if (CORRUPT_STYLES_FIXER[value.skin]) {
            CORRUPT_STYLES_FIXER[value.skin](value);
        }
    });
}

/**
 * @exports utils/dataFixer/plugins/stylesFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        var themeData = pageJson.data && pageJson.data.theme_data;
        if (!_.isEmpty(themeData)) {
            addMissingStyleIfNeeded(themeData);
            fixCorruptStyle(themeData);
            _.forEach(themeData, function (style) {
                fixStyleParamsIfNeeded(style);
            });
        }
    }
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var PLACEHOLDER_IMAGE_FILENAME = 'add_image_thumb.png';

function isBgImageStrip(comp) {
    return comp && comp.componentType === 'wysiwyg.viewer.components.BgImageStrip';
}

function getDataQuery(comp) {
    return comp && comp.dataQuery && comp.dataQuery.replace('#', '');
}

function isPlaceholder(dataItem) {
    return dataItem.uri.slice(0 - PLACEHOLDER_IMAGE_FILENAME.length) === PLACEHOLDER_IMAGE_FILENAME;
}

function gatherBgImageStripDataAndFixEmptyTitle(dataQueryMap, documentData, comp) {
    if (isBgImageStrip(comp)) {
        var dataQuery = getDataQuery(comp);
        var dataItem = dataQuery && documentData[dataQuery];

        if (dataItem) {
            dataItem.title = dataItem.title || '';
            if (!isPlaceholder(dataItem)) {
                dataQueryMap[comp.id] = dataQuery;
            }
        }
    }
}

function propagateBgImageStripData(dataQueryMap, documentData, comp) {
    if (isBgImageStrip(comp)) {
        var desktopQuery = dataQueryMap[comp.id];

        if (desktopQuery) {
            comp.dataQuery = '#' + desktopQuery;
        } else {
            delete comp.dataQuery;
        }
    }
}

function forComponents(comps, callback) {
    _.forEach(comps, function (comp) {
        callback(comp);
        forComponents(comp.components, callback);
    });
}

module.exports = {
    exec: function exec(pageJson) {
        var structure = pageJson.structure;
        var desktopComps = structure && (structure.components || structure.children);
        var mobileComps = structure && structure.mobileComponents;

        if (desktopComps) {
            var dataQueryMap = {};
            forComponents(desktopComps, gatherBgImageStripDataAndFixEmptyTitle.bind(null, dataQueryMap, pageJson.data.document_data));
            forComponents(desktopComps, propagateBgImageStripData.bind(null, dataQueryMap, pageJson.data.document_data));
            forComponents(mobileComps, propagateBgImageStripData.bind(null, dataQueryMap, pageJson.data.document_data));
        }
    }
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);

function getReplacementMap(shouldMergeClipartAndImage) {
    var replacementMap = {
        'wysiwyg.viewer.components.HorizontalMenu': {
            comp: 'wysiwyg.viewer.components.menus.DropDownMenu',
            dataQuery: '#MAIN_MENU'
        }
    };

    if (shouldMergeClipartAndImage) {
        replacementMap['wysiwyg.viewer.components.ClipArt'] = {
            comp: 'wysiwyg.viewer.components.WPhoto'
        };
    }

    return replacementMap;
}

function replaceNameIfNeeded(replacementTypes, pageJson, component) {
    var type = component.componentType;
    var replacement = replacementTypes[type];

    if (replacement) {
        component.componentType = replacement.comp;
        if (replacement.dataQuery) {
            component.dataQuery = replacement.dataQuery;
        }
        if (replacement.callback) {
            replacement.callback(pageJson);
        }
    }
}

function fixCompHeight(pageJson, component) {
    if (component.componentType === 'wysiwyg.viewer.components.ItunesButton') {
        component.layout.height = Math.round(component.layout.width / 2.75);
    }
}

function getComponentProperties(pageJson, comp) {
    return pageJson.data.component_properties[comp.propertyQuery];
}

function getComponentData(pageJson, comp) {
    return comp.dataQuery && pageJson.data.document_data[comp.dataQuery.replace('#', '')];
}

function setComponentProperties(pageJson, comp, propertyItem) {
    pageJson.data.component_properties[comp.propertyQuery] = propertyItem;
}

function setComponentData(pageJson, comp, dataItem) {
    var newId = coreUtils.guidUtils.getUniqueId('dataItem', '-');

    comp.dataQuery = '#' + newId;
    dataItem.id = newId;
    pageJson.data.document_data[newId] = dataItem;
}

function findCompHeight(comp) {
    if (comp.components.length > 0) {
        var compsBottomY = _.map(comp.components, function (component) {
            return component.layout.y + component.layout.height;
        });
        return _.max(compsBottomY);
    }
    return 0;
}

function findFooterY(pageJson) {
    var pagesContainer = _.find(pageJson.structure.children, { id: 'PAGES_CONTAINER' });
    return pagesContainer.layout.y + pagesContainer.layout.height;
}

function addDefaultLayout(pageJson, comp) {
    if (comp.id === 'SITE_FOOTER' && !comp.layout) {
        comp.layout = {
            anchors: [],
            fixedPosition: false,
            height: findCompHeight(comp),
            rotationInDegrees: 0,
            scale: 1,
            width: 320,
            x: 0,
            y: findFooterY(pageJson)
        };
    }
}

function addDefaultData(pageJson, comp) {
    if (getComponentData(pageJson, comp)) {
        return;
    }

    switch (comp.componentType) {
        case 'wysiwyg.viewer.components.svgshape.SvgShape':
            setComponentData(pageJson, comp, {
                link: null,
                type: 'SvgShape'
            });
            break;
        case 'wysiwyg.viewer.components.WFacebookComment':
            setComponentData(pageJson, comp, {
                type: 'WFacebookComment',
                urlFormat: 'hashBang'
            });
            return;
        case 'wysiwyg.viewer.components.WFacebookLike':
            setComponentData(pageJson, comp, {
                type: 'WFacebookLike',
                urlFormat: 'hashBang'
            });
            return;
        default:
            break;
    }
}

function fixCompData(pagesJson, comp) {
    var data = getComponentData(pagesJson, comp);
    if (!data) {
        return;
    }
    switch (comp.componentType) {
        case 'wysiwyg.viewer.components.ClipArt':
            data.title = '';
            return;
        case 'wysiwyg.viewer.components.FacebookShare':
            data.urlFormat = data.urlFormat || 'hashBang';
            return;
        case 'wysiwyg.viewer.components.VKShareButton':
            data.urlFormat = data.urlFormat || 'hashBang';
            return;
        case 'wysiwyg.common.components.pinterestpinit.viewer.PinterestPinIt':
            data.urlFormat = data.urlFormat || 'hashBang';
            return;
        case 'wysiwyg.viewer.components.WTwitterTweet':
            data.urlFormat = data.urlFormat || 'hashBang';
            return;
        case 'wysiwyg.viewer.components.WFacebookComment':
            data.urlFormat = data.urlFormat || 'hashBang';
            return;
        case 'wysiwyg.viewer.components.WFacebookLike':
            data.urlFormat = data.urlFormat || 'hashBang';
            return;
    }
}

function validationAnchorCompWidth(screenWidth, pageJson, comp) {
    if (comp.componentType === 'wysiwyg.common.components.anchor.viewer.Anchor' && comp.layout.width === 0) {
        comp.layout.width = screenWidth;
    }
}

function addDefaultProperties(pageJson, comp) {
    if (getComponentProperties(pageJson, comp)) {
        return;
    }

    switch (comp.componentType) {
        case 'wysiwyg.viewer.components.menus.DropDownMenu':
            {
                setComponentProperties(pageJson, comp, {
                    alignButtons: 'center',
                    alignText: 'center',
                    sameWidthButtons: false,
                    moreButtonLabel: 'More',
                    moreItemHeight: 15,
                    stretchButtonsToMenuWidth: true,
                    type: 'HorizontalMenuProperties'
                });
                break;
            }
        case 'wysiwyg.viewer.components.mobile.TinyMenu':
            {
                var newId = 'TINY_MENU';
                comp.propertyQuery = newId;
                setComponentProperties(pageJson, comp, {
                    direction: 'left',
                    type: 'TinyMenuProperties',
                    id: newId,
                    metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false }
                });
                break;
            }
        default:
            break;
    }
}

/**
 * this is caching the properties by comp id, so that we can access it in mobile in case there are missing properties
 * @param cache
 * @param pageJson
 * @param comp
 */
function cacheComponentPropertiesByCompId(cache, pageJson, comp) {
    cache.properties[comp.id] = getComponentProperties(pageJson, comp);
}

function fixMissingPropertiesInMobile(cache, pageJson, comp) {
    if (!getComponentProperties(pageJson, comp) && cache.properties[comp.id]) {
        setComponentProperties(pageJson, comp, cache.properties[comp.id]);
    }
}

function isMobileDisplayedModeMissing(comp, mobileDisplayedModeId) {
    var modeDefinitions = _.get(comp, 'modes.definitions');

    return !_.some(modeDefinitions, { modeId: mobileDisplayedModeId });
}

function getHoverModeId(comp) {
    var modeDefinitions = _.get(comp, 'modes.definitions');

    return _.find(modeDefinitions, { type: coreUtils.siteConstants.COMP_MODES_TYPES.HOVER }).modeId;
}

function fixCompProps(pageJson, comp) {
    var props = getComponentProperties(pageJson, comp);
    if (!comp.propertyQuery || !props) {
        return;
    }

    switch (comp.componentType) {
        case 'wysiwyg.viewer.components.WFacebookLike':
            if (!props.language) {
                props.language = 'en';
            }
            break;
        case 'wysiwyg.viewer.components.PayPalButton':
            if (!props.language) {
                props.language = 'en';
            }
            break;
        case 'wysiwyg.viewer.components.GoogleMap':
            if (!props.language) {
                props.language = 'en';
            }
            break;
        case 'wysiwyg.viewer.components.WRichText':
            if (props.type !== 'WRichTextProperties') {
                delete comp.propertyQuery;
            }
            break;
        case 'wysiwyg.viewer.components.HoverBox':
            if (props.mobileDisplayedModeId && isMobileDisplayedModeMissing(comp, props.mobileDisplayedModeId)) {
                props.mobileDisplayedModeId = getHoverModeId(comp);
            }
            break;
        default:
            break;
    }
}

function runOnAllComps(pageJson, comps, funcs) {
    _.forEach(comps, function (comp) {
        _.forEach(funcs, function (func) {
            func(pageJson, comp);
        });
        if (comp.components) {
            runOnAllComps(pageJson, comp.components, funcs);
        }
    });
}

function replaceName(shouldMergeClipartAndImage) {
    return _.partial(replaceNameIfNeeded, getReplacementMap(shouldMergeClipartAndImage));
}

function fixDesktopComps(pageJson, cache, comps, shouldMergeClipartAndImage) {
    runOnAllComps(pageJson, comps, [replaceName(shouldMergeClipartAndImage), fixCompHeight, addDefaultData, addDefaultProperties, fixCompProps, fixCompData, _.partial(validationAnchorCompWidth, 1920), _.partial(cacheComponentPropertiesByCompId, cache)]);
}

function findMissingJsonAnchors(context, pageJson, comp) {
    context.pageContainsStructuresWithoutJsonAnchors = context.pageContainsStructuresWithoutJsonAnchors || !comp.layout || !comp.layout.anchors;
}

function removeJsonAnchors(pageJson, comp) {
    if (comp.layout) {
        delete comp.layout.anchors;
    }
}

function fixMobileComps(pageJson, cache, comps, shouldMergeClipartAndImage) {
    var context = {
        pageContainsStructuresWithoutJsonAnchors: false
    };

    runOnAllComps(pageJson, comps, [replaceName(shouldMergeClipartAndImage), fixCompHeight, addDefaultData, addDefaultProperties, fixCompProps, fixCompData, addDefaultLayout, _.partial(validationAnchorCompWidth, 320), _.partial(fixMissingPropertiesInMobile, cache), _.partial(findMissingJsonAnchors, context)]);

    if (context.pageContainsStructuresWithoutJsonAnchors) {
        runOnAllComps(pageJson, comps, [removeJsonAnchors]);
    }
}

/**
 * @exports utils/dataFixer/plugins/compFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson, pageIdsArray, requestModel, currentUrl, urlFormatModel, isViewerMode, rendererModel, magicObject) {
        var structureData = pageJson.structure;
        if (structureData) {
            var cache = {
                properties: {}
            };

            var desktopComps = structureData.components || structureData.children;
            var mobileComps = structureData.mobileComponents;

            var shouldMergeClipartAndImage = magicObject.isExperimentOpen('merge_clipart_and_image');
            if (desktopComps) {
                fixDesktopComps(pageJson, cache, desktopComps, shouldMergeClipartAndImage);
            }
            if (mobileComps) {
                fixMobileComps(pageJson, cache, mobileComps, shouldMergeClipartAndImage);
            }
        }
    }
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var galleryPropertyTypes = ['GalleryExpandProperties', 'MatrixGalleryProperties', 'PaginatedGridGalleryProperties', 'SliderGalleryProperties', 'SlideShowGalleryProperties'];

function fixGalleryFn(gallery) {
    if (_.isUndefined(gallery.galleryImageOnClickAction) || gallery.galleryImageOnClickAction === 'unset') {
        if (gallery.expandEnabled === false) {
            gallery.galleryImageOnClickAction = 'disabled';
        } else {
            gallery.galleryImageOnClickAction = 'zoomMode';
        }
    }
    return gallery;
}

function fixDataNodesForTypes(dataMap, types, mapper) {
    return _(dataMap).pickBy(function (dataNode) {
        return _.includes(types, dataNode.type);
    }).mapValues(mapper).value();
}

/**
 * @exports utils/dataFixer/plugins/galleryFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        fixDataNodesForTypes(pageJson.data.component_properties, galleryPropertyTypes, fixGalleryFn);
    }
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var behaviorsDataFixer = __webpack_require__(23);

function getBehaviorsItemPath(comp) {
    return ['behaviors_data', comp.behaviorQuery, 'items'];
}

function wereBehaviorsMigrated(pageData) {
    return _.has(pageData, 'behaviors_data');
}

function setFixedBehaviors(behaviorArr, comp, pageData) {
    var behaviorsToSet = JSON.stringify(behaviorArr);
    if (wereBehaviorsMigrated(pageData)) {
        _.set(pageData, getBehaviorsItemPath(comp), behaviorsToSet);
    } else {
        comp.behaviors = behaviorsToSet;
    }
}

function getCompBehaviors(comp, pageData) {
    if (wereBehaviorsMigrated(pageData)) {
        return _.get(pageData, getBehaviorsItemPath(comp), '[]');
    }
    return comp.behaviors || '[]';
}

/**
 * Convert old behaviors structure to new behaviors structure
 * @param comp
 */
function flattenBehaviors(comp, pageData) {
    var behaviorsList = [];
    var behaviorsString = getCompBehaviors(comp, pageData);
    var behaviorsObj = JSON.parse(behaviorsString);

    if (_.isEmpty(behaviorsObj)) {
        if (wereBehaviorsMigrated(pageData)) {
            delete comp.behaviorQuery;
        } else {
            delete comp.behaviors;
        }
        return;
    }

    if (_.isArray(behaviorsObj)) {
        var shouldFix = false;
        _.forEach(behaviorsObj, function (behavior) {
            var sourceId = _.get(behavior, 'action.sourceId');
            if (sourceId && sourceId !== comp.id) {
                behavior.action.sourceId = comp.id;
                shouldFix = true;
            }
        });

        if (shouldFix) {
            setFixedBehaviors(behaviorsObj, comp, pageData);
        }
        return;
    }

    _.forEach(behaviorsObj, function (targets, actionName) {
        _.forEach(targets, function (behaviors, targetId) {
            _.forEach(behaviors, function (behavior) {
                var extendedBehavior = _.assign({ targetId: targetId, action: actionName }, behavior);
                if (actionName === 'screenIn' || actionName === 'pageIn') {
                    extendedBehavior.targetId = '';
                }
                behaviorsList.push(extendedBehavior);
            });
        });
    });

    setFixedBehaviors(behaviorsList, comp, pageData);
}

function fixComponentBehaviors(comps, pageData) {
    _.forEach(comps, function (comp) {
        flattenBehaviors(comp, pageData);
        if (comp.components) {
            fixComponentBehaviors(comp.components, pageData);
        }
    });
}

/**
 * @exports utils/dataFixer/plugins/behaviorsFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        behaviorsDataFixer.exec(pageJson);
        var structureData = pageJson.structure;
        if (!structureData) {
            return;
        }
        if (structureData.components) {
            fixComponentBehaviors(structureData.components, pageJson.data);
        }
        if (structureData.mobileComponents) {
            fixComponentBehaviors(structureData.mobileComponents, pageJson.data);
        }
        if (structureData.children) {
            fixComponentBehaviors(structureData.children, pageJson.data);
        }
    }
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);
var behaviorsMigrationHelper = __webpack_require__(5);

function fetchDesktopComponentsWithBehaviors(structure) {
    var flattenComponents = coreUtils.dataUtils.getAllCompsInStructure(structure, false);
    return _.pickBy(flattenComponents, 'behaviors');
}

function fetchCorrespondingMobileComponents(structure, desktopComponents) {
    var flattenMobileComponents = coreUtils.dataUtils.getAllCompsInStructure(structure, true);
    return _.pickBy(flattenMobileComponents, function (mobileComp) {
        return desktopComponents[mobileComp.id];
    });
}

function setBehaviorsQuery(compStructure, dataItem, mobileCompStructure) {
    compStructure.behaviorQuery = dataItem.id;
    if (mobileCompStructure) {
        mobileCompStructure.behaviorQuery = compStructure.behaviorQuery;
    }
}

function moveBehaviorsFromStructureToData(pageJson) {
    var pageData = _.get(pageJson, 'data');
    var pageStructure = _.get(pageJson, 'structure');
    pageData.behaviors_data = pageData.behaviors_data || {};
    var desktopComponents = fetchDesktopComponentsWithBehaviors(pageStructure);
    var mobileComponents = fetchCorrespondingMobileComponents(pageStructure, desktopComponents);

    _.forEach(desktopComponents, function (compStructure) {
        var dataItem = behaviorsMigrationHelper.createBehaviorsDataItem(compStructure.behaviors);
        setBehaviorsQuery(compStructure, dataItem, mobileComponents[compStructure.id]);
        delete compStructure.behaviors;
        _.set(pageData, ['behaviors_data', dataItem.id], dataItem);
    });
}

module.exports = {
    exec: moveBehaviorsFromStructureToData
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

/**
 * @exports utils/dataFixer/plugins/connectionsDataFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        var pageData = _.get(pageJson, 'data');
        pageData.connections_data = pageData.connections_data || {};
    }
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var skinToLayoutMap = {
    'wysiwyg.viewer.skins.line.FadeLine': { width: 90 },
    'wysiwyg.viewer.skins.line.FadeNotchBottomLine': { width: 60 },
    'wysiwyg.viewer.skins.line.FadeNotchTopLine': { width: 60 },
    'wysiwyg.viewer.skins.line.ShadowBottomLine': { width: 200 },
    'wysiwyg.viewer.skins.line.ShadowTopLine': { width: 200 }
};

function fixFiveGridLineLayout(comps) {
    _.forEach(comps, function (comp) {
        if (_.has(skinToLayoutMap, comp.skin)) {
            var layout = skinToLayoutMap[comp.skin];
            comp.layout = _.mapValues(comp.layout, function (val, key) {
                if (layout[key]) {
                    return Math.max(val, layout[key]);
                }
                return val;
            });
        }

        if (comp.components) {
            fixFiveGridLineLayout(comp.components);
        }
    });
}

/**
 * @exports utils/dataFixer/plugins/fiveGridLineLayoutFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        var structureData = pageJson.structure;
        if (!structureData) {
            return;
        }
        if (structureData.components) {
            fixFiveGridLineLayout(structureData.components);
        }
        if (structureData.children) {
            fixFiveGridLineLayout(structureData.children);
        }
        if (structureData.mobileComponents) {
            fixFiveGridLineLayout(structureData.mobileComponents);
        }
    }
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

//you can reproduce the issue by adding a component bigger than page clicking it once and saving..

function childrenAnchorsExist(childrenArr) {
    var childComp = _.head(childrenArr);
    return !!_.get(childComp, 'layout.anchors');
}

/**
 * @exports utils/dataFixer/plugins/toPageAnchorsFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        var structureData = pageJson.structure;
        if (structureData && structureData.components && !_.isEmpty(structureData.components) && childrenAnchorsExist(structureData.components)) {
            var bottomMost = _.maxBy(structureData.components, function (compStructure) {
                var bottom = -1 * Number.MAX_VALUE;
                if (compStructure.layout && _.isNumber(compStructure.layout.y) && _.isNumber(compStructure.layout.height)) {
                    bottom = compStructure.layout.y + compStructure.layout.height;
                }
                return bottom;
            });
            var toParentAnchor = void 0;
            if (bottomMost.layout && bottomMost.layout.anchors) {
                toParentAnchor = _.find(bottomMost.layout.anchors, { type: 'BOTTOM_PARENT' });
            }
            if (!toParentAnchor) {
                bottomMost.layout = bottomMost.layout || {};
                bottomMost.layout.anchors = bottomMost.layout.anchors || [];
                bottomMost.layout.anchors.push({
                    distance: 0,
                    type: 'BOTTOM_PARENT',
                    targetComponent: pageJson.structure.id,
                    locked: true,
                    originalValue: pageJson.structure.layout.height,
                    topToTop: bottomMost.layout.y
                });
            }
        }
        //didn't see this problem in mobile
    }
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var anchorCyclesHelper = __webpack_require__(6);

var unresizableComponents = {
    'wysiwyg.common.components.anchor.viewer.Anchor': true,
    'wysiwyg.common.components.subscribeform.viewer.SubscribeForm': true,
    'wysiwyg.common.components.pinitpinwidget.viewer.PinItPinWidget': true,
    'wysiwyg.common.components.singleaudioplayer.viewer.SingleAudioPlayer': true,
    'wixapps.integration.components.AppPart': true,
    'wixapps.integration.components.AppPart2': true,
    'wixapps.integration.components.common.minipart': true,
    'wysiwyg.common.components.onlineclock.viewer.OnlineClock': true,
    'wysiwyg.common.components.weather.viewer.Weather': true,
    'wysiwyg.common.components.skypecallbutton.viewer.SkypeCallButton': true,
    'wysiwyg.common.components.spotifyfollow.viewer.SpotifyFollow': true,
    'wysiwyg.common.components.spotifyplayer.viewer.SpotifyPlayer': true,
    'wysiwyg.common.components.youtubesubscribebutton.viewer.YouTubeSubscribeButton': true,
    'wysiwyg.viewer.components.ContactForm': true,
    'wysiwyg.viewer.components.FacebookShare': true,
    'wysiwyg.viewer.components.FiveGridLine': true,
    'wysiwyg.viewer.components.FlickrBadgeWidget': true,
    'wysiwyg.viewer.components.ItunesButton': true,
    'wysiwyg.viewer.components.LinkBar': true,
    'wysiwyg.viewer.components.PayPalButton': true,
    'wysiwyg.viewer.components.PinterestFollow': true,
    'wysiwyg.viewer.components.VKShareButton': true,
    'wysiwyg.viewer.components.WFacebookComment': true,
    'wysiwyg.viewer.components.WGooglePlusOne': true,
    'wysiwyg.viewer.components.mobile.TinyMenu': true
};

var notAnchorableComponents = {
    'wysiwyg.common.components.backtotopbutton.viewer.BackToTopButton': true,
    'wysiwyg.viewer.components.tpapps.TPAGluedWidget': true,
    'mobile.core.components.Page': true,
    'wixapps.integration.components.AppPage': true
};

function removeAnchorsForNotAnchorableComponents(component) {
    //TODO: bring this back to life after solving the fixed footer thing CLNT-2889
    //|| (component.layout && component.layout.fixedPosition === true)
    if (notAnchorableComponents[component.componentType]) {
        component.layout.anchors = [];
    }
}

function fixTopTopToBeLocked(anchor) {
    if (anchor.type === 'TOP_TOP') {
        anchor.locked = true;
    }
}

/**
 * return the height of the bounding rect surrounding the component
 */
function getBoundingHeight(height, width, angleInDegrees) {
    var currentAngleInRadians = (angleInDegrees || 0) * Math.PI / 180;
    return parseInt(Math.abs(width * Math.sin(currentAngleInRadians)) + Math.abs(height * Math.cos(currentAngleInRadians)), 10);
}

/**
 * return the top of the bounding rect surrounding the component
 */
function getBoundingY(y, height, boundingHeight) {
    return parseInt(y - (boundingHeight - height) / 2, 10);
}

function getCompBottom(comp) {
    return comp.layout && comp.layout.y + comp.layout.height;
}

function getCompAnchors(comp) {
    return comp.layout && comp.layout.anchors || [];
}

//we are looking for a bottom bottom anchor to closeCircleComp
function isCompAnchorTreeClosingCircle(comp, closeCircleComp, closeCircleCompBottom, siblingsMap, visitedComps) {
    if (visitedComps[comp.id] || getCompBottom(comp) > closeCircleCompBottom) {
        return;
    }
    visitedComps[comp.id] = true;
    var anchors = getCompAnchors(comp);
    _.remove(anchors, function (anchor) {
        if (anchor.targetComponent === closeCircleComp.id) {
            return true;
        }
        if (anchor.type !== 'BOTTOM_PARENT') {
            if (!siblingsMap[anchor.targetComponent]) {
                return true;
            }
            isCompAnchorTreeClosingCircle(siblingsMap[anchor.targetComponent], closeCircleComp, closeCircleCompBottom, siblingsMap, visitedComps);
        }
        return false;
    });
}

function breakCircleIfThereIsOne(anchor, closeCircleComp, siblingsMap) {
    //circles might be created by bottom_top anchors
    if (anchor.type !== 'BOTTOM_TOP') {
        return;
    }
    var targetComp = siblingsMap[anchor.targetComponent];
    var targetCompAnchors = getCompAnchors(targetComp);
    //yes, there are loops that small...
    _.remove(targetCompAnchors, { targetComponent: closeCircleComp.id });

    //the bottom of the target comp should be outside of the from comp so not interesting
    var topTopAnchors = _.filter(targetCompAnchors, { type: 'TOP_TOP' });
    var closeCircleCompBottom = getCompBottom(closeCircleComp) + 10;
    _.forEach(topTopAnchors, function (anch) {
        if (siblingsMap[anch.targetComponent]) {
            isCompAnchorTreeClosingCircle(siblingsMap[anch.targetComponent], closeCircleComp, closeCircleCompBottom, siblingsMap, {});
        }
    });
}

function updateAnchorsToMasterPage(parentComponent, anchors) {
    if (parentComponent.type !== 'Document') {
        return;
    }
    _.forEach(anchors, function (anchor) {
        //eslint-disable-line lodash/prefer-filter
        if (anchor.targetComponent === 'SITE_STRUCTURE') {
            anchor.targetComponent = 'masterPage';
        }
    });
}

function preventSameTypeAnchorsBetweenTwoComps(component, anchors, siblingsMap) {
    anchors = _.reject(anchors, { type: 'BOTTOM_PARENT' });
    _.forEach(anchors, function (anchor) {
        var targetComp = siblingsMap[anchor.targetComponent];
        if (!targetComp) {
            return;
        }
        var targetCompAnchorsForComp = _.filter(getCompAnchors(targetComp), {
            targetComponent: component.id,
            type: anchor.type
        });
        _.forEach(targetCompAnchorsForComp, function (targetCompAnchor) {
            var compWithBiggerY = component.layout.y < targetComp.layout.y ? targetComp : component;
            var anchorToRemove = component.layout.y < targetComp.layout.y ? targetCompAnchor : anchor;
            _.remove(compWithBiggerY.layout.anchors, function (higherCompAnchor) {
                return higherCompAnchor === anchorToRemove;
            });
        });
    });
}

function removeAnchorsNotInTheSameScope(children) {
    _.forEach(children, function (component) {
        var anchors = getCompAnchors(component);
        anchors = _.reject(anchors, { type: 'BOTTOM_PARENT' });
        _.remove(anchors, function (anchor) {
            return !_.some(children, { id: anchor.targetComponent });
        });
    });
}

function fixAnchorAndReturnIsStaying(anchor, parentComponent, siblingsMap) {
    var parentId = parentComponent.id;
    var targetComponent = siblingsMap[anchor.targetComponent];
    if (anchor.type === 'BOTTOM_PARENT') {
        targetComponent = anchor.targetComponent === parentId ? parentComponent : null;
    }

    if (!targetComponent) {
        return false;
    }

    if (anchor.type === 'BOTTOM_BOTTOM' && unresizableComponents[targetComponent.componentType]) {
        return false;
    }

    if (anchor.type !== 'BOTTOM_PARENT' && (notAnchorableComponents[targetComponent.componentType] ||
    //TODO: this is temp until we find a solution for this crap..
    targetComponent.componentType === 'wysiwyg.viewer.components.HeaderContainer' && targetComponent.layout && targetComponent.layout.fixedPosition === true)) {
        return false;
    }

    var targetValue = void 0;
    if (targetComponent.layout && _.isNumber(targetComponent.layout.height) && _.isNumber(targetComponent.layout.y)) {
        var targetLayout = targetComponent.layout;
        var targetBoundingHeight = getBoundingHeight(targetLayout.height, targetLayout.width, targetLayout.rotationInDegrees);
        var targetBoundingY = getBoundingY(targetLayout.y, targetLayout.height, targetBoundingHeight);
        targetValue = anchor.type === 'BOTTOM_PARENT' || anchor.type === 'BOTTOM_BOTTOM' ? targetBoundingHeight : targetBoundingY;
    } else {
        targetValue = 0;
    }

    anchor.originalValue = Math.min(anchor.originalValue, targetValue);
    return true;
}

function removeInvalidAnchors(anchors) {
    _.remove(anchors, function (anchor) {
        return anchor.distance === null || isNaN(anchor.distance);
    });
}

function fixParentAnchors(parentComponent, childrenPropertyName) {
    var isPage = !!childrenPropertyName;

    if (isPage) {
        removeAnchorsForNotAnchorableComponents(parentComponent);
    }
}

function fixAnchorsForPageAndChildren(parentComponent, childrenPropertyName) {
    fixParentAnchors(parentComponent, childrenPropertyName);
    return fixAnchorsForChildrenInScope(parentComponent, childrenPropertyName);
}

function fixAnchorsForChildrenInScope(parentComponent, childrenPropertyName) {
    var children = childrenPropertyName ? parentComponent[childrenPropertyName] : parentComponent.components;

    if (_.isEmpty(children)) {
        return;
    }
    var siblingsMap = _.transform(children, function (result, comp) {
        result[comp.id] = comp;
    }, {});

    removeAnchorsNotInTheSameScope(children); //do it before break circle runs
    _.forEach(children, function (component) {
        var anchors = getCompAnchors(component);
        removeInvalidAnchors(anchors);
        removeAnchorsForNotAnchorableComponents(component);
        updateAnchorsToMasterPage(parentComponent, anchors);
        preventSameTypeAnchorsBetweenTwoComps(component, anchors, siblingsMap);
        _.remove(anchors, function (anchor) {
            fixTopTopToBeLocked(anchor);
            var shouldStay = fixAnchorAndReturnIsStaying(anchor, parentComponent, siblingsMap);
            if (shouldStay) {
                breakCircleIfThereIsOne(anchor, component, siblingsMap);
            }
            return !shouldStay;
        });

        fixAnchorsForChildrenInScope(component);
    });
}

function childrenAnchorsExist(childrenArr) {
    var childComp = _.head(childrenArr);
    return !!_.get(childComp, 'layout.anchors');
}

/**
 * @exports utils/dataFixer/plugins/wrongAnchorsFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        var structureData = pageJson.structure;
        var desktopChildrenPropertyName = 'components';
        if (structureData) {
            if (structureData.type === 'Document') {
                //TODO: update the server to add id to the document node
                structureData = _.clone(pageJson.structure);
                structureData.id = 'masterPage';
                pageJson.structure = structureData;
                desktopChildrenPropertyName = 'children';
            }
            if (childrenAnchorsExist(structureData[desktopChildrenPropertyName])) {
                fixAnchorsForPageAndChildren(structureData, desktopChildrenPropertyName);
            }
            if (childrenAnchorsExist(structureData.mobileComponents)) {
                fixAnchorsForPageAndChildren(structureData, 'mobileComponents');
                anchorCyclesHelper.fixBottomTopBottomBottomCycles(structureData.mobileComponents);
            }
        }
    }
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function degreesToRadians(angleInDegrees) {
    return angleInDegrees * Math.PI / 180;
}

function getBoundingHeight(layout) {
    if (!layout.rotationInDegrees) {
        return layout.height;
    }
    var currentAngleInRadians = degreesToRadians(layout.rotationInDegrees);
    return parseInt(Math.abs(layout.width * Math.sin(currentAngleInRadians)) + Math.abs(layout.height * Math.cos(currentAngleInRadians)), 10);
}

function getBoundingY(layout) {
    if (!layout.rotationInDegrees) {
        return layout.y;
    }
    var boundingHeight = getBoundingHeight(layout);
    return parseInt(layout.y - (boundingHeight - layout.height) / 2, 10);
}

function getLowestComp(comps) {
    return _.maxBy(comps, function (comp) {
        return getBoundingY(comp.layout);
    });
}

function removeInvalidAnchors(parts) {
    var pagesContainer = parts.pagesContainer;
    var header = parts.header;
    if (pagesContainer && header) {
        _.remove(pagesContainer.layout.anchors, { targetComponent: 'SITE_HEADER', type: 'TOP_TOP' });
        _.remove(header.layout.anchors, { targetComponent: 'PAGES_CONTAINER', type: 'TOP_TOP' });
    }
}

function addMissingAnchors(components, parts) {
    var pagesContainer = parts.pagesContainer;
    var header = parts.header;
    var footer = parts.footer;

    var sitePages = pagesContainer && pagesContainer.components && _.find(pagesContainer.components, { id: 'SITE_PAGES' });
    if (sitePages && sitePages.layout && (!sitePages.layout.anchors || sitePages.layout.anchors.length === 0)) {
        sitePages.layout.anchors = [{
            distance: 0,
            locked: true,
            originalValue: 0,
            targetComponent: 'PAGES_CONTAINER',
            type: 'BOTTOM_PARENT'
        }];
    }
    if (pagesContainer && pagesContainer.layout && (!pagesContainer.layout.anchors || pagesContainer.layout.anchors.length === 0) && footer && footer.layout && !footer.layout.fixedPosition) {
        pagesContainer.layout.anchors = [{
            distance: 10,
            locked: true,
            originalValue: 0,
            targetComponent: 'SITE_FOOTER',
            type: 'BOTTOM_TOP'
        }];
    }

    if (header) {
        var hasBottomParentAnchorToSiteStructure = _.find(components, function (component) {
            return _.find(component.layout.anchors, { type: 'BOTTOM_PARENT', targetComponent: 'masterPage' });
        });
        if (!hasBottomParentAnchorToSiteStructure) {
            var lowestComp = getLowestComp(components);
            if (!lowestComp.layout.anchors) {
                return;
            }
            lowestComp.layout.anchors.push({
                distance: 0,
                locked: true,
                originalValue: getBoundingY(lowestComp.layout) + getBoundingHeight(lowestComp.layout) + (header ? getBoundingHeight(header.layout) : 0),
                targetComponent: 'masterPage',
                type: 'BOTTOM_PARENT'
            });
        }
    }
}

function childrenAnchorsDeleted(childrenArr) {
    return !(childrenArr.length && childrenArr[0].layout && childrenArr[0].layout.anchors);
}

function findParts(components) {
    // Optimization: single _.forEach instead of three _.find
    var parts = {};
    _.forEach(components, function (component) {
        switch (component.id) {
            case 'SITE_HEADER':
                parts.header = component;
                return !(parts.footer && parts.pagesContainer);
            case 'SITE_FOOTER':
                parts.footer = component;
                return !(parts.header && parts.pagesContainer);
            case 'PAGES_CONTAINER':
                parts.pagesContainer = component;
                return !(parts.header && parts.footer);
            default:
                return true; // continue
        }
    });
    return parts;
}

function fixAnchors(components) {
    if (components && !_.isEmpty(components) && !childrenAnchorsDeleted(components)) {
        var parts = findParts(components);
        removeInvalidAnchors(parts);
        addMissingAnchors(components, parts);
    }
}

/**
 * @exports utils/dataFixer/plugins/addMissingAnchorsOfMasterPage
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        var structureData = pageJson.structure;
        if (!structureData || structureData.type !== 'Document') {
            return;
        }
        fixAnchors(structureData.children);
        fixAnchors(structureData.mobileComponents);
    },


    test: {
        getBoundingHeight: getBoundingHeight,
        getBoundingY: getBoundingY,
        getLowestComp: getLowestComp
    }
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function getSitePagesFromMasterPage(masterPage) {
    var sitePages = void 0;

    if (masterPage.structure.children) {
        var pageContainer = _.find(masterPage.structure.children, { id: 'PAGES_CONTAINER' });

        if (pageContainer && !_.isEmpty(pageContainer.components)) {
            sitePages = _.find(pageContainer.components, { id: 'SITE_PAGES' });
        }
    }

    return sitePages;
}

function getMobileSitePagesFromMasterPage(masterPage) {
    var mobileSitePages = void 0;

    if (masterPage.structure.mobileComponents) {
        var mobilePageContainer = _.find(masterPage.structure.mobileComponents, { id: 'PAGES_CONTAINER' });
        if (mobilePageContainer && !_.isEmpty(mobilePageContainer.components)) {
            mobileSitePages = _.find(mobilePageContainer.components, { id: 'SITE_PAGES' });
        }
    }

    return mobileSitePages;
}

function fixSitePagesContainsOnlyPages(sitePages) {
    if (!_.isEmpty(sitePages.components)) {
        sitePages.components = [];
    }
}

function fixSitePagesTop(sitePages) {
    if (sitePages.layout) {
        sitePages.layout.y = 0;
    }
}

/**
 * @exports utils/dataFixer/plugins/masterPageFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        if (pageJson.structure && pageJson.structure.type === 'Document') {
            //masterPage
            var sitePages = getSitePagesFromMasterPage(pageJson);
            var mobileSitePages = getMobileSitePagesFromMasterPage(pageJson);

            if (sitePages) {
                fixSitePagesContainsOnlyPages(sitePages);
                fixSitePagesTop(sitePages);
            }

            if (mobileSitePages) {
                fixSitePagesContainsOnlyPages(mobileSitePages);
                fixSitePagesTop(mobileSitePages);
            }
        }

        return pageJson;
    }
};

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);

/**
 * @exports utils/dataFixer/plugins/fiveGridLineLayoutFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        /***************************************************************************************************
         * This plugin is part of the link refactor (merged experiment: linkrefdata).                      *
         * It does 3 things:                                                                               *
         * 1. Convert link data items to new ones (with new schemas)                                       *
         * 2. Covert FlashComponent & SiteButton to new schemas (with new links like #1)                   *
         * 3. Fixes Image schema to support the new links and updates schema version (for server support)  *
         ***************************************************************************************************/

        //Handle cases that the DataFixer is running but the DataManager is not available yet.
        //This DataFixer plugin will be called again when the data DataManager is ready
        //(skipped JSONs will be fixed later)
        //                if(!window.W.Data) {
        //                    return pageJson;
        //                }

        var schemasNames = {
            toFix: ['FlashComponent', 'SiteButton', 'Image'],
            newNames: ['LinkableFlashComponent', 'LinkableButton', 'Image'], //Image keeps the schema name and updates the schema version
            originalLink: ['TextLink', 'Link']
        },
            linkDataAttributes = ['href', 'text', 'target', 'icon', 'linkType'],
            linkTargets = {
            oldValues: ['same', 'other'],
            newValues: ['_self', '_blank']
        };

        function filterSchemasToFix(items) {
            return _.filter(items, function (dataItem) {
                var isImage = dataItem.type === schemasNames.toFix[2];
                var isOldImageSchema = !isImage || dataItem.metaData.schemaVersion !== '2.0';

                return !dataItem.link && _.includes(schemasNames.toFix, dataItem.type) && isOldImageSchema;
            });
        }

        function filterLinkItemsToFix(items) {
            return _.filter(items, function (dataItem) {
                return dataItem.linkType && _.includes(schemasNames.originalLink, dataItem.type);
            });
        }

        function createItemFromNewSchema(dataItem) {
            var schemaIndex = _.indexOf(schemasNames.toFix, dataItem.type);
            var newSchemaName = schemasNames.newNames[schemaIndex];
            //Copy schema specific attributes from original data item (without old link attributes)
            var newDataItem = _.defaults({ type: newSchemaName }, _.omit(dataItem, linkDataAttributes));

            //Create a new link data item and add reference to it in the new data item
            var linkItem = createNewLinkItem(dataItem, true);
            if (linkItem) {
                newDataItem.link = createLinkRef(linkItem.id);
                newLinkDataItems[linkItem.id] = linkItem; //Save it to be added later to DataManager
            }

            //If the schema name wasn't changes (Image) - update the schema version
            if (dataItem.type === newDataItem.type) {
                newDataItem.metaData.schemaVersion = '2.0';
            }

            return newDataItem;
        }

        function createNewLinkItem(dataItem, shouldGetUniqueId) {
            var linkType = dataItem.linkType || '';
            var lowerCaseLinkType = linkType.toLowerCase();
            var id = shouldGetUniqueId ? createUniqueId() : dataItem.id;

            switch (lowerCaseLinkType) {
                case 'page':
                    return createPageLink(id, dataItem);
                case 'website':
                    return createExternalLink(id, dataItem);
                case 'email':
                    return createEmailLink(id, dataItem);
                case 'document':
                    return createDocumentLink(id, dataItem);
                case 'login':
                    return createLoginToWixLink(id, dataItem);
                case 'admin_login':
                    return null; //This link type is deprecated. AdminLoginButton component doesn't use it anymore
                case 'free_link':
                    return null; //Nothing to do with this link (used by eCom, wixapps handles them)
                case '':
                    return null; //Nothing to do (there is no link)
                default:
                    return null;
            }
        }

        function createExternalLink(uniqueLinkId, dataItem) {
            var linkItem = {};
            linkItem.id = uniqueLinkId;
            linkItem.type = 'ExternalLink';
            linkItem.target = getLinkTarget(dataItem.target);
            var url = dataItem.href;
            if (!url) {
                return null;
            }
            linkItem.url = url;
            return linkItem;
        }

        function createPageLink(uniqueLinkId, dataItem) {
            var linkItem = {};
            linkItem.id = uniqueLinkId;
            linkItem.type = 'PageLink';
            var url = dataItem.href;
            if (!url) {
                return null;
            }
            var indexOfPageId = url.lastIndexOf('/');
            if (indexOfPageId < 0) {
                indexOfPageId = url.lastIndexOf('|'); //Legacy sites
            }
            url = url.substr(indexOfPageId + 1);
            linkItem.pageId = createLinkRef(url);
            return linkItem;
        }

        function createDocumentLink(uniqueLinkId, dataItem) {
            var linkItem = {};
            var docId = void 0;
            linkItem.type = 'DocumentLink';
            linkItem.id = uniqueLinkId;
            var docURL = dataItem.href;
            if (!docURL) {
                return null;
            }
            docId = docURL.substr(docURL.lastIndexOf('/') + 1);

            var queryParamStartIndex = docId.indexOf('?dn=');
            if (queryParamStartIndex !== -1) {
                docId = docId.substring(0, queryParamStartIndex);
            }
            linkItem.docId = docId;

            linkItem.name = dataItem.text;
            return linkItem;
        }

        function createEmailLink(uniqueLinkId, dataItem) {
            var linkItem = {};
            linkItem.id = uniqueLinkId;
            linkItem.type = 'EmailLink';
            var url = dataItem.href;
            if (!url || !url.toLowerCase) {
                return null;
            }
            if (coreUtils.stringUtils.startsWith(url, 'mailto:', true)) {
                url = url.substr('mailto:'.length);
            }
            var emailAndParams = url.split('?');
            linkItem.recipient = emailAndParams[0];
            if (emailAndParams[1]) {
                var params = parseUrlParams(emailAndParams[1]);
                if (params.subject) {
                    linkItem.subject = params.subject;
                }
                if (params.body) {
                    linkItem.body = params.body;
                }
            }

            return linkItem;
        }

        function createLoginToWixLink(uniqueLinkId, dataItem) {
            var linkItem = {};
            linkItem.id = uniqueLinkId;
            linkItem.type = 'LoginToWixLink';

            var loginParams = dataItem.text;
            if (loginParams && coreUtils.stringUtils.startsWith(loginParams, '{')) {
                loginParams = JSON.parse(loginParams);
                linkItem.postLoginUrl = loginParams.postLoginUrl;
                linkItem.postSignupUrl = loginParams.postSignupUrl;
                linkItem.dialog = loginParams.type;
            }

            return linkItem;
        }

        function createLinkRef(linkId) {
            if (!linkId) {
                return null;
            }
            if (linkId && coreUtils.stringUtils.startsWith(linkId, '#')) {
                return linkId;
            }
            return '#' + linkId;
        }

        function getLinkTarget(oldTarget) {
            var newTarget = void 0;
            var oldTargetsIndex = _.indexOf(linkTargets.oldValues, oldTarget);

            if (_.includes(linkTargets.newValues, oldTarget)) {
                newTarget = oldTarget;
            } else if (oldTargetsIndex !== -1) {
                newTarget = linkTargets.newValues[oldTargetsIndex]; //The the corresponding new target value
            } else {
                newTarget = linkTargets.newValues[1]; //fallback - _blank target
            }

            return newTarget;
        }

        function parseUrlParams(paramsStr) {
            var mailParamsObj = {};
            var keyValueRegEx = /([^&=]+)=([^&]*)/g;
            var tmp = void 0;

            //Extract all key-value pairs (format: key=value) from the mail parameters string
            while (tmp = keyValueRegEx.exec(paramsStr)) {
                // eslint-disable-line no-cond-assign
                mailParamsObj[tmp[1]] = tmp[2];
            }

            return mailParamsObj;
        }

        function createUniqueId() {
            var existingIds = _.keys(pageJson.data.document_data);
            var id = void 0;

            do {
                id = new Date().getTime().toString(36) + '_' + Math.round(Math.random() * 99999).toString(36);
                id = id.replace(/\s/g, '_');
            } while (existingIds[id]);

            return id;
        }

        var data = pageJson.data;
        var dataItems = data.document_data;
        var newLinkDataItems = {};
        var dataItemsToFix = void 0;

        //Fix (convert) schemas to 'linkable' schemas
        dataItemsToFix = filterSchemasToFix(dataItems);
        _.forEach(dataItemsToFix, function (dataItem) {
            var newDataItem = createItemFromNewSchema(dataItem);
            if (newDataItem) {
                dataItems[dataItem.id] = newDataItem; //Override the existing data item with the new one (same ID)
                //                        markDataItemAsDirty(dataItem.id);
            }
        });

        //Fix (convert) links data items (create new link data items with same id and replace the original)
        dataItemsToFix = filterLinkItemsToFix(dataItems);
        _.forEach(dataItemsToFix, function (dataItem) {
            var newLinkDataItem = createNewLinkItem(dataItem);
            if (newLinkDataItem) {
                dataItems[dataItem.id] = newLinkDataItem;

                //Don't mark the converted links as dirty because they are not referenced and will be deleted
                //by the server GC in the next save.
            }
        });

        //NOTE: when we start to work with 'dirty' data items, we should probably mark the newLinkDataItems as dirty later, so that they will be saved in the document data
        _.assign(dataItems, newLinkDataItems);
    }
};

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @exports utils/dataFixer/plugins/fromDocumentToThemeData
 * @type {{exec: exec}}
 */

module.exports = {
    exec: function exec(pageJson) {
        var data = pageJson.data;
        if (data.document_data.THEME_DATA) {
            if (!data.theme_data.THEME_DATA) {
                data.theme_data.THEME_DATA = data.document_data.THEME_DATA;
            }
            delete data.document_data.THEME_DATA;
        }
    }
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var TPA_GLUED_WIDGET_COMP_TYPE = 'wysiwyg.viewer.components.tpapps.TPAGluedWidget';

var MASTER_PAGE_ID = 'masterPage';

function fixComponentsLayoutFixedPosition(pageJson) {
    _.forEach(pageJson.structure.children, function (compStructure) {
        //eslint-disable-line lodash/prefer-filter
        if (compStructure.componentType === TPA_GLUED_WIDGET_COMP_TYPE) {
            compStructure.layout.fixedPosition = true;
        }
    });
}

module.exports = {
    /*
     * Add a 'fixedPosition: true' property to glued widgets' layout
     */
    exec: function exec(pageJson) {
        if (_.get(pageJson, 'structure.id') === MASTER_PAGE_ID) {
            fixComponentsLayoutFixedPosition(pageJson);
        }
    }
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);

var TPA_GLUED_WIDGET_COMP_TYPE = 'wysiwyg.viewer.components.tpapps.TPAGluedWidget';
var WIX_CHAT_APPDEF_ID = '14517e1a-3ff0-af98-408e-2bd6953c36a2';
var WIDGET_ID = '14517f3f-ffc5-eced-f592-980aaa0bbb5c';

var MASTER_PAGE_ID = 'masterPage';
var _state = { lastGeneratedId: undefined, counter: 0 };

function setComponentData(pageJson, comp, dataItem) {
    var newId = coreUtils.guidUtils.getUniqueId('dataItem', '-');

    comp.dataQuery = '#' + newId;
    dataItem.id = newId;
    pageJson.data.document_data[newId] = dataItem;
}

function addWixChatToDesktopStructure(clientSpecMap, pageJson) {
    var appData = _.find(clientSpecMap, { appDefinitionId: WIX_CHAT_APPDEF_ID });
    if (appData) {
        var widgetDataItems = getWidgetsCompAndData(pageJson, appData.applicationId);
        _.forEach(widgetDataItems, function (widget) {
            var widgetData = widget.data;
            var widgetIds = _.keys(widgetData.widgets);
            if (widgetData.applicationId !== appData.applicationId || !_.includes(widgetIds, widgetData.widgetId)) {
                setComponentData(pageJson, widget.comp, _.assign(widgetData, {
                    applicationId: appData.applicationId,
                    widgetId: WIDGET_ID
                }));
            }
        });

        if (!isAppPermissionsRevoked(appData) && !widgetDataItems.length) {
            var widgetData = _.get(appData, 'widgets.' + WIDGET_ID);
            var compId = getUniqueId('comp', '-');
            var dataId = getUniqueId('dataItem', '-');
            var propId = getUniqueId('propItem', '-');
            var widgetStructure = getWidgetStructure(compId, dataId, propId, widgetData);
            pageJson.structure.children.push(widgetStructure);
            pageJson.data.document_data[dataId] = getWidgetData(appData, dataId);
            pageJson.data.component_properties[propId] = getWidgetProperties(widgetData);
            if (!pageJson.data.theme_data[widgetStructure.styleId]) {
                pageJson.data.theme_data[widgetStructure.styleId] = getGluedWidgetStyle(widgetStructure.styleId);
            }
        }
    }
}

function getWidgetStructure(compId, dataId, propId, widgetLayoutData, styleId) {
    return {
        type: 'Component',
        styleId: styleId || 'tpagw0',
        id: compId,
        dataQuery: '#' + dataId,
        skin: 'wysiwyg.viewer.skins.TPAWidgetSkin',
        layout: {
            width: _.get(widgetLayoutData, 'defaultWidth') || 320,
            height: _.get(widgetLayoutData, 'defaultHeight') || 250,
            x: _.get(widgetLayoutData, 'x') || 0,
            y: _.get(widgetLayoutData, 'y') || 0,
            scale: 1,
            rotationInDegrees: 0,
            fixedPosition: _.get(widgetLayoutData, 'fixedPosition') || true
        },
        propertyQuery: propId,
        componentType: 'wysiwyg.viewer.components.tpapps.TPAGluedWidget'
    };
}

function getWixChatGluedTPAStructure(desktopId, dataItemQuery, propertyItemQuery, styleId) {
    dataItemQuery = removeHashIfExists(dataItemQuery);
    propertyItemQuery = removeHashIfExists(propertyItemQuery);
    var widgetLayoutData = {
        x: 10, y: 10,
        width: 0, height: 5,
        fixedPosition: false
    };
    return getWidgetStructure(desktopId, dataItemQuery, propertyItemQuery, widgetLayoutData, styleId);
}

function getWidgetData(appData, dataId) {
    return {
        type: 'TPAWidget',
        id: dataId,
        metaData: {
            isPreset: false,
            schemaVersion: '1.0',
            isHidden: false
        },
        applicationId: appData.applicationId,
        widgetId: WIDGET_ID
    };
}

function getWidgetProperties(widgetData) {
    return {
        type: 'TPAGluedProperties',
        metaData: {
            schemaVersion: '1.0'
        },
        placement: _.get(widgetData, 'gluedOptions.placement'),
        verticalMargin: _.get(widgetData, 'gluedOptions.verticalMargin'),
        horizontalMargin: _.get(widgetData, 'gluedOptions.horizontalMargin')
    };
}

function getGluedWidgetStyle(styleId) {
    return {
        type: 'TopLevelStyle',
        styleType: 'system',
        compId: '',
        componentClassName: 'wysiwyg.viewer.components.tpapps.TPAGluedWidget',
        pageId: '',
        skin: 'wysiwyg.viewer.skins.TPAWidgetSkin',
        style: {
            groups: {},
            properties: {},
            propertiesSource: {}
        },
        id: styleId,
        metaData: {
            isPreset: false,
            schemaVersion: '1.0',
            isHidden: false
        }
    };
}

function getWidgetsCompAndData(pageJson, applicationId) {
    return _(pageJson.structure.children).filter(function (comp) {
        if (!comp.dataQuery) {
            return false;
        }
        var data = pageJson.data.document_data[comp.dataQuery.replace('#', '')];
        return _.get(data, 'widgetId') === WIDGET_ID || _.get(data, 'applicationId') === applicationId;
    }).map(function (comp) {
        return {
            comp: comp,
            data: pageJson.data.document_data[comp.dataQuery.replace('#', '')]
        };
    }).value();
}

function isAppPermissionsRevoked(appData) {
    return _.get(appData, 'permissions.revoked') === true;
}

function getUniqueId(prefix, prefixDelimiter) {
    return _getUniqueId(_state, prefix, prefixDelimiter, Date.now());
}

function _getUniqueId(state, prefix, prefixDelimiter, dateNow) {
    prefix = prefix || '';
    prefixDelimiter = prefixDelimiter || '';
    var value = dateNow;
    if (value === state.lastGeneratedId) {
        state.counter++;
    } else {
        state.lastGeneratedId = value;
        state.counter = 0;
    }
    return prefix + prefixDelimiter + Number(state.lastGeneratedId).toString(36) + (state.counter || '');
}

function fixMissingWixChatTPAOnMasterPageMobile(pageJson, clientSpecMap) {
    var wixChatAppData = _.find(clientSpecMap, { appDefinitionId: WIX_CHAT_APPDEF_ID });
    var isWidgetAlreadyAdded = getWidgetsCompAndData(pageJson).length > 0;
    var shouldAddWixChatTPA = pageJson && pageJson.structure.id === MASTER_PAGE_ID && wixChatAppData && !_.get(wixChatAppData, 'permissions.revoked') && isWidgetAlreadyAdded && hasWixChatTPAInPageStructure(pageJson.data, pageJson.structure.children, wixChatAppData) && !hasWixChatTPAInPageStructure(pageJson.data, pageJson.structure.mobileComponents, wixChatAppData);

    if (shouldAddWixChatTPA) {
        var desktopComp = getWixChatComponentFromStructure(pageJson.data.document_data, pageJson.structure.children, wixChatAppData);
        addWixChatTPAGluedWidgetToMobileStructure(pageJson, desktopComp);
    }
}

function hasWixChatTPAInPageStructure(pageData, compsInStructure, appData) {
    return !!getWixChatComponentFromStructure(pageData.document_data, compsInStructure, appData);
}

function getWixChatComponentFromStructure(documentData, compsInStructure, appData) {
    var desktopChildren = [].concat(compsInStructure);
    while (!_.isEmpty(desktopChildren)) {
        var component = desktopChildren.shift();
        if (component.componentType === TPA_GLUED_WIDGET_COMP_TYPE) {
            var compData = documentData[removeHashIfExists(component.dataQuery)];
            if (Number(compData.applicationId) === Number(appData.applicationId)) {
                return component;
            }
        }
        if (!_.isEmpty(component.components)) {
            desktopChildren = desktopChildren.concat(component.components);
        }
    }
    return null;
}

function removeHashIfExists(value) {
    return value && value[0] === '#' ? value.substr(1) : value;
}

function addWixChatTPAGluedWidgetToMobileStructure(pageJson, desktopComp) {
    var mobileComps = pageJson.structure.mobileComponents;
    var footer = _.find(mobileComps, { id: 'SITE_FOOTER' });
    var dataItemQuery = desktopComp.dataQuery;
    var propertyItemQuery = desktopComp.propertyQuery;
    var styleId = desktopComp.styleId;
    if (footer && _.isArray(footer.components)) {
        footer.components.push(getWixChatGluedTPAStructure(desktopComp.id, dataItemQuery, propertyItemQuery, styleId));
    } else {
        // landing pages
        mobileComps.push(getWixChatGluedTPAStructure(desktopComp.id, dataItemQuery, propertyItemQuery, styleId));
    }
}

module.exports = {
    /*
     * Add the wix chat app to the site if exists in clientSpecMap
     */
    exec: function exec(pageJson, pageIdsArray, requestModel, currentUrl, urlFormatModel, isViewerMode, rendererModel, magicObject) {
        var clientSpecMap = _.get(magicObject, 'clientSpecMap');
        if (pageJson.structure.id === 'masterPage') {
            addWixChatToDesktopStructure(clientSpecMap, pageJson);

            var isMABInstalled = _.get(magicObject, 'quickActionsMenuEnabled');
            if (_.get(pageJson, 'structure.id') === MASTER_PAGE_ID && !isMABInstalled) {
                fixMissingWixChatTPAOnMasterPageMobile(pageJson, clientSpecMap);
            }
        }
    }
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var PRO_GALLERY_APP_DEF_ID = '14271d6f-ba62-d045-549b-ab972ae1f70e';
var PRO_GALLERY_FULL_SCREEN_WIDGET_ID = '144f04b9-aab4-fde7-179b-780c11da4f46';
var PRO_GALLERY_TPA_PAGE_ID = 'fullscreen_page';

var NON_EXISTING_STYLE_ID = 'non_existing_style_id';

var TPA_MULTI_SECTION_COMP_TYPE = 'wysiwyg.viewer.components.tpapps.TPAMultiSection';

function getBlankBackground() {
    return {
        type: 'BackgroundMedia',
        color: 'transparent',
        alignType: 'center',
        fittingType: 'fill',
        scrollType: 'none',
        mediaRef: null
    };
}

function handleFixInViewer(pageJson, proGalleryApplicationId) {
    var pageId = _.get(pageJson, 'structure.id');
    var pageData = _.get(pageJson, ['data', 'document_data', pageId]);
    var tpaPageId = _.get(pageData, 'tpaPageId');
    var tpaApplicationId = _.get(pageData, 'tpaApplicationId');
    if (tpaPageId === PRO_GALLERY_TPA_PAGE_ID && tpaApplicationId === proGalleryApplicationId) {
        updateBackground(pageData, pageJson, 'desktop');
        updateBackground(pageData, pageJson, 'mobile');
        pageJson.structure.styleId = NON_EXISTING_STYLE_ID;
    }
}

function updateBackground(pageData, pageJson, viewMode) {
    var backgroundRef = _.get(pageData, 'pageBackgrounds.' + viewMode + '.ref');
    backgroundRef = _.replace(backgroundRef, '#', '');
    var backgroundData = _.get(pageJson, ['data', 'document_data', backgroundRef]);
    if (backgroundData) {
        _.merge(backgroundData, getBlankBackground());
    }
}

function handleFixInEditor(pageJson, proGalleryApplicationId) {
    var pageId = _.get(pageJson, 'structure.id');

    if (pageId === 'masterPage') {
        var masterPageData = _.get(pageJson, 'data.document_data');
        var pageData = _.find(masterPageData, { tpaApplicationId: proGalleryApplicationId, tpaPageId: PRO_GALLERY_TPA_PAGE_ID });
        if (pageData) {
            updateBackground(pageData, pageJson, 'desktop');
            updateBackground(pageData, pageJson, 'mobile');
        }
    } else {
        handleNonMasterPageFixInEditor(pageJson);
    }
}

function handleNonMasterPageFixInEditor(pageJson) {
    var pageDirectComponents = _.get(pageJson, ['structure', 'components']);
    var TPAMultiSectionComponent = _.find(pageDirectComponents, { componentType: TPA_MULTI_SECTION_COMP_TYPE });
    if (TPAMultiSectionComponent) {
        var compDataQuery = TPAMultiSectionComponent.dataQuery.replace('#', '');
        var tpaComponentWidgetId = _.get(pageJson, ['data', 'document_data', compDataQuery, 'widgetId']);
        if (tpaComponentWidgetId === PRO_GALLERY_FULL_SCREEN_WIDGET_ID) {
            pageJson.structure.styleId = NON_EXISTING_STYLE_ID;
        }
    }
}

function getProGalleryApplicationId(clientSpecMap) {
    var appData = _.find(clientSpecMap, { appDefinitionId: PRO_GALLERY_APP_DEF_ID });
    return _.get(appData, 'applicationId');
}

module.exports = {
    /*
     * fix pro gallery full screen page to have a blank background to avoid the site background image flashing before the iframe loads
     * Need to update background data on both master page and the actual page due to differences in data location between editor and viewer
     */
    exec: function exec(pageJson, pageIdsArray, requestModel, currentUrl, urlFormatModel, isViewerMode, rendererModel, magicObject) {
        var proGalleryApplicationId = getProGalleryApplicationId(magicObject.clientSpecMap);
        if (proGalleryApplicationId) {
            if (magicObject.isViewerMode) {
                handleFixInViewer(pageJson, proGalleryApplicationId);
            } else if (magicObject.isExperimentOpen('se_proGalleryBGDataFixer')) {
                handleFixInEditor(pageJson, proGalleryApplicationId);
            }
        }
    }
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var fixers = __webpack_require__(3);

var migrationFunctions = {
    'BgImageStripProperties': function BgImageStripProperties(property) {
        property.fittingType = fixers.cssToFittingType({
            bgSize: property.bgSize,
            bgRepeat: property.bgRepeat
        });
        property.fittingType = fixers.migrateToLegacyFittings(property.fittingType);
        property.alignType = fixers.cssToAlignType(property.bgPosition);
        property.type = 'BgImageStripUnifiedProperties';

        delete property.bgSize;
        delete property.bgRepeat;
        delete property.bgPosition;
        delete property.bgUrl;
    }
};

function fixProperties(properties) {
    _.forEach(properties, function (property) {
        var migrationFunction = migrationFunctions[property.type];
        if (migrationFunction) {
            migrationFunction(property);
        }
    });
}

/**
 * @exports utils/dataFixer/plugins/backgroundsDataFixer
 * @type {{exec: function}}
 */
module.exports = {
    exec: function exec(pageJson) {
        var properties = pageJson.data.component_properties;
        if (!_.isEmpty(properties)) {
            fixProperties(properties);
        }
    }
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var apps = {
    faq: {
        filterAppPart: {
            appPartName: 'f2c4fc13-e24d-4e99-aadf-4cff71092b88',
            viewName: 'ExpandQuestions'
        },
        filterAppLogicCustomization: {
            type: 'AppPartCustomization',
            forType: 'Category',
            view: 'ToggleMobile',
            key: 'comp.initialState',
            fieldId: 'toggle',
            format: 'Mobile'
        },
        modify: function modify(customization) {
            return _.assign(customization, {
                fieldId: 'vars',
                key: 'initialState'
            });
        }
    }
};

function exec(pageJson) {
    _(apps).values().forEach(function (app) {
        _(pageJson.data.document_data).filter(app.filterAppPart).forEach(function (part) {
            part.appLogicCustomizations = _(part.appLogicCustomizations).map(function (customization) {
                var shouldModify = _.find([customization], app.filterAppLogicCustomization);
                return shouldModify ? app.modify(customization) : customization;
            }).compact().value();
        });
    });
}

module.exports = {
    exec: exec
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var fixers = __webpack_require__(3);
var coreUtils = __webpack_require__(1);
var imageClientApi = __webpack_require__(7);

var BG_MEDIA_TYPE = 'BackgroundMedia';
var BG_IMAGE_TYPE = 'BackgroundImage';
//var BG_OLD_PREFIX = 'customBgImg';
var BG_IMAGE_PREFIX = 'bgImage';
var BG_MEDIA_PREFIX = 'mediaBg';
var BG_DATA_DELIMITER = '-';

/**
 * Create BackgroundMedia Items on MasterPage
 * @param {object} theme
 * @param {object} masterPageData
 */
function createBackgroundMediaOnMaster(masterPageData, theme) {
    // Pages data items from master page
    var pageDataItems = _.filter(masterPageData, function (item) {
        return item.type === 'Page' || item.type === 'AppPage';
    });
    var pageIds = _.map(pageDataItems, 'id');
    var hasBgImage = _.some(pageDataItems, function (item) {
        return item.pageBackgrounds && item.pageBackgrounds.desktop.ref;
    });

    if (hasBgImage) {
        convertBgImageToBgMediaItems(masterPageData);
    } else {
        var fallbackThemeDesktopBg = theme.siteBg;
        var fallbackThemeMobileBg = !theme.mobileBg || theme.mobileBg === '[siteBg]' ? theme.siteBg : theme.mobileBg;
        createBgDataFromTheme(masterPageData, fallbackThemeDesktopBg, fallbackThemeMobileBg, pageIds);
    }
}

/**
 * Create BackgroundMedia items on Page (if there were BackgroundImage items before)
 * @param {object} pageData page.data.document_data
 */
function createBackgroundMediaOnPages(pageData) {
    convertBgImageToBgMediaItems(pageData);
}

/**
 * Covert all BackgroundImage items to BackgroundMedia items
 * @param {object} data masterPage.data.document_data or page.data.document_data
 */
function convertBgImageToBgMediaItems(data) {
    var backgroundImageDataItems = _.filter(data, { type: BG_IMAGE_TYPE });
    _.forEach(backgroundImageDataItems, function (item) {
        convertBgImageToBgMediaItem(data, item);
    });
}

/**
 * Covert a single BackgroundImage item to BackgroundMedia item
 * @param {object} data masterPage.data.document_data or page.data.document_data
 * @param {object} backgroundImageItem
 */
function convertBgImageToBgMediaItem(data, backgroundImageItem) {
    var bgId = backgroundImageItem.id;
    var imageId = coreUtils.guidUtils.getUniqueId(BG_IMAGE_PREFIX + BG_DATA_DELIMITER);
    var backgroundMediaItem = generateDataItemsFromBgImageData(backgroundImageItem);
    addBgMediaItemsToData(data, backgroundMediaItem, bgId, imageId);
}

/**
 * Add converted BackgroundMedia to the page/master page data
 * @param {object} data masterPage.data.document_data or page.data.document_data
 * @param {object} backgroundMediaItem
 * @param {string} bgId
 * @param {string} imageId
 */
function addBgMediaItemsToData(data, backgroundMediaItem, bgId, imageId) {
    data[bgId] = _.assign({ id: bgId }, backgroundMediaItem.bgItem);
    if (backgroundMediaItem.imageItem) {
        data[bgId].mediaRef = '#' + imageId;
        data[imageId] = _.assign({ id: imageId }, backgroundMediaItem.imageItem);
    }
}

/**
 * Use the theme siteBg data to generate the BackgroundMedia data items
 * @param {object} masterPageData masterPage.data.document_data
 * @param {array} pageIds page ids from siteAsJson.masterPage.data.document_data
 * @param {string} themeDesktopBg siteBg string from siteAsJson.masterPage.data.theme_data.THEME_DATA
 * @param {string} themeMobileBg mobileBg string from siteAsJson.masterPage.data.theme_data.THEME_DATA
 * @param {Array} pageIds
 */
function createBgDataFromTheme(masterPageData, themeDesktopBg, themeMobileBg, pageIds) {
    var desktopBackgroundItems = generateDataItemsFromBgString(themeDesktopBg);
    var mobileBackgroundItems = generateDataItemsFromBgString(themeMobileBg);

    _.forEach(pageIds, function (pageId) {
        var desktopBgId = coreUtils.guidUtils.getUniqueId(BG_MEDIA_PREFIX, BG_DATA_DELIMITER);
        var mobileBgId = coreUtils.guidUtils.getUniqueId(BG_MEDIA_PREFIX, BG_DATA_DELIMITER);
        var desktopImageId = desktopBgId.replace(BG_MEDIA_PREFIX, BG_IMAGE_PREFIX);
        var mobileImageId = mobileBgId.replace(BG_MEDIA_PREFIX, BG_IMAGE_PREFIX);

        setBgToPage(masterPageData, desktopBackgroundItems, pageId, desktopBgId, desktopImageId, 'desktop');
        setBgToPage(masterPageData, mobileBackgroundItems, pageId, mobileBgId, mobileImageId, 'mobile');
    });
}

/**
 * Set BackgroundMedia to a page while recycling old BackgroundImage data id
 * @param {object} data masterPage.data.document_data or page.data.document_data
 * @param {object} bgDataItems the generated data items
 * @param {string} pageId page id
 * @param {string} bgId old BackgroundImage id
 * @param {string} imageId  Image id
 * @param {string} device 'mobile' or 'desktop'
 */
function setBgToPage(data, bgDataItems, pageId, bgId, imageId, device) {
    data[pageId].pageBackgrounds = data[pageId].pageBackgrounds || { desktop: '', mobile: '' };
    data[pageId].pageBackgrounds[device] = { ref: '#' + bgId, custom: true, isPreset: false };
    addBgMediaItemsToData(data, bgDataItems, bgId, imageId);
}

/**
 * create BackgroundMedia item from theme siteBg string
 * @param {string} bgString theme siteBg string
 * @returns {{bgItem:object, imageItem:object|undefined}}
 */
function generateDataItemsFromBgString(bgString) {
    var bgObject = getBgObjectFromOldValues.apply(this, _.compact(bgString.split(' ')));
    return generateDataItemsFromBg(bgObject);
}

/**
 * create BackgroundMedia item from BackgroundImage Data
 * @param {string} bgString theme siteBg string
 * @returns {{bgItem:object, imageItem:object|undefined}}
 */
function generateDataItemsFromBgImageData(data) {
    var bgObject = getBgObjectFromOldValues.apply(this, [data.url, data.imagesizew, data.imagesizeh, data.positionx, data.positiony, data.width, data.repeatx, data.repeaty, data.attachment, data.color, data.metaData
    //data.id
    ]);
    return generateDataItemsFromBg(bgObject);
}

/**
 * Helper function to convert bg array to object
 * @param imageId
 * @param imageW
 * @param imageH
 * @param x
 * @param y
 * @param width
 * @param repeatX
 * @param repeatY
 * @param attachment
 * @param color
 * @returns {{imageId: *, imageW: *, imageH: *, x: *, y: *, width: *, repeatX: *, repeatY: *, attachment: *, color: *}}
 */
function getBgObjectFromOldValues(imageId, imageW, imageH, x, y, width, repeatX, repeatY, attachment, color, metaData) {
    metaData = metaData || {};
    return {
        imageId: imageId,
        imageW: imageW,
        imageH: imageH,
        x: x,
        y: y,
        width: width,
        repeatX: repeatX,
        repeatY: repeatY,
        attachment: attachment,
        color: color,
        metaData: {
            isPreset: metaData.isPreset || false,
            schemaVersion: '2.0',
            isHidden: metaData.isHidden || false
        }
    };
}

/**
 * Build the data items for our background
 * @param {object} bgObject
 * @returns {{bgItem:object, imageItem:object|undefined}}
 */
function generateDataItemsFromBg(bgObject) {
    var dataItems = { bgItem: {} };
    var color = 'rgb(255,255,255)';
    var alignType = fixers.cssToAlignType(bgObject.x + ' ' + bgObject.y);
    var fittingType = fixers.cssToFittingType({
        bgRepeat: bgObject.repeatX + ' ' + bgObject.repeatY,
        bgSize: bgObject.width
    });
    var scrollType = bgObject.attachment === 'fixed' ? 'fixed' : 'scroll';

    fittingType = getLegacyFittingTypes(fittingType);

    if (bgObject.color && bgObject.color !== 'none') {
        color = bgObject.color;
    }

    if (bgObject.imageId && bgObject.imageId !== 'none') {
        dataItems.imageItem = {
            type: 'Image',
            uri: bgObject.imageId,
            width: parseInt(bgObject.imageW, 10),
            height: parseInt(bgObject.imageH, 10),
            metaData: {
                isPreset: false,
                schemaVersion: '1.0',
                isHidden: false
            }
        };
    }

    dataItems.bgItem = {
        type: 'BackgroundMedia',
        color: color,
        alignType: alignType,
        fittingType: fittingType,
        scrollType: scrollType,
        metaData: bgObject.metaData
    };

    return dataItems;
}

/**
 * HTML-Client background has some annoying fitting type combos, we need to support them.
 * @param fittingType
 * @returns {string}
 */
function getLegacyFittingTypes(fittingType) {
    // Legacy map for backgrounds from old editor.
    var legacyBgTypesMap = {};
    legacyBgTypesMap[imageClientApi.fittingTypes.TILE] = imageClientApi.fittingTypes.LEGACY_BG_FIT_AND_TILE;
    legacyBgTypesMap[imageClientApi.fittingTypes.TILE_HORIZONTAL] = imageClientApi.fittingTypes.LEGACY_BG_FIT_AND_TILE_HORIZONTAL;
    legacyBgTypesMap[imageClientApi.fittingTypes.TILE_VERTICAL] = imageClientApi.fittingTypes.LEGACY_BG_FIT_AND_TILE_VERTICAL;
    legacyBgTypesMap[imageClientApi.fittingTypes.LEGACY_ORIGINAL_SIZE] = imageClientApi.fittingTypes.LEGACY_BG_NORMAL;

    return legacyBgTypesMap[fittingType] || fittingType;
}

function fixCorruptedBG(theme) {
    theme.siteBg = fixBgData(theme.siteBg);
    if (theme.mobileBg && theme.mobileBg !== '[siteBg]') {
        theme.mobileBg = fixBgData(theme.mobileBg);
    }
}

function fixBgData(bgString) {
    var bgParts = _.compact(bgString.split(' '));
    var bgObject = getBgObjectFromOldValues.apply(this, bgParts);
    var color = bgObject.color;
    if (color) {
        color = color.replace('[', '{');
        color = color.replace(']', '}');
        bgParts[9] = color;
    }
    return bgParts.join(' ');
}

/**
 * @exports utils/dataFixer/plugins/backgroundMediaFixer
 * @type {{exec: function}}
 */
module.exports = {
    exec: function exec(pageJson) {
        if (!pageJson.structure) {
            return;
        }

        var theme = pageJson.data.theme_data && pageJson.data.theme_data.THEME_DATA;
        var data = pageJson.data.document_data;
        var hasBgMedia = _.some(data, { type: BG_MEDIA_TYPE });
        var hasBgImage = _.some(data, { type: BG_IMAGE_TYPE });

        if (hasBgMedia && !hasBgImage) {
            return;
        }

        if (pageJson.structure.type === 'Document') {
            fixCorruptedBG(theme);
            createBackgroundMediaOnMaster(data, theme);
        } else {
            createBackgroundMediaOnPages(data);
        }
    }
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);

var BG_MEDIA_TYPE = 'BackgroundMedia';

var BG_ITEM_TEMPLATE = {
    alignType: 'center',
    color: '{color_11}',
    fittingType: 'fill',
    scrollType: 'scroll',
    type: 'BackgroundMedia'
};

var PAGE_BACKGROUNDS_TEMPLATE = {
    pageBackgrounds: {
        desktop: {
            custom: true,
            isPreset: true,
            ref: null
        },
        mobile: {
            custom: true,
            isPreset: true,
            ref: null
        }
    }
};

function generateBgItemId(idPrefix, item) {
    return coreUtils.guidUtils.getUniqueId(item.id, '_') + idPrefix;
}

function addNewBgItem(id, pageData) {
    pageData[id] = _.assign({ id: id }, BG_ITEM_TEMPLATE);
}

/**
 * For each page, check if mobile bg is defined, and if not, fill in with a basic bg object.
 * @param pageData
 */
function fixUndefinedBackgroundMediaItems(pageData) {
    var pageDataItems = _.filter(pageData, function (item) {
        return item.type === 'Page' || item.type === 'AppPage';
    });

    _.forEach(pageDataItems, function (item) {
        var id = void 0;
        _.defaults(item, PAGE_BACKGROUNDS_TEMPLATE);

        if (!item.pageBackgrounds.mobile.ref) {
            id = generateBgItemId('_mobile_bg', item);
            addNewBgItem(id, pageData);
            item.pageBackgrounds.mobile.ref = '#' + id;
        }

        if (!item.pageBackgrounds.desktop.ref) {
            id = generateBgItemId('_desktop_bg', item);
            addNewBgItem(id, pageData);
            item.pageBackgrounds.desktop.ref = '#' + id;
        }
    });
}

/**
 * @exports utils/dataFixer/plugins/backgroundMediaFixer
 * @type {{exec: function}}
 */
module.exports = {
    exec: function exec(pageJson) {
        if (!pageJson.structure) {
            return;
        }

        var data = pageJson.data.document_data;
        var hasBgMedia = _.some(data, { type: BG_MEDIA_TYPE });

        // Run ONLY if we have at least one BackgroundMedia item
        if (hasBgMedia) {
            fixUndefinedBackgroundMediaItems(data);
        }
    }
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function addNewMediaItem(id, item, data) {
    data[id] = _.assign({ id: id }, _.omit(item, 'id'));
}

function getNewId(prefix, type, refName) {
    return prefix + '_' + type + '_' + refName;
}

/**
 *
 * @param mediaParent {{BackgroundMediaDataSchema}|{WixVideoDataSchema}} the media parent
 * @param ref {'mediaRef'|'imageOverlay'|'posterImageRef'} the reference attribute, one of: backgroundMedia: mediaRef
 * @param pageData {object} page data
 * @param prefix {string}
 */
function duplicateAndReferenceMediaItem(mediaParent, ref, type, pageId, pageDocumentData) {
    if (mediaParent[ref].indexOf('#' + pageId) === 0) {
        return;
    }
    var media = _.cloneDeep(pageDocumentData[mediaParent[ref].replace('#', '')]);
    var newId = getNewId(pageId, type, ref);
    addNewMediaItem(newId, media, pageDocumentData);
    mediaParent[ref] = '#' + newId;
}

/**
 *
 * @param type {string} 'mobile'|'desktop'
 * @param pageBgItem
 * @param pageData
 */
function setBackgroundMediaRefPerDevice(type, pageData, pageDocumentData) {
    var bgRef = pageData.pageBackgrounds[type].ref.replace('#', '');
    var bgItem = pageDocumentData[bgRef];
    var mediaItem = void 0;
    //we might not find the media data on master page
    if (bgItem && bgItem.mediaRef) {
        mediaItem = pageDocumentData[bgItem.mediaRef.replace('#', '')];

        if (mediaItem.type === 'WixVideo') {
            duplicateAndReferenceMediaItem(mediaItem, 'posterImageRef', type, pageData.id, pageDocumentData);
        }
        if (bgItem.imageOverlay) {
            duplicateAndReferenceMediaItem(bgItem, 'imageOverlay', type, pageData.id, pageDocumentData);
        }
        duplicateAndReferenceMediaItem(bgItem, 'mediaRef', type, pageData.id, pageDocumentData);
    }
}

/**
 * For each page background device, check if mediaRef is unique.
 * @param pageData
 * @returns {[{data:pageItem,type:'desktop'|'mobile'}]} of items that should be fixed
 */
function duplicatedBackgroundMediaItems(pageData, pageDocumentData) {
    if (pageData.pageBackgrounds) {
        setBackgroundMediaRefPerDevice('mobile', pageData, pageDocumentData);
        setBackgroundMediaRefPerDevice('desktop', pageData, pageDocumentData);
    }
}

/**
 * @exports utils/dataFixer/plugins/backgroundMediaRefDuplicationFixer
 * @type {{exec: function}}
 */
module.exports = {
    exec: function exec(pageJson) {
        if (!pageJson.structure) {
            return;
        }
        var documentData = pageJson.data.document_data;
        var pageDataItems = _.filter(documentData, function (item) {
            return item.type === 'Page' || item.type === 'AppPage';
        });

        _.forEach(pageDataItems, function (pageData) {
            duplicatedBackgroundMediaItems(pageData, documentData);
        });
    }
};

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var behaviorsMigrationHelper = __webpack_require__(5);

var compTypes = ['wysiwyg.viewer.components.StripContainer', 'wysiwyg.viewer.components.StripContainerSlideShowSlide'];

var effectsMap = {
    fixed: { action: 'bgScrub', name: 'BackgroundReveal', duration: 1, delay: 0 },
    parallax: { action: 'bgScrub', name: 'BackgroundParallax', duration: 1, delay: 0 }
};

function getCompBehaviors(comp, behaviorsData) {
    var behaviorsStr = _.get(behaviorsData, [comp.behaviorQuery, 'items'], '[]');
    return JSON.parse(behaviorsStr);
}

function getContainerBgData(comp, data) {
    // Get Data Item
    var dataRef = comp.designQuery.replace('#', '');
    var bgRef = data[dataRef].background.replace('#', '');
    return data[bgRef];
}

function changeScrollTypeToBehavior(comp, data, behaviorsData) {
    var behaviors = void 0;

    if (!_.includes(compTypes, comp.componentType)) {
        return;
    }

    var containerBgData = getContainerBgData(comp, data);
    var scrollType = containerBgData.scrollType;
    containerBgData.scrollType = 'none';

    // If scrollType === scroll just set to 'none' else add/or remove ContainerFixedBg behavior
    if (scrollType !== 'scroll' && scrollType !== 'none') {
        behaviors = getCompBehaviors(comp, behaviorsData);
        behaviors = _.reject(behaviors, { name: 'ContainerFixedBg', action: 'bgScrub' });
        behaviors.push(effectsMap[scrollType]);
        var behaviorsToSet = JSON.stringify(behaviors);

        if (comp.behaviorQuery) {
            _.set(behaviorsData, [comp.behaviorQuery, 'items'], behaviorsToSet);
        } else {
            var behaviorsDataItem = behaviorsMigrationHelper.createBehaviorsDataItem(behaviorsToSet);
            _.set(behaviorsData, behaviorsDataItem.id, behaviorsDataItem);
            comp.behaviorQuery = behaviorsDataItem.id;
        }
    }
}

function removeScrollTypeOldBehavior(comp, data, behaviorsData) {
    var behaviors = void 0;

    if (!_.includes(compTypes, comp.componentType)) {
        return;
    }

    var containerBgData = getContainerBgData(comp, data);
    containerBgData.scrollType = 'none';

    behaviors = getCompBehaviors(comp, behaviorsData);
    behaviors = _.reject(behaviors, { name: 'ContainerFixedBg', action: 'bgScrub' });
    if (_.isEmpty(behaviors)) {
        delete comp.behaviors;
        delete comp.behaviorQuery;
    } else {
        _.set(behaviorsData, [comp.behaviorQuery, 'items'], JSON.stringify(behaviors));
    }
}

function fixBackgroundEffect(comps, data, behaviorsData) {
    _.forEach(comps, function (comp) {
        changeScrollTypeToBehavior(comp, data, behaviorsData);
        if (comp.components) {
            fixBackgroundEffect(comp.components, data, behaviorsData);
        }
    });
}

function removeOldBackgroundEffect(comps, data, behaviorsData) {
    _.forEach(comps, function (comp) {
        removeScrollTypeOldBehavior(comp, data, behaviorsData);
        if (comp.components) {
            removeOldBackgroundEffect(comp.components, data, behaviorsData);
        }
    });
}

/**
 * @exports utils/dataFixer/plugins/behaviorsFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        var structureData = pageJson.structure;
        if (!structureData) {
            return;
        }

        var data = pageJson.data.design_data;
        var behaviorsData = pageJson.data.behaviors_data;

        //Page
        if (structureData.components) {
            fixBackgroundEffect(structureData.components, data, behaviorsData);
        }
        //MasterPage
        if (structureData.children) {
            fixBackgroundEffect(structureData.children, data, behaviorsData);
        }
        // Mobile - Remove!
        if (structureData.mobileComponents) {
            removeOldBackgroundEffect(structureData.mobileComponents, data, behaviorsData);
        }
    }
};

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

// CLNT-4002 - fix document media icon not showing due to storage url change

module.exports = {
    exec: function exec(pageJson) {
        if (pageJson.structure.type === 'Page') {
            var components = pageJson.structure.components;
            var compProps = pageJson.data.document_data;
            _.forEach(components, function (comp) {
                if (_.includes(comp.componentType, 'DocumentMedia')) {
                    var dataQuery = comp.dataQuery;
                    var docCompData = compProps[dataQuery.replace('#', '')];
                    if (docCompData.uri.indexOf('media/') === 0) {
                        docCompData.uri = docCompData.uri.replace('media/', '');
                    }
                }
            });
        }
        return pageJson;
    }
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function fixPinterestUrl(dataNode) {
    var url = 'www.pinterest.com/';
    dataNode.urlChoice = _.includes(dataNode.urlChoice, 'pinterest.com') ? dataNode.urlChoice : url + dataNode.urlChoice;
}

/**
* @exports utils/dataFixer/plugins/pinterestFollowFixer
* @type {{exec: exec}}
*/
module.exports = {
    exec: function exec(pageJson) {
        return _(pageJson.data.document_data).pickBy({ type: 'PinterestFollow' }).mapValues(fixPinterestUrl).value();
    }
};

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function moveSinglePostToTopLevel(masterPageData) {
    var singlePostPageId = findSinglePostPageMenuItem(masterPageData);
    if (singlePostPageId) {
        moveSinglePostToNewParent(masterPageData, '#' + singlePostPageId);
    }
}

function findSinglePostPageMenuItem(data) {
    var singlePostPageId = _.findKey(data, function (key) {
        return key.appPageId && key.appPageId === '7326bfbb-4b10-4a8e-84c1-73f776051e10';
    });

    if (!singlePostPageId) {
        return null;
    }

    var singlePostLinkId = _.findKey(data, function (key) {
        return key.pageId && key.pageId === '#' + singlePostPageId;
    });
    return _.findKey(data, function (key) {
        return key.link && key.link === '#' + singlePostLinkId;
    });
}

function moveSinglePostToNewParent(data, singlePostPageId) {
    var pagesIds = data.CUSTOM_MAIN_MENU && data.CUSTOM_MAIN_MENU.items;
    _.forEach(pagesIds, function (pageId) {
        var pageItems = data[pageId.replace('#', '')].items;
        var index = _.indexOf(pageItems, singlePostPageId);
        if (index !== -1) {
            pageItems.splice(index, 1);
            data.CUSTOM_MAIN_MENU.items.push(singlePostPageId);
            return false;
        }
    });
}

/**
 * @exports utils/dataFixer/plugins/blogPageMenuFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        if (pageJson.structure && pageJson.structure.type === 'Document') {
            moveSinglePostToTopLevel(pageJson.data.document_data);
        }
        return pageJson;
    }
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);

var appPartMediaInnerCustomizationFormatFixer = {
    exec: function exec(pageJson) {
        if (!pageJson.data || !pageJson.data.document_data) {
            return;
        }

        _(pageJson.data.document_data).filter(function (component) {
            return appPartMediaInnerCustomizationFormatFixer.isAppPartType(component.type);
        }).forEach(function (appPart) {
            _(appPart.appLogicCustomizations).compact().groupBy('view').filter(function (ignoredCustomizations, view) {
                return coreUtils.appPartMediaInnerViewNameUtils.isMediaInnerViewName(view);
            }).forEach(function (mediaInnerCustomizations) {
                _(mediaInnerCustomizations).groupBy('fieldId').filter(function (customizations) {
                    return _.isEqual(_.map(customizations, 'format'), ['']);
                }).forEach(function (desktopCustomizations) {
                    _.forEach(desktopCustomizations, function (customization) {
                        customization.format = '*';
                    });
                });
            });
        });
    },
    isAppPartType: function isAppPartType(type) {
        return type === 'AppPart';
    }
};

module.exports = appPartMediaInnerCustomizationFormatFixer;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);

/**
 * For each component data of a blog feed app part in a given page JSON, changes the format of affected "read more"
 * value customizations from "" to "*" and removes the corresponding unaffected customizations if any (to avoid
 * issues with having multiple customizations that differ in value).
 */
var fixer = {
    exec: function exec(pageJson) {
        if (!pageJson.data) {
            return;
        }

        _(pageJson.data.document_data).filter(function (componentData) {
            return componentData.type === fixer.getAppPartType() && _.includes(fixer.getBlogFeedAppPartNames(), componentData.appPartName);
        }).forEach(function (blogFeedAppPartComponentData) {
            var customizations = blogFeedAppPartComponentData.appLogicCustomizations;
            _(customizations).compact() // Can contain null.
            .filter(function (customization) {
                return customization.fieldId === fixer.getReadMoreValueCustomizationFieldId() && //eslint-disable-line lodash/prefer-matches
                customization.key === fixer.getReadMoreValueCustomizationKey() && customization.format === '' && _.includes(fixer.getAffectedReadMoreValueCustomizationViews(), customization.view);
            }).forEach(function (affectedReadMoveValueCustomization) {
                // Drop existing corresponding customizations if any with the format '*' to avoid issues
                // with having multiple customizations that differ in value.
                _.remove(customizations, {
                    fieldId: affectedReadMoveValueCustomization.fieldId,
                    format: '*',
                    key: affectedReadMoveValueCustomization.key,
                    view: affectedReadMoveValueCustomization.view
                });

                affectedReadMoveValueCustomization.format = '*';
            });
        });
    },


    // The methods below are used for testing purposes (to simplify a number of test cases by replacing return
    // value).
    getAppPartType: function getAppPartType() {
        return 'AppPart';
    },
    getBlogFeedAppPartNames: function getBlogFeedAppPartNames() {
        return [coreUtils.blogAppPartNames.FEED, coreUtils.blogAppPartNames.CUSTOM_FEED];
    },
    getReadMoreValueCustomizationFieldId: function getReadMoreValueCustomizationFieldId() {
        return 'ReadMoreBtn';
    },
    getReadMoreValueCustomizationKey: function getReadMoreValueCustomizationKey() {
        return 'value';
    },
    getAffectedReadMoreValueCustomizationViews: function getAffectedReadMoreValueCustomizationViews() {
        return ['MediaLeft', 'MediaLeftPage', 'MediaRight', 'MediaRightPage', 'MediaZigzag', 'MediaZigzagPage', 'Masonry', 'MasonryPage'];
    }
};

module.exports = fixer;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

module.exports = {
    exec: function exec(pageJson) {
        _(pageJson.data.document_data).filter({ type: 'AppPart' }).forEach(function (data) {
            _(data.appLogicCustomizations).filter({
                fieldId: 'tagsValue',
                forType: 'Post',
                format: '',
                key: 'value',
                view: 'SinglePostMediaTop'
            }).forEach(function (customization) {
                customization.format = '*';
            });
        });
    }
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function hashCustomization(customization) {
    var rule = _.omit(customization, 'value');
    return JSON.stringify(rule);
}

module.exports = {
    exec: function exec(pageJson) {
        _(pageJson.data.document_data).filter({ type: 'AppPart' }).forEach(function (appPart) {
            var customizations = appPart.appLogicCustomizations;
            var index = customizations.length;
            var stateByHash = {};
            while (index) {
                index -= 1;
                var hash = hashCustomization(customizations[index]);
                if (!stateByHash[hash]) {
                    stateByHash[hash] = true;
                } else {
                    customizations.splice(index, 1);
                }
            }
        });
    }
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);

module.exports = {
    exec: function exec(pageJson) {
        _(pageJson.data.document_data).filter({
            type: 'AppPart',
            appPartName: coreUtils.blogAppPartNames.CUSTOM_FEED
        }).forEach(function (compData) {
            _(compData.appLogicCustomizations).filter(customizationMatches).forEach(function (customization) {
                _.assign(customization, {
                    fieldId: 'vars',
                    format: '*',
                    key: 'itemsPerPage'
                });
            });
        });
    }
};

function customizationMatches(customization) {
    return customization.forType === 'Array' && customization.key === 'comp.itemsPerPage' && _.includes(['', '*'], customization.format) && _.includes(['paginatedlist', 'columnBlog'], customization.fieldId) && _.includes(['MediaTop', 'MediaBottom', 'MediaLeft', 'MediaRight', 'MediaZigzag', 'Masonry'], customization.view);
}

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);

module.exports = {
    exec: function exec(pageJson) {
        _(pageJson.data.document_data).filter(function (compData) {
            return compData.type === 'AppPart' && _.includes([coreUtils.blogAppPartNames.CUSTOM_FEED, coreUtils.blogAppPartNames.FEED, coreUtils.blogAppPartNames.SINGLE_POST], compData.appPartName);
        }).forEach(function (compData) {
            _(compData.appLogicCustomizations).filter(customizationMatches).forEach(function (customization) {
                _.assign(customization, {
                    fieldId: 'dateAndAuthor'
                });
            });
        });
    }
};

function customizationMatches(customization) {
    return customization.forType === 'Post' && customization.key === 'comp.hidden' && (customization.fieldId === 'date' || customization.fieldId === 'author') && _.includes(['MediaTop', 'MediaBottom', 'MediaLeft', 'MediaRight', 'MediaZigzag', 'Masonry', 'MediaTopPage', 'MediaBottomPage', 'MediaLeftPage', 'MediaRightPage', 'MediaZigzagPage', 'MasonryPage', 'SinglePostMediaBottom', 'SinglePostMediaTop'], customization.view);
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);

module.exports = {
    exec: function exec(pageJson) {
        _(pageJson.data.document_data).filter(function (compData) {
            return compData.type === 'AppPart' && _.includes([coreUtils.blogAppPartNames.CUSTOM_FEED, coreUtils.blogAppPartNames.FEED, coreUtils.blogAppPartNames.SINGLE_POST], compData.appPartName);
        }).forEach(function (compData) {
            _(compData.appLogicCustomizations).filter(customizationMatches).forEach(function (customization) {
                _.assign(customization, {
                    fieldId: 'vars',
                    key: 'dateAndAuthorPosition',
                    value: customization.value === '0' ? 'left' : 'right'
                });
            });
        });
    }
};

function customizationMatches(customization) {
    return customization.forType === 'Post' && //eslint-disable-line lodash/prefer-matches
    customization.key === 'layout.spacerBefore' && customization.fieldId === 'date' && _.includes(['MediaTop', 'MediaBottom', 'MediaLeft', 'MediaRight', 'MediaZigzag', 'Masonry', 'MediaTopPage', 'MediaBottomPage', 'MediaLeftPage', 'MediaRightPage', 'MediaZigzagPage', 'MasonryPage', 'SinglePostMediaBottom', 'SinglePostMediaTop'], customization.view);
}

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);

var brokenButtonStyleIds = null;

module.exports = {
    exec: function exec(pageJson) {
        // Styles are stored in the master page that is processed first by data fixers.
        if (_.isNull(brokenButtonStyleIds)) {
            brokenButtonStyleIds = [];

            _.forEach(pageJson.data.theme_data, function (style, styleId, styleById) {
                var buttonStyleIsBroken = _.matches({
                    componentClassName: 'wysiwyg.viewer.components.SiteButton',
                    skin: 'wysiwyg.viewer.skins.AppPartSkin'
                })(style);

                if (buttonStyleIsBroken) {
                    brokenButtonStyleIds.push(styleId);
                    delete styleById[styleId];
                }
            });

            // Data fixers run synchronously.
            // Store broken button style IDs collected on the master page for use on other pages.
            // Free memory at the end.
            setTimeout(function () {
                brokenButtonStyleIds = null;
            });
        }

        _(pageJson.data.document_data).filter(function (compData) {
            return compData.type === 'AppPart' && _.includes(coreUtils.blogAppPartNames, compData.appPartName);
        }).forEach(function (compData) {
            _.remove(compData.appLogicCustomizations, function (customization) {
                return customization.key === 'comp.style' && _.includes(brokenButtonStyleIds, customization.value);
            });
        });
    }
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);

var VIEW_NAMES_BY_APP_PART_NAME = {};
VIEW_NAMES_BY_APP_PART_NAME[coreUtils.blogAppPartNames.FEED] = ['MediaBottomPage', 'MediaLeftPage', 'MediaRightPage', 'MediaTopPage', 'MediaZigzagPage'];
VIEW_NAMES_BY_APP_PART_NAME[coreUtils.blogAppPartNames.POSTS_LIST] = ['PostsList', 'PostsListMediaLeft'];
VIEW_NAMES_BY_APP_PART_NAME[coreUtils.blogAppPartNames.TICKER] = ['TickerMediaBottom', 'TickerMediaTop'];

module.exports = {
    exec: function exec(pageJson) {
        _(pageJson.data.document_data).filter(function (compData) {
            return compData.type === 'AppPart' && _.includes([coreUtils.blogAppPartNames.FEED, coreUtils.blogAppPartNames.POSTS_LIST, coreUtils.blogAppPartNames.TICKER], compData.appPartName);
        }).forEach(function (compData) {
            _(compData.appLogicCustomizations).filter(function (customization) {
                return customization.fieldId === 'date' && //eslint-disable-line lodash/prefer-matches
                customization.forType === 'Post' && !customization.format && customization.key === 'comp.format' && _.includes(VIEW_NAMES_BY_APP_PART_NAME[compData.appPartName], customization.view);
            }).forEach(function (customization) {
                customization.format = '*';
            });
        });
    }
};

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var DEFAULT_FORM_COMPONENT_PROPERTIES = {
    type: 'ContactFormProperties',
    hidden_emailFieldLabel: true,
    hidden_nameFieldLabel: true,
    hidden_phoneFieldLabel: false,
    hidden_addressFieldLabel: false,
    hidden_subjectFieldLabel: true,
    hidden_messageFieldLabel: true,
    required_emailFieldLabel: true,
    required_nameFieldLabel: true,
    required_phoneFieldLabel: false,
    required_addressFieldLabel: false,
    required_subjectFieldLabel: false,
    required_messageFieldLabel: false,
    useCookie: true
};

var DEFAULT_FORM_FIELD_LABELS = {
    nameFieldLabel: {
        type: 'string',
        default: 'Name'
    },
    emailFieldLabel: {
        type: 'string',
        default: 'Email'
    },
    phoneFieldLabel: {
        type: 'string',
        default: 'Phone'
    },
    addressFieldLabel: {
        type: 'string',
        default: 'Address'
    },
    subjectFieldLabel: {
        type: 'string',
        default: 'Subject'
    },
    messageFieldLabel: {
        type: 'string',
        default: 'Message'
    },
    submitButtonLabel: {
        type: 'string',
        default: 'Send'
    },
    successMessage: {
        type: 'string',
        default: 'Your details were sent successfully!'
    },
    errorMessage: {
        type: 'string',
        default: 'Please provide a valid email'
    },
    textDirection: {
        type: 'string',
        default: 'left',
        enum: ['left', 'right']
    },
    validationErrorMessage: {
        type: 'string',
        default: 'Please fill in all required fields.'
    },
    onSubmitBehavior: {
        type: 'string',
        default: 'message',
        enum: ['message', 'link']
    }
};

var SKIN_1_FIELDS_ORDER = {
    skinPrefix: 'contactform.',
    fields: ['name', 'email', 'subject', 'phone', 'address', 'message']
};

var SKIN_2_FIELDS_ORDER = {
    skinPrefix: 'wysiwyg.viewer.skins.contactform.',
    fields: ['name', 'email', 'phone', 'address', 'subject', 'message']
};

var DYNAMIC_CONTACT_FORM_TYPE = 'DynamicContactForm';
var OLD_CONTACT_FORM_COMPONENT_TYPE = 'wysiwyg.viewer.components.ContactForm';
var DYNAMIC_CONTACT_FORM_COMPONENT_TYPE = 'wysiwyg.viewer.components.DynamicContactForm';

function cleanQuery(rawQuery) {
    return (rawQuery || '').replace('#', '');
}

function shouldMigrate(_ref, structureData) {
    var isExperimentOpen = _ref.isExperimentOpen;

    return (isExperimentOpen('sv_contactFormTemplatesMigration') || isExperimentOpen('sv_contactFormFinalMigration')) && !!structureData;
}

function isFormCorrupt(comp, propertyQuery, pageJson) {
    return !_.has(pageJson.data.component_properties, propertyQuery) && comp.componentType === OLD_CONTACT_FORM_COMPONENT_TYPE;
}

function fixMigratedContactForm(comp) {
    var propertyQuery = cleanQuery(comp.propertyQuery);
    _.unset(comp, 'propertyQuery');
    _.unset(this.pageJson.data.component_properties, [propertyQuery]);
}

function migrateField(fieldName) {
    switch (fieldName) {
        case 'email':
            return { fieldType: 'email', fieldInputType: 'email' };
        case 'phone':
            return { fieldType: 'phone', fieldInputType: 'tel' };
        default:
            return { fieldType: fieldName, fieldInputType: 'text' };
    }
}

function migrateOldFields(skin, oldData, oldProps) {
    var oldFieldsOrder = _.startsWith(skin, SKIN_1_FIELDS_ORDER.skinPrefix) ? SKIN_1_FIELDS_ORDER.fields : SKIN_2_FIELDS_ORDER.fields;

    return _.reduce(oldFieldsOrder, function (res, fieldName) {
        var fieldKey = fieldName + 'FieldLabel';
        var isDisplayed = oldProps['hidden_' + fieldKey];

        if (isDisplayed) {
            var migratedData = migrateField(fieldName);

            res.push({
                name: migratedData.fieldType,
                inputType: migratedData.fieldInputType,
                displayLabel: oldData[fieldKey] || _.get(DEFAULT_FORM_FIELD_LABELS[fieldKey], 'default'),
                required: oldProps['required_' + fieldKey],
                isDisplayed: isDisplayed
            });
        }
        return res;
    }, []);
}

function isDynamicContactForm(data) {
    return _.has(data, 'dynamicFields') && _.get(data, 'type') === DYNAMIC_CONTACT_FORM_TYPE;
}

function migrateOldContactForm(comp) {
    var _this = this;

    var compDataQuery = cleanQuery(comp.dataQuery);
    var compPropertyQuery = cleanQuery(comp.propertyQuery);

    var oldData = this.pageJson.data.document_data[compDataQuery];
    var oldProps = isFormCorrupt(comp, compPropertyQuery, this.pageJson) ? DEFAULT_FORM_COMPONENT_PROPERTIES : this.pageJson.data.component_properties[compPropertyQuery];

    _.unset(comp, 'propertyQuery');
    _.set(comp, 'componentType', DYNAMIC_CONTACT_FORM_COMPONENT_TYPE);

    if (isDynamicContactForm(oldData)) {
        return;
    }

    _.assign(this.pageJson.data.document_data[compDataQuery], {
        type: DYNAMIC_CONTACT_FORM_TYPE,
        dynamicFields: migrateOldFields(comp.skin, oldData, oldProps)
    });

    ['name', 'email', 'subject', 'phone', 'address', 'message'].forEach(function (fieldName) {
        _.unset(_this.pageJson.data.document_data, [compDataQuery, fieldName + 'FieldLabel']);
    });

    _.unset(this.pageJson.data.component_properties, compPropertyQuery);
}

function migrateAllOldContactForms(comps) {
    var _this2 = this;

    if (!comps) {
        return;
    }

    _.forEach(comps, function (comp) {
        if (comp.componentType === OLD_CONTACT_FORM_COMPONENT_TYPE) {
            migrateOldContactForm.call(_this2, comp);
        }

        if (comp.componentType === DYNAMIC_CONTACT_FORM_COMPONENT_TYPE) {
            fixMigratedContactForm.call(_this2, comp);
        }

        migrateAllOldContactForms.call(_this2, comp.components);
    });
}

module.exports = {
    exec: function exec(pageJson, pageIdsArray, requestModel, currentUrl, urlFormatModel, isViewerMode, rendererModel, magicObject) {
        var structureData = pageJson.structure;

        if (shouldMigrate(magicObject, structureData)) {
            var allComps = _.concat([], structureData.components || structureData.children, structureData.mobileComponents || []);
            migrateAllOldContactForms.call({ pageJson: pageJson }, allComps);
        }
    }
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function isJsonForPage(pageJson) {
    return _.get(pageJson, 'structure.type') === 'Page';
}

function removePageDataItems(pageJson) {
    _(pageJson.data.document_data).filter({ type: 'Page' }).map('id').forEach(function (pageId) {
        delete pageJson.data.document_data[pageId];
    });
}

function updateLinksMasterPageId(pageJson) {
    _.forEach(pageJson.data.document_data, function (dataItem) {
        //eslint-disable-line lodash/prefer-filter
        if (dataItem.pageId === '#SITE_STRUCTURE') {
            dataItem.pageId = '#masterPage';
        }
    });
}

function pageDataFixer(pageJson) {
    if (isJsonForPage(pageJson)) {
        removePageDataItems(pageJson);
    }
    updateLinksMasterPageId(pageJson);
}

module.exports = { exec: pageDataFixer };

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var GROUP_COMP_TYPE = 'wysiwyg.viewer.components.Group';
var GROUP_SKIN = 'wysiwyg.viewer.components.GroupSkin';

function fixSkin(compStructure) {
    if (compStructure.componentType === GROUP_COMP_TYPE) {
        compStructure.skin = GROUP_SKIN;
    }
}

function runOnAllComps(comps) {
    _.forEach(comps, function (comp) {
        fixSkin(comp);
        runOnAllComps(comp.components);
    });
}

module.exports = {
    exec: function exec(pageJson) {
        var structureData = pageJson.structure;
        if (structureData) {
            var desktopComps = structureData.components || structureData.children;
            var mobileComps = structureData.mobileComponents;

            if (desktopComps) {
                runOnAllComps(desktopComps);
            }

            if (mobileComps) {
                runOnAllComps(mobileComps);
            }
        }
    }
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var textTypes = ['RichText', 'Text', 'StyledText', 'MediaRichText'];

function fixTextNodes(dataMap) {
    return _(dataMap).pickBy(function (dataNode) {
        return _.includes(textTypes, dataNode.type);
    }).mapValues(function (textData) {
        textData.text = removeObjectElements(textData.text);
        textData.text = removeImgElementsWithEventHandlers(textData.text);
        return textData;
    }).value();
}

function removeObjectElements(html) {
    return html && html.replace(/(<object[^>]*>)(.*?)(<\/object>)/gi, '');
}

function removeImgElementsWithEventHandlers(html) {
    return html && html.replace(/<img[^>]*(onerror|onload|onmouseenter|onmousemove|onmouseleave|onmouseover|onmouseup|onmouseout)[^>]*\/?>(<\/img>)?/gi, '');
}

/**
 * @exports utils/dataFixer/plugins/objectTagTextSecurityFixer
 */
module.exports = {
    exec: function exec(pageJson) {
        var data = pageJson.data.document_data;
        if (data) {
            fixTextNodes(data);
        }
    }
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var isJsonForPage = _.matchesProperty(['structure', 'type'], 'Page'); // eslint-disable-line santa/no-module-state

module.exports = {
    exec: function exec(pageJson, pageIdsArray, requestModel, currentUrl, urlFormatModel, isViewerMode, rendererModel, magicObject) {
        if (_.get(magicObject, 'isSlash') && !isJsonForPage(pageJson)) {
            _.forEach(magicObject.pageIdToResolvedUriSEO, function (resolved, pageId) {
                pageJson.data.document_data[pageId].pageUriSEO = resolved.curr;
            });
        }
    }
};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var CompsMigrationHelper = __webpack_require__(2);
var coreUtils = __webpack_require__(1);

function getEmptyBackground() {
    return {
        type: 'MediaContainerDesignData',
        id: coreUtils.guidUtils.getUniqueId('dataItem', '-'),
        background: {
            id: coreUtils.guidUtils.getUniqueId('dataItem', '-'),
            type: 'BackgroundMedia',
            mediaRef: null,
            alignType: 'center',
            fittingType: 'fill',
            colorOpacity: 0,
            colorOverlay: '',
            colorOverlayOpacity: 1,
            imageOverlay: '',
            scrollType: 'none',
            color: '#FFFFFF'
        }
    };
}

function getDefaultColumnsContainerProperties() {
    return {
        columnsMargin: 0,
        frameMargin: 0,
        fullWidth: true,
        rowMargin: 0,
        siteMargin: 0,
        type: 'StripColumnsContainerProperties'
    };
}

function getDefaultColumnProperties() {
    return {
        type: 'ColumnProperties',
        alignment: 50
    };
}

function createColumnFromStrip(comp, cache) {
    return {
        id: _.get(cache, [comp.id, 'mediaId'], coreUtils.guidUtils.getUniqueId('media')),
        type: 'Container',
        layout: {
            width: comp.layout.width,
            height: comp.layout.height,
            x: 0,
            y: 0,
            scale: 1,
            rotationInDegrees: 0,
            anchors: [{
                distance: 0,
                topToTop: 0,
                originalValue: 0,
                type: 'BOTTOM_PARENT',
                locked: true,
                targetComponent: comp.id
            }],
            fixedPosition: false
        },
        components: comp.components,
        componentType: 'wysiwyg.viewer.components.Column',
        styleId: 'strc1'
    };
}

function migrateAnchors(comp, column) {
    _.forEach(comp.components, function (childComp) {
        var anchors = _.get(childComp, ['layout', 'anchors'], []);
        _.forEach(anchors, function (anchor) {
            //eslint-disable-line lodash/prefer-filter
            if (anchor.type === 'BOTTOM_PARENT') {
                anchor.targetComponent = column.id;
            }
        });
    });
}

function migrateBehaviors(comp, column) {
    if (comp.behaviors) {
        column.behaviors = _.clone(comp.behaviors);
        delete comp.behaviors;
    }
    if (comp.behaviorQuery) {
        column.behaviorQuery = comp.behaviorQuery;
        delete comp.behaviorQuery;
    }
}

function migrateStrip(pageJson, cache, mobileView, comp) {
    comp.componentType = 'wysiwyg.viewer.components.StripColumnsContainer';
    delete comp.skin;
    comp.styleId = 'strc1';

    this.setComponentProperties(pageJson, comp, getDefaultColumnsContainerProperties(), cache);

    var column = createColumnFromStrip(comp, cache);

    migrateAnchors(comp, column);
    migrateBehaviors(comp, column);

    _.set(cache, [comp.id, 'mediaId'], column.id);

    this.setComponentProperties(pageJson, column, getDefaultColumnProperties(), cache);

    column.designQuery = comp.designQuery;
    delete comp.designQuery;

    if (!mobileView) {
        comp.layout.width = 980;
        var designDataWithEmptyBackground = getEmptyBackground();
        this.setComponentDesignData(pageJson, comp, designDataWithEmptyBackground, cache);
    } else {
        comp.layout.width = 320;
        comp.designQuery = _.get(cache, [comp.id, 'designQuery']);
        this.deleteComponentData(pageJson, comp);
    }
    delete comp.dataQuery;

    comp.components = [column];
}

var MIGRATION_MAP = {
    'wysiwyg.viewer.components.StripContainer': migrateStrip

    /**
     * @exports utils/dataFixer/plugins/migrateStripToColumnsContainer
     * @type {{exec: exec}}
     */

};var migrationHelper = new CompsMigrationHelper(MIGRATION_MAP); // eslint-disable-line santa/no-module-state

module.exports = {
    exec: migrationHelper.migratePage.bind(migrationHelper)
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var TINY_MENU_SKIN = 'wysiwyg.viewer.skins.mobile.TinyMenuSkin';

function applyTinyMenuDefaults(styleData) {
    if (styleData.skin !== TINY_MENU_SKIN || _.isUndefined(styleData.style) || _.isUndefined(styleData.style.properties)) {
        return;
    }

    var defaults = [['bg', 'bgDrop'], ['bg', 'bgOpen'], ['txt', 'bordercolor'], ['txt', 'iconcolor'], ['bordercolor', 'borderColorSelected']];

    var prop = styleData.style.properties;
    var propSource = styleData.style.propertiesSource;

    function applyDefault(map, key, val) {
        if (!_.isUndefined(map) && !_.isUndefined(map[key])) {
            map[val] = map[val] || map[key];
        }
    }

    _.forEach(defaults, function (def) {
        var key = def[0];
        var val = def[1];

        applyDefault(prop, key, val);
        applyDefault(propSource, key, val);

        key = 'alpha-' + key;
        val = 'alpha-' + val;

        applyDefault(prop, key, val);
        applyDefault(propSource, key, val);
    });
}

/**
 * @exports utils/dataFixer/plugins/tinyMenuSkinBackgroundFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        var themeData = pageJson.data && pageJson.data.theme_data;
        if (!_.isEmpty(themeData)) {
            _.forEach(themeData, applyTinyMenuDefaults);
        }
    }
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function fixTinyMenuLayout(components) {
    var tinyMenuComponent = _.find(components, { id: 'TINY_MENU' });
    if (tinyMenuComponent) {
        if (tinyMenuComponent.layout.fixedPosition && tinyMenuComponent.layout.x > 320) {
            tinyMenuComponent.layout.x = 250;
        }
        return true;
    }
    return _.some(components, function (component) {
        return _.isEmpty(component.components) ? false : fixTinyMenuLayout(component.components);
    });
}

/**
 * @exports utils/dataFixer/plugins/tinyMenuLayoutFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        var isMasterPage = _.get(pageJson, ['structure', 'id']) === 'masterPage';
        if (!isMasterPage) {
            return;
        }
        fixTinyMenuLayout(pageJson.structure.mobileComponents);
    }
};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);

function isStripContainer(component) {
    return component.componentType === 'wysiwyg.viewer.components.StripContainer';
}

function hasDesignQuery(component) {
    return !_.isUndefined(component.designQuery);
}

function createMediaContainerDesignDataItem(comp, designData, designId) {
    if (_.isUndefined(designId)) {
        designId = coreUtils.guidUtils.getUniqueId('dataItem', '-');
    }
    designData[designId] = {
        id: designId,
        type: 'MediaContainerDesignData',
        metaData: { isPreset: false, schemaVersion: '1.0', isHidden: false }
    };
    comp.designQuery = '#' + designId;
    return designId;
}

function moveDataItem(source, target, itemId) {
    target[itemId] = source[itemId];
    delete source[itemId];
    return target[itemId];
}

function moveBackgroundData(sourceId, targetId, source, target) {
    var componentData = source[sourceId];
    if (!_.isUndefined(componentData.background)) {
        var backgroundMediaId = componentData.background.slice(1);
        var backgroundMedia = moveDataItem(source, target, backgroundMediaId);

        if (!_.isUndefined(backgroundMedia.mediaRef)) {
            var innerMediaId = backgroundMedia.mediaRef.slice(1);
            var innerMedia = moveDataItem(source, target, innerMediaId);
            if (innerMedia.type === 'WixVideo') {
                var posterImageId = innerMedia.posterImageRef.slice(1);
                moveDataItem(source, target, posterImageId);
            }
            if (!_.isUndefined(innerMedia.originalImageDataRef)) {
                var orgImage = innerMedia.originalImageDataRef.slice(1);
                moveDataItem(source, target, orgImage);
            }
            if (!_.isUndefined(innerMedia.link)) {
                delete innerMedia.link;
            }
        }
        if (!_.isUndefined(backgroundMedia.imageOverlay)) {
            var imageOverlayId = backgroundMedia.imageOverlay.slice(1);
            moveDataItem(source, target, imageOverlayId);
        }

        delete componentData.background;
        target[targetId].background = '#' + backgroundMediaId;
        return backgroundMediaId;
    }
}

function migrateToDesignData(documentData, designData, dataIdToDesignId, dataIdToBgMediaId, stripContainer) {
    var dataId = stripContainer.dataQuery.slice(1);
    var designId = createMediaContainerDesignDataItem(stripContainer, designData);
    dataIdToDesignId[dataId] = designId;
    var bgMediaId = moveBackgroundData(dataId, designId, documentData, designData);
    if (!_.isUndefined(bgMediaId)) {
        dataIdToBgMediaId[dataId] = bgMediaId;
    }
}

function migrateToDesignDataMobile(designData, dataIdToDesignId, dataIdToBgMediaId, stripContainer) {
    var dataId = stripContainer.dataQuery.slice(1);
    stripContainer.designQuery = '#' + dataIdToDesignId[dataId];
}

function fixStripContainers(components, mobileComponents, documentData, designData) {
    var dataIdToBgMediaId = {};
    var dataIdToDesignId = {};
    var stripContainers = _.filter(components, isStripContainer);

    _(stripContainers).reject(hasDesignQuery).forEach(_.partial(migrateToDesignData, documentData, designData, dataIdToDesignId, dataIdToBgMediaId));

    _(mobileComponents).filter(function (component) {
        return isStripContainer(component) && !hasDesignQuery(component);
    }).forEach(_.partial(migrateToDesignDataMobile, designData, dataIdToDesignId, dataIdToBgMediaId));
}

function getChildren(structure) {
    if (!_.isUndefined(structure.components)) {
        return structure.components;
    } else if (!_.isUndefined(structure.children)) {
        return structure.children;
    }
    return [];
}

function flatComponents(componentsTree) {
    var stack = _.clone(componentsTree) || [];
    var flat = [];
    while (stack.length > 0) {
        var comp = stack.pop();
        flat.push(comp);
        var children = getChildren(comp);
        _.forEach(children, function (child) {
            //eslint-disable-line lodash/prefer-map
            stack.push(child);
        });
    }
    return flat;
}

function getComponents(pageJson) {
    return flatComponents(getChildren(pageJson.structure));
}

function getMobileComponents(pageJson) {
    return flatComponents(pageJson.structure.mobileComponents);
}

module.exports = {
    exec: function exec(pageJson) {
        var components = getComponents(pageJson);
        var mobileComponents = getMobileComponents(pageJson);

        pageJson.data.design_data = pageJson.data.design_data || {};
        fixStripContainers(components, mobileComponents, pageJson.data.document_data, pageJson.data.design_data);
    }
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function fixSendEmailField(dataItem) {
    if (!dataItem.metaData || dataItem.metaData.schemaVersion !== '2.0') {
        dataItem.sendMail = true;
    }
}

function fixData(data) {
    _.forEach(data, function (dataItem) {
        if (dataItem.type === 'LoginToWixLink' || dataItem.type === 'HomePageLogin') {
            fixSendEmailField(dataItem);
        }
    });
}

/**
 * @exports utils/dataFixer/plugins/backgroundsDataFixer
 * @type {{exec: function}}
 */
module.exports = {
    exec: function exec(pageJson) {
        var data = pageJson.data.document_data;
        if (!_.isEmpty(data)) {
            fixData(data);
        }
    }
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

/**
 * @exports utils/dataFixer/plugins/characterSetsFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        if (pageJson.structure && pageJson.structure.type === 'Document') {
            if (_.isEmpty(pageJson.data.document_data.masterPage.characterSets)) {
                pageJson.data.document_data.masterPage.characterSets = ['latin'];
            }
        }
        return pageJson;
    }
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

module.exports = {
    /**
     * Converts page props to have { desktop: ..., mobile: ...} at the top level
     * @param pageJson
     */
    exec: function exec(pageJson) {
        var props = _.get(pageJson, ['data', 'component_properties', pageJson.structure.id]);
        var popupProps = props && props.popup;
        if (popupProps) {
            _.forEach(['desktop', 'mobile'], function (mode) {
                var modeValue = props[mode];
                var popupModeValue = props.popup[mode];
                if (modeValue || popupModeValue) {
                    _.set(props, [mode, ['popup']], _.assign(modeValue || {}, popupModeValue || {}));
                }
            });
            delete props.popup;
        }
    }
};

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);

module.exports = {
    exec: function exec(pageJson) {
        _(pageJson.data.document_data).filter({
            type: 'AppPart',
            appPartName: coreUtils.blogAppPartNames.SINGLE_POST
        }).forEach(function (compData) {
            var customization = _.find(compData.appLogicCustomizations, {
                forType: 'Post',
                fieldId: 'vars',
                key: 'selectionSharerExperimentOpen',
                view: compData.viewName
            });

            if (!customization) {
                customization = {
                    forType: 'Post',
                    fieldId: 'vars',
                    key: 'selectionSharerExperimentOpen',
                    view: compData.viewName,
                    type: 'AppPartCustomization',
                    format: ''
                };
                compData.appLogicCustomizations.push(customization);
            }
        });
    }
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function getQuickActionBar(masterPage) {
    return _.find(masterPage.structure.mobileComponents, { id: 'QUICK_ACTION_BAR' });
}

function addQuickActionBarStructure(masterPage) {
    masterPage.structure.mobileComponents.push({
        type: 'Container',
        id: 'QUICK_ACTION_BAR',
        componentType: 'wysiwyg.viewer.components.QuickActionBar',
        components: [],
        styleId: 'quickActionBarStyle',
        layout: {
            fixedPosition: true
        }
    });
}

function addQuickActionBarStyle(masterPage) {
    getQuickActionBar(masterPage).styleId = 'quickActionBarStyle';
    _.assign(masterPage.data.theme_data, {
        quickActionBarStyle: {
            type: 'TopLevelStyle',
            id: 'quickActionBarStyle',
            metaData: {
                isPreset: false,
                schemaVersion: '1.0',
                isHidden: false
            },
            skin: 'wysiwyg.viewer.skins.quickActionBar.floatingSkin',
            style: {
                properties: {
                    'alpha-controlButtonBG': '1',
                    'alpha-controlButtonFG': '1',
                    'alpha-controlButtonBorderColor': '1',
                    'alpha-actionsBorderColor': '1',
                    'boxShadowToggleOn-actionsSHD': 'true',
                    'boxShadowToggleOn-controlButtonSHD': 'true',
                    controlButtonBG: '#ffffff',
                    controlButtonFG: '#4682b4',
                    controlButtonBorderSize: '0',
                    controlButtonBorderColor: '#ffffff',
                    actionsBorderSize: '0',
                    actionsBorderColor: '#ffffff',
                    colorScheme: 'brand inv',
                    controlButtonSHD: '0px 1px 4px 0px rgba(0,0,0,0.6)',
                    actionsSHD: '0px 1px 4px 0px rgba(0,0,0,0.6)'
                },
                propertiesSource: {
                    controlButtonBG: 'value',
                    controlButtonFG: 'value',
                    controlButtonBorderSize: 'value',
                    controlButtonBorderColor: 'value',
                    actionsBorderSize: 'value',
                    actionsBorderColor: 'value',
                    colorScheme: 'value',
                    controlButtonSHD: 'value',
                    actionsSHD: 'value'
                },
                groups: {}
            },
            componentClassName: 'wysiwyg.viewer.components.QuickActionBar',
            pageId: '',
            compId: '',
            styleType: 'custom'
        }
    });
}

function addQuickActionBarProperties(masterPage) {
    getQuickActionBar(masterPage).propertyQuery = 'quickActionBarProps';
    _.assign(masterPage.data.component_properties, {
        quickActionBarProps: {
            type: 'QuickActionBarProperties',
            metaData: {
                isPreset: false,
                schemaVersion: '1.0',
                isHidden: false
            },
            colorScheme: 'brand',
            invertColors: true,
            alignment: 'right',
            hideText: true
        }
    });
}

function hasQuickActionBar(masterPage) {
    return !!getQuickActionBar(masterPage);
}

function hasTPAWithQuickActions(clientSpecMap) {
    var chatAppDefId = '14517e1a-3ff0-af98-408e-2bd6953c36a2';
    var chatApp = _.find(clientSpecMap, { appDefinitionId: chatAppDefId });
    var isChatAppInstalled = !_.isUndefined(chatApp) && !_.get(chatApp, 'permissions.revoked');
    return isChatAppInstalled;
}

function fixQuickActionBarStructure(masterPage) {
    var quickActionBarStructure = _.find(masterPage.structure.mobileComponents, { id: 'QUICK_ACTION_BAR' });
    if (_.isUndefined(quickActionBarStructure.components)) {
        quickActionBarStructure.components = [];
    }
    quickActionBarStructure.type = 'Container';
    if (_.isUndefined(masterPage.data.component_properties[quickActionBarStructure.propertyQuery])) {
        addQuickActionBarProperties(masterPage);
    }
}

function fixQuickActionBarStyleProperties(masterPage) {
    var quickActionBarStructure = _.find(masterPage.structure.mobileComponents, { id: 'QUICK_ACTION_BAR' });
    var styleProperties = _.get(masterPage.data.theme_data, [quickActionBarStructure.styleId, 'style', 'properties']);
    _.transform(['controlButtonBorderColor', 'actionsBorderColor'], function (styleProps, prop) {
        if (/^rgb/.test(styleProps[prop])) {
            styleProps[prop] = '#ffffff';
        }
    }, styleProperties);
}

function fixQuickActionBarItemsData(masterPage) {
    _(masterPage.data.document_data).filter(function (dataNode) {
        return dataNode.type === 'QuickActionBarItem' && _.isString(dataNode.text);
    }).forEach(function (dataNode) {
        dataNode.text = dataNode.text.slice(0, 40);
    });
}

/**
 * @exports utils/dataFixer/plugins/quickActionBarDataFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson, pageIdsArray, requestModel, currentUrl, urlFormatModel, isViewerMode, rendererModel, magicObject) {
        if (pageJson.structure.id !== 'masterPage') {
            return;
        }

        fixQuickActionBarItemsData(pageJson);

        if (hasQuickActionBar(pageJson)) {
            fixQuickActionBarStructure(pageJson);
            fixQuickActionBarStyleProperties(pageJson);
            return;
        }

        var shouldAddQuickActionBar = hasTPAWithQuickActions(magicObject.clientSpecMap) && !hasQuickActionBar(pageJson) && !magicObject.quickActionsMenuEnabled;

        if (shouldAddQuickActionBar) {
            addQuickActionBarStructure(pageJson);
            addQuickActionBarStyle(pageJson);
            addQuickActionBarProperties(pageJson);
        }
    }
};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);

var fixer = {
    exec: function exec(pageJson) {
        _.forEach(pageJson.data.document_data, function (compData) {
            if (compData.appPartName && compData.appPartName === coreUtils.blogAppPartNames.FEED) {
                fixer.fixMobileDateCustomization(compData);
            }
        });
    },
    fixMobileDateCustomization: function fixMobileDateCustomization(appPart) {
        _.forEach(appPart.appLogicCustomizations, function (customization) {
            if (customization.fieldId === 'date' && customization.format === 'Mobile' && customization.forType === 'Post' && customization.key === 'comp.hidden') {
                //eslint-disable-line lodash/prefer-matches
                customization.fieldId = 'dateAndAuthor';
            }
        });
    }
};

module.exports = fixer;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);

function isImageDataItem(dataItem) {
    return dataItem.type === 'Image';
}

function hasDuplicatedOriginalImageRef(imagesDataArr, originalImageDataRef) {
    return originalImageDataRef !== 'undefined' && originalImageDataRef !== 'null' && imagesDataArr.length > 1;
}

function createNewOriginalImageData(documentData, originalImageDataItemId) {
    var newId = originalImageDataItemId + '_' + coreUtils.guidUtils.getUniqueId();
    var newDataItem = _.cloneDeep(documentData[originalImageDataItemId]);
    newDataItem.id = newId;

    return newDataItem;
}

module.exports = {
    exec: function exec(pageJson) {
        var documentData = _.get(pageJson, ['data', 'document_data']);

        if (!documentData) {
            return;
        }

        _(documentData).pickBy(isImageDataItem).groupBy('originalImageDataRef').pickBy(hasDuplicatedOriginalImageRef).forOwn(function (imagesDataArr, originalImageDataRef) {
            var imagesWithDuplicatedOriginalImageRef = _.tail(imagesDataArr);
            var originalImageDataItemId = originalImageDataRef.replace('#', '');

            _.forEach(imagesWithDuplicatedOriginalImageRef, function (imageDataItem) {
                var newDataItem = createNewOriginalImageData(documentData, originalImageDataItemId);
                documentData[newDataItem.id] = newDataItem;
                imageDataItem.originalImageDataRef = '#' + newDataItem.id;
            });
        });
    }
};

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var TPA_SECTION_COMP_TYPE = 'wysiwyg.viewer.components.tpapps.TPASection';
var TPA_SECTION_DATA_TYPE = 'TPA';
var WIX_FORUM_APP_DEF_ID = '14724f35-6794-cd1a-0244-25fd138f9242';
var WIX_FORUM_APP_WIDGET_ID = '1489040e-001f-4631-55a9-2c29b4417126';
var MASTER_PAGE_ID = 'masterPage';

var STRETCHING_LAYOUT_DOCK_VALUE = { left: { vw: 0 }, right: { vw: 0 } };

function fixWixForumPagesLandingPageInMobileFlag(pageData, appData) {
    var widgetData = appData.widgets[WIX_FORUM_APP_WIDGET_ID];
    var isLandingPageInMobile = _.get(widgetData, 'appPage.landingPageInMobile');
    if (isLandingPageInMobile === true) {
        pageData.isMobileLandingPage = true;
    }
}

function fixTpaSectionPageLayoutMobileStretch(pageJson, appData) {
    var tpaSectionComponent = getFirstTPASectionInMobileStructure(pageJson);
    fixTPASectionLayoutIfWixForum(appData, tpaSectionComponent);
}

function fixTPASectionLayoutIfWixForum(appData, tpaSectionComp) {
    var shouldSetStretch = getStretchByDefaultInMobileFlag(appData);
    if (shouldSetStretch === true) {
        _.set(tpaSectionComp.layout, 'dock', STRETCHING_LAYOUT_DOCK_VALUE);
        if (tpaSectionComp.layout.y === 10) {
            tpaSectionComp.layout.y = 0;
        }
    }
}

function getFirstTPASectionInMobileStructure(pageJson) {
    var compsToScan = [].concat(_.get(pageJson, 'structure.mobileComponents'));
    while (compsToScan.length > 0) {
        var component = compsToScan.shift();
        if (component && component.componentType === TPA_SECTION_COMP_TYPE) {
            return component;
        } else if (component.components) {
            compsToScan = compsToScan.concat(component.components);
        }
    }
}

function getStretchByDefaultInMobileFlag(appData) {
    if (appData) {
        var widgetData = appData.widgets[WIX_FORUM_APP_WIDGET_ID];
        return _.get(widgetData, 'shouldBeStretchedByDefaultMobile');
    }
    return null;
}

function getForumApplicationId(clientSpecMap) {
    var appData = _.find(clientSpecMap, { appDefinitionId: WIX_FORUM_APP_DEF_ID });
    return _.get(appData, 'applicationId');
}

module.exports = {
    exec: function exec(pageJson, pageIdsArray, requestModel, currentUrl, urlFormatModel, isViewerMode, rendererModel, magicObject) {
        var pageData = void 0;
        var clientSpecMap = _.get(magicObject, 'clientSpecMap');
        var isExperimentOpen = magicObject.isExperimentOpen('sv_tpaSectionsMobileFSDataFixer');
        var forumApplicationId = getForumApplicationId(clientSpecMap);
        if (forumApplicationId && isExperimentOpen) {
            var appData = _.get(clientSpecMap, forumApplicationId);
            var pageId = _.get(pageJson, 'structure.id');
            if (pageId === MASTER_PAGE_ID) {
                var masterPageData = _.get(pageJson, 'data.document_data');
                pageData = _.find(masterPageData, { tpaApplicationId: forumApplicationId });
                if (pageData) {
                    fixWixForumPagesLandingPageInMobileFlag(pageData, appData);
                }
            } else {
                pageData = _.get(pageJson, ['data', 'document_data']);
                var tpaForumCompData = _.find(pageData, { applicationId: forumApplicationId.toString(),
                    type: TPA_SECTION_DATA_TYPE });

                if (tpaForumCompData) {
                    fixTpaSectionPageLayoutMobileStretch(pageJson, appData);
                }
            }
        }
    }
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

function fixProperties(properties) {
    _.forEach(properties, function (property) {
        if (property.type === 'WPhotoProperties' && property.effectName) {
            if (!property.filterEffect && property.effectName !== 'none') {
                property.filterEffect = {
                    effectType: property.effectName
                };
            }
            delete property.effectName;
        }
    });
}

module.exports = {
    exec: function exec(pageJson) {
        var properties = pageJson.data.component_properties;
        if (!_.isEmpty(properties)) {
            fixProperties(properties);
        }
    }
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var TINY_MENU_SKINS = ['wysiwyg.viewer.skins.mobile.TinyMenuSkin', 'wysiwyg.viewer.skins.mobile.TinyMenuFullScreenSkin', 'wysiwyg.viewer.skins.mobile.TinyMenuPullFromLeftSkin', 'wysiwyg.viewer.skins.mobile.TinyMenuPullFromTopSkin', 'wysiwyg.viewer.skins.mobile.TinyMenuPullFromRightSkin'];

var TINY_MENU_DEFAULT_SKIN = 'wysiwyg.viewer.skins.mobile.TinyMenuSkin';
var TINY_MENU_DEFAULT_STYLE_ID = 'tm2';

function hasValidSkin(tinyMenuComponent, themeData) {
    var styleSkin = _.get(themeData, [tinyMenuComponent.styleId, 'skin']);
    var structureSkin = tinyMenuComponent.skin;
    return styleSkin && structureSkin && _.includes(TINY_MENU_SKINS, styleSkin) && _.includes(TINY_MENU_SKINS, structureSkin);
}

function fixTinyMenuSkin(tinyMenuComponent) {
    tinyMenuComponent.skin = TINY_MENU_DEFAULT_SKIN;
    tinyMenuComponent.styleId = TINY_MENU_DEFAULT_STYLE_ID;
}

function findTinyMenuComponent(components) {
    var tinyMenuComponent = _.find(components, { id: 'TINY_MENU' });
    if (tinyMenuComponent) {
        return tinyMenuComponent;
    }
    _.forEach(components, function (component) {
        if (_.isEmpty(component.components)) {
            return;
        }
        tinyMenuComponent = findTinyMenuComponent(component.components);
        return !tinyMenuComponent;
    });
    return tinyMenuComponent;
}

/**
 * @exports utils/dataFixer/plugins/tinyMenuSkinFixer
 * @type {{exec: exec}}
 */
module.exports = {
    exec: function exec(pageJson) {
        var isMasterPage = _.get(pageJson, ['structure', 'id']) === 'masterPage';
        if (!isMasterPage) {
            return;
        }
        var tinyMenuComponent = findTinyMenuComponent(pageJson.structure.mobileComponents);
        if (tinyMenuComponent && !hasValidSkin(tinyMenuComponent, pageJson.data.theme_data)) {
            fixTinyMenuSkin(tinyMenuComponent);
        }
    }
};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _ = __webpack_require__(0);

var _require = __webpack_require__(1),
    vectorImageConversionUtils = _require.vectorImageConversionUtils;

var popupCloseButtonClassName = 'wysiwyg.viewer.components.PopupCloseIconButton';
var svgShapeClassName = 'wysiwyg.viewer.components.svgshape.SvgShape';
var compsToConvert = _defineProperty({}, svgShapeClassName, vectorImageConversionUtils.vectorImageDefaults);
var repeaterCompType = 'wysiwyg.viewer.components.Repeater';

var convertStyle = vectorImageConversionUtils.convertStyle;
var convertData = vectorImageConversionUtils.convertData;
var convertProperties = vectorImageConversionUtils.convertProperties;
var convertStructure = vectorImageConversionUtils.convertStructure;

function fixStyleItems(styles) {
    _.forEach(styles, function (style) {
        if (_.includes(style.skin, 'svgshape') && style.componentClassName !== popupCloseButtonClassName) {
            var compDef = compsToConvert[svgShapeClassName];
            convertStyle(style, compDef);
        }
    });
}

function fixShapesInRepeater(component, data, properties) {
    //get the repeater suffix names if exists
    var itemCompData = data[_.get(component, 'dataQuery', '').replace('#', '')];
    fixShapeComponents(component.components, data, properties, _.get(itemCompData, 'items'));
}

function fixShapeComponents(components, data, properties, repeaterDataItemsNames) {
    _.forEach(components, function (component) {
        if (component.components) {
            if (component.componentType === repeaterCompType) {
                fixShapesInRepeater(component, data, properties);
                //clear repeater dataItems names array
                repeaterDataItemsNames = [];
            }
            fixShapeComponents(component.components, data, properties, repeaterDataItemsNames);
        } else {
            var compDef = compsToConvert[component.componentType];
            if (compDef) {
                var svgId = component.skin;
                var propsQuery = _.get(component, 'propertyQuery', '').replace('#', '');
                var dataQuery = _.get(component, 'dataQuery', '').replace('#', '');

                if (!properties[propsQuery]) {
                    properties[propsQuery] = {};
                }

                var compData = data[dataQuery];
                var compProps = properties[propsQuery];

                convertStructure(component, compDef);
                convertData(compData, compDef, svgId);
                convertProperties(compProps, compDef);

                //Convert modes overrides
                _.forEach(_.get(component, ['modes', 'overrides']), function (override) {
                    //eslint-disable-line lodash/prefer-filter
                    if (override.propertyQuery) {
                        var overridePropsQuery = _.get(override, 'propertyQuery', '').replace('#', '');
                        if (!properties[overridePropsQuery]) {
                            properties[overridePropsQuery] = {};
                        }
                        var overrideProps = properties[overridePropsQuery];
                        convertProperties(overrideProps, compDef);
                    }
                });

                //get the repeater data items
                _.forEach(repeaterDataItemsNames, function (repeaterItemName) {
                    var itemCompData = data[_.get(component, 'dataQuery', '').replace('#', '') + '__' + repeaterItemName];
                    if (itemCompData) {
                        convertData(itemCompData, compDef, svgId);
                    }
                });
            }
        }
    });
}

module.exports = {
    exec: function exec(pageJson, pageIdsArray, requestModel, currentUrl, urlFormatModel, isViewerMode, rendererModel, magicObject) {
        if (magicObject.isExperimentOpen('se_vector_image')) {
            var styles = pageJson.data.theme_data;
            var data = pageJson.data.document_data;
            var properties = pageJson.data.component_properties;
            var components = pageJson.structure.components || pageJson.structure.children;
            var mobileComponents = pageJson.structure.mobileComponents;
            var repeaterDataItemsNames = [];
            if (!_.isEmpty(styles)) {
                fixStyleItems(styles);
            }

            if (!_.isEmpty(components)) {
                fixShapeComponents(components, data, properties, repeaterDataItemsNames);
            }

            if (!_.isEmpty(mobileComponents)) {
                fixShapeComponents(mobileComponents, data, properties, repeaterDataItemsNames);
            }
        }
    }
};

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);

var _require = __webpack_require__(1),
    vectorImageConversionUtils = _require.vectorImageConversionUtils;

var compsToConvert = {
    'wysiwyg.viewer.components.VectorImageArt': vectorImageConversionUtils.vectorImageDefaults,
    'wysiwyg.viewer.components.VectorImageShape': vectorImageConversionUtils.vectorImageDefaults
};

var convertStyle = vectorImageConversionUtils.convertStyle;
var convertStructure = vectorImageConversionUtils.convertStructure;

function fixStyleItems(styles) {
    _.forEach(styles, function (style) {
        var compDef = compsToConvert[style.componentClassName];
        if (compDef) {
            convertStyle(style, compDef);
        }
    });
}

function fixShapeComponents(components) {
    _.forEach(components, function (component) {
        var compDef = compsToConvert[component.componentType];
        if (compDef) {
            convertStructure(component, compDef);
        }
        if (component.components) {
            fixShapeComponents(component.components);
        }
    });
}

module.exports = {
    exec: function exec(pageJson /*, pageIdsArray, requestModel, currentUrl, urlFormatModel, isViewerMode, rendererModel*/) {
        var styles = pageJson.data.theme_data;
        var components = pageJson.structure.components || pageJson.structure.children;
        var mobileComponents = pageJson.structure.mobileComponents;
        if (!_.isEmpty(styles)) {
            fixStyleItems(styles);
        }

        if (!_.isEmpty(components)) {
            fixShapeComponents(components);
        }

        if (!_.isEmpty(mobileComponents)) {
            fixShapeComponents(mobileComponents);
        }
    }
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var CompsMigrationHelper = __webpack_require__(2);

var SEMI_NATIVE_STYLE_POSTFIX = '-semi';
var TPA_WIDGET = 'wysiwyg.viewer.components.tpapps.TPAWidget';

function getSemiNativeWidgetsIds(clientSpecMap) {
    return _(clientSpecMap).filter('appFields.platform').reduce(function (acc, entry) {
        return _(entry.widgets).pickBy(['componentFields.semiNative', true]).mapValues(_.constant(true)).assign(acc).value();
    }, {});
}

function addSemiNativeStyleForEveryTpaWidgetStyle(pageJson) {
    var newStyles = _(pageJson.data.theme_data).filter({
        componentClassName: 'wysiwyg.viewer.components.tpapps.TPAWidget',
        skin: 'wysiwyg.viewer.skins.TPAWidgetSkin'
    }).map(function (style) {
        var newStyle = _.cloneDeep(style);
        newStyle.componentClassName = 'platform.components.semiNativeComponent';
        newStyle.skin = 'wysiwyg.viewer.skins.semiNativeComponentSkin';
        return newStyle;
    }).transform(function (res, style) {
        res[style.id + SEMI_NATIVE_STYLE_POSTFIX] = style;
    }, {}).value();
    _.assign(pageJson.data.theme_data, newStyles);
}

function migrateTpaWidgetIfSemiNative(clientSpecMap, page, cache, mobileView, comp) {
    var semiNativeWidgetIds = getSemiNativeWidgetsIds(clientSpecMap);
    var data = this.getComponentData(page, comp);
    var shouldMigrateComp = comp.componentType === TPA_WIDGET && semiNativeWidgetIds[data.widgetId];

    if (shouldMigrateComp) {
        comp.componentType = 'platform.components.semiNativeComponent';
        comp.skin = 'wysiwyg.viewer.skins.semiNativeComponentSkin';
        comp.styleId += SEMI_NATIVE_STYLE_POSTFIX;

        this.setComponentData(page, comp, _.defaults({
            type: 'SemiNative'
        }, data), cache);
    }
}

module.exports = {
    /**
     * @exports utils/dataFixer/plugins/migrateWidgetsToControllers
     * @type {{exec: exec}}
     */
    exec: function exec(pageJson, pageIdsArray, requestModel, currentUrl, urlFormatModel, isViewerMode, rendererModel, magicObject) {
        var isMigrateTpaToSemiNativeOpen = magicObject.isExperimentOpen('sv_migrateTpaToSemiNative');
        if (isMigrateTpaToSemiNativeOpen && magicObject.isViewerMode) {
            if (pageJson.structure.id === 'masterPage') {
                addSemiNativeStyleForEveryTpaWidgetStyle(pageJson);
            }

            var MIGRATION_MAP = {
                'wysiwyg.viewer.components.tpapps.TPAWidget': _.partial(migrateTpaWidgetIfSemiNative, magicObject.clientSpecMap)
            };

            var migrationHelper = new CompsMigrationHelper(MIGRATION_MAP);
            migrationHelper.migratePage(pageJson);
        }
    }
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var CompsMigrationHelper = __webpack_require__(2);

function migrateGrid(pageJson, cache, isMobile, comp) {
    var gridData = pageJson.data.document_data[comp.dataQuery.slice(1)];
    var compsProps = pageJson.data.component_properties;
    var gridProps = compsProps[comp.propertyQuery];

    if (_.has(gridProps, 'dataSource')) {
        var migratingDataSource = {
            type: gridProps.dataSource.type,
            revision: gridProps.dataSource.id
        };
        delete gridProps.dataSource;
        var mobilePropsQuery = 'mobile_' + comp.propertyQuery;
        if (_.has(compsProps, mobilePropsQuery)) {
            delete compsProps[mobilePropsQuery].dataSource;
        }
        _.set(gridData, 'dataSource', migratingDataSource);
    }
}

module.exports = {
    exec: function exec(pageJson) {
        var MIGRATION_MAP = {
            'wysiwyg.viewer.components.Grid': migrateGrid
        };
        var migrationHelper = new CompsMigrationHelper(MIGRATION_MAP);
        migrationHelper.migratePage(pageJson);
    }
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var CompsMigrationHelper = __webpack_require__(2);

function patchColumn(pageJson, cache, mobileView, comp) {
    if (mobileView && _.startsWith(comp.designQuery, '#mobile_')) {
        this.deleteComponentDesignData(pageJson, comp);
        comp.designQuery = _.replace(comp.designQuery, 'mobile_', '');
    }
}

var MIGRATION_MAP = {
    'wysiwyg.viewer.components.Column': patchColumn
};

var migrationHelper = new CompsMigrationHelper(MIGRATION_MAP); // eslint-disable-line santa/no-module-state

module.exports = { exec: migrationHelper.migratePage.bind(migrationHelper) };

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CompsMigrationHelper = __webpack_require__(2);
var coreUtils = __webpack_require__(1);

function getEmptyBackground() {
    return {
        type: 'MediaContainerDesignData',
        id: coreUtils.guidUtils.getUniqueId('dataItem', '-'),
        background: {
            id: coreUtils.guidUtils.getUniqueId('dataItem', '-'),
            type: 'BackgroundMedia',
            mediaRef: null,
            alignType: 'center',
            fittingType: 'fill',
            colorOpacity: 0,
            colorOverlay: '',
            colorOverlayOpacity: 1,
            imageOverlay: '',
            scrollType: 'none',
            color: '#FFFFFF'
        }
    };
}

function handleNoDesignDataInColumns(pageJson, cache, mobileView, comp) {
    if (!comp.designQuery && !mobileView) {
        comp.layout.width = 980;
        var designDataWithEmptyBackground = getEmptyBackground();
        this.setComponentDesignData(pageJson, comp, designDataWithEmptyBackground, cache);
    }
}

var MIGRATION_MAP = {
    'wysiwyg.viewer.components.StripColumnsContainer': handleNoDesignDataInColumns,
    'wysiwyg.viewer.components.Column': handleNoDesignDataInColumns
};

var migrationHelper = new CompsMigrationHelper(MIGRATION_MAP); // eslint-disable-line santa/no-module-state

module.exports = { exec: migrationHelper.migratePage.bind(migrationHelper) };

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*eslint no-unused-vars:0*/


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);
var fixPageData = __webpack_require__(4);

function componentClass(compType) {
    switch (compType) {
        case 'wysiwyg.viewer.components.WSiteStructure':
            return 'Document';
        case 'mobile.core.components.Page':
            return 'Page';
        case 'wixapps.integration.components.Area':
        case 'mobile.core.components.Container':
        case 'wysiwyg.viewer.components.HeaderContainer':
        case 'wysiwyg.viewer.components.FooterContainer':
        case 'wysiwyg.viewer.components.PagesContainer':
        case 'wysiwyg.viewer.components.ScreenWidthContainer':
        case 'wysiwyg.viewer.components.StripContainer':
            return 'Container';
    }
    return 'Component';
}

function toInt(v) {
    return parseInt(v || 0, 10);
}

function tagStartHandler(siteModel, state, tagName, attrs, unary) {
    var attrsDict = _(attrs).map('name').invokeMap('toLowerCase').zipObject(_.map(attrs, 'value')).value();
    if (componentClass(attrsDict.comp) === 'Page') {
        state.page = attrsDict.id;
    }
    siteModel.pagesData[state.page] = siteModel.pagesData[state.page] || {
        structure: {},
        data: {},
        theme_data: {}
    };
    var structure = siteModel.pagesData[state.page].structure = siteModel.pagesData[state.page].structure || {};
    if (_.has(state.childrenIndex, state.page)) {
        for (var i = 0; i < state.childrenIndex[state.page].length; i++) {
            structure = structure.components[state.childrenIndex[state.page][i]];
        }
        var newStructure = {};
        state.childrenIndex[state.page].push(structure.components.length);
        structure.components.push(newStructure);
        structure = newStructure;
    } else {
        state.childrenIndex[state.page] = [];
    }
    structure.componentType = attrsDict.comp;
    structure.type = componentClass(attrsDict.comp);
    structure.id = attrsDict.id;
    structure.components = [];
    structure.skin = attrsDict.skin;
    structure.styleId = attrsDict.styleid;
    if (attrsDict.dataquery) {
        structure.dataQuery = attrsDict.dataquery;
    }
    structure.propertyQuery = attrsDict.propertyquery;
    structure.layout = {
        width: toInt(attrsDict.width),
        height: toInt(attrsDict.height),
        x: toInt(attrsDict.x),
        y: toInt(attrsDict.y),
        anchors: siteModel.wixAnchors[attrsDict.id] || []
    };
}

function tagEndHandler(siteModel, state, tagName) {
    if (state.childrenIndex[state.page].length === 0) {
        state.page = 'masterPage';
    } else {
        state.childrenIndex[state.page].pop();
    }
}

function migrateSiteModel(siteModel) {
    siteModel.pagesData = {};
    var mainPageData = _.get(siteModel, 'wixData.document_data.SITE_STRUCTURE.mainPage') || _.get(siteModel, 'wixData.document_data.masterPage.mainPage');
    var mainPageId = mainPageData && mainPageData.slice(1);

    siteModel.pagesData.masterPage = { data: siteModel.wixData };
    siteModel.pagesData.masterPage.structure = {};

    var state = { page: 'masterPage', childrenIndex: {} };

    coreUtils.htmlParser(siteModel.wixHtmlRaw, {
        start: tagStartHandler.bind(undefined, siteModel, state),
        end: tagEndHandler.bind(undefined, siteModel, state)
    });

    var pagesList = _.keys(siteModel.pagesData);
    var pagesListWithoutMaster = _.without(pagesList, 'masterPage');
    siteModel.pagesData.masterPage.data.document_data.MAIN_MENU = siteModel.pagesData.masterPage.data.document_data.MAIN_MENU || { items: [], type: 'Menu', id: 'MAIN_MENU', metaData: {} };

    _.forEach(pagesList, function (pageId) {
        siteModel.pagesData[pageId] = fixPageData(siteModel.pagesData[pageId], pagesListWithoutMaster, siteModel.requestModel, siteModel.currentUrl, siteModel.urlFormatModel);
    });
    siteModel.publicModel.pageList = {
        mainPageId: mainPageId,
        pages: _.map(pagesListWithoutMaster, function (pageId) {
            return _.chain(siteModel).get(['pagesData', 'masterPage', 'data', 'document_data', pageId]).pick(['title', 'pageUriSEO']).assign({ pageId: pageId }).value();
        })
    };
}

module.exports = migrateSiteModel;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _ = __webpack_require__(0);
var coreUtils = __webpack_require__(1);
var imageTransformDataFixers = __webpack_require__(3);

var imageClientApi = coreUtils.imageClientApi;

function fixBackgroundData(siteData) {
    var theme = siteData.getPageDataMap(siteData.MASTER_PAGE_ID, siteData.dataTypes.THEME);
    var data = siteData.getPageDataMap(siteData.MASTER_PAGE_ID, siteData.dataTypes.DATA);
    var bgIds = _(data).filter({ type: 'BackgroundImage' }).map('id').value();

    // New schema? do nothing
    if (isPagesBgNewSchema(data)) {
        return;
    }

    // If we have no pageBackground object in the mainPage data, migrate
    if (isBgOnlyInTheme(data)) {
        propagateBgToPages(theme, data);

        // else we have the old schema, migrate
    } else {
        _.forEach(bgIds, function (id) {
            getMigratedBgDataItem(data[id]);
        });
    }
}

/**
 * Check if a page has reference to background.
 * Assuming that if one page has no ref, all pages has no ref.
 * @param data
 * @returns {boolean}
 */
function isBgOnlyInTheme(data) {
    var page = _.find(data, { type: 'Page' });
    return !data[page.id].pageBackgrounds;
}

/**
 * Check if a page has reference to new data schema background.
 * Assuming that if one page has it, all pages has it.
 * @param data
 * @returns {boolean}
 */
function isPagesBgNewSchema(data) {
    var page = _.find(data, { type: 'Page' });
    return data[page.id].pageBackgrounds && data[page.id].pageBackgrounds.type === 'BackgroundMediaUnified';
}

/**
 * Convert theme bg string to new data structure ,inject data items to data and link it to all pages.
 * @param theme
 * @param data
 * @param pageIds
 */
function propagateBgToPages(theme, data) {
    var defaultBgFallbackString = 'none 0 0 center center auto repeat repeat scroll none';
    var pageIds = _(data).filter({ type: 'Page' }).map('id').value();

    //Migrate theme string to new data schema
    var bgString = theme.THEME_DATA.siteBg || defaultBgFallbackString;
    var mobileBgString = (theme.THEME_DATA.mobileBg === '[siteBg]' ? theme.THEME_DATA.siteBg : theme.THEME_DATA.mobileBg) || defaultBgFallbackString;
    var bgData = getMigratedBgString(bgString);
    var mobileBgData = getMigratedBgString(mobileBgString);

    // Generate bg data item ids
    bgData.id = 'customBgImg' + generateRandomId();
    mobileBgData.id = 'customBgImg' + generateRandomId([bgData.id]);

    //Add bg data items to site data.
    data[bgData.id] = bgData;
    data[mobileBgData.id] = mobileBgData;

    //Add a reference to bg to all pages.
    _.forEach(pageIds, function (id) {
        data[id].pageBackgrounds = {
            desktop: { custom: true, isPreset: false, ref: '#' + bgData.id },
            mobile: { custom: true, isPreset: false, ref: '#' + mobileBgData.id }
        };
    });
}

/**
 * Generate a random data id, based on html-client DataManager.addDataItemWithUniqueId
 * @param [excludes]
 * @returns {string}
 */
function generateRandomId(excludes) {
    var id = '';
    excludes = excludes || [];
    while (_.includes(excludes, id)) {
        id = _.random(0, 99999).toString(36).replace(' ', '_');
    }
    return id;
}

/**
 * Migrate Bg from theme string
 * @param bgString
 * @returns {*}
 */
function getMigratedBgString(bgString) {
    var bgArray = _.compact(bgString.split(' '));
    return getMigratedBg.apply(this, bgArray);
}

/**
 * HTML-Client background has some annoying fitting type combos, we need to support them.
 * @param fittingType
 * @returns {*}
 */
function getLegacyFittingTypes(fittingType) {
    // Legacy map for backgrounds from old editor.
    var legacyBgTypesMap = {};
    legacyBgTypesMap[imageClientApi.fittingTypes.TILE] = imageClientApi.fittingTypes.LEGACY_BG_FIT_AND_TILE;
    legacyBgTypesMap[imageClientApi.fittingTypes.TILE_HORIZONTAL] = imageClientApi.fittingTypes.LEGACY_BG_FIT_AND_TILE_HORIZONTAL;
    legacyBgTypesMap[imageClientApi.fittingTypes.TILE_VERTICAL] = imageClientApi.fittingTypes.LEGACY_BG_FIT_AND_TILE_VERTICAL;
    legacyBgTypesMap[imageClientApi.fittingTypes.ORIGINAL_SIZE] = imageClientApi.fittingTypes.LEGACY_BG_NORMAL;

    return legacyBgTypesMap[fittingType] || fittingType;
}

/**
 *
 * @param {string} imageId
 * @param {string} imageW
 * @param {string} imageH
 * @param {string} x
 * @param {string} y
 * @param {string} width
 * @param {string} repeatX
 * @param {string} repeatY
 * @param {string} attachment
 * @param {string} color
 * @param {{isHidden: boolean, isPreset: boolean, schemaVersion: number}} [metaData]
 * @returns {{type: string, alignType: string, fittingType: string, attachment: string, imageWidth: number, imageHeight: number, uri: string, color: string, metaData: {isHidden: (metaData.isHidden|boolean), isPreset: (metaData.isPreset|boolean), schemaVersion: number}}}
 */
function getMigratedBg(imageId, imageW, imageH, x, y, width, repeatX, repeatY, attachment, color, metaData, id) {
    var alignType = imageTransformDataFixers.cssToAlignType(x + ' ' + y);
    var fittingType = imageTransformDataFixers.cssToFittingType({ bgRepeat: repeatX + ' ' + repeatY, bgSize: width });
    fittingType = getLegacyFittingTypes(fittingType);

    metaData = metaData || {};
    //Be on the safe side
    if (!color || color === 'none') {
        color = 'rgba(0,0,0,0)';
    }

    return {
        type: 'BackgroundMediaUnified',
        alignType: alignType,
        fittingType: fittingType,
        attachment: attachment,
        imageWidth: Number(imageW),
        imageHeight: Number(imageH),
        mediaType: 'image',
        uri: imageId,
        color: color,
        metaData: { // TODO: HANDLE META DATA
            isHidden: metaData.isHidden || false,
            isPreset: metaData.isPreset || false,
            schemaVersion: 2.0
        },
        id: id
    };
}

function getMigratedBgDataItem(data) {
    var originalBgArray = [data.url, data.imagesizew, data.imagesizeh, data.positionx, data.positiony, data.width, data.repeatx, data.repeaty, data.attachment, data.color, data.metaData, data.id];

    return getMigratedBg.apply(this, originalBgArray);
}

module.exports = {
    fixBackgroundData: fixBackgroundData,
    migrateBgDataItem: getMigratedBgDataItem,
    migrateBgString: getMigratedBgString
};

/***/ })
/******/ ])});;


// WEBPACK FOOTER //
// santa-data-fixer.js